// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {font-family: Poppins !important;padding-top: 77px;text-align: justify;}

.searchResult{z-index: 11111; position: absolute; max-height:200px;  overflow-x: hidden; padding: 0px 0px 20px 0px;
    background-color: #fff; width: 93%; color: #302ba0; cursor: default; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
.searchResult ul {list-style: none; padding: 0px 10px 20px 13px;}
.searchResult ul a {list-style: none; font-size:13px; line-height: 30px; 
    color:#70757a; text-decoration: none;  }

    .whats-app h1{display: inline; color: #302ba0; padding: 0px 0px 0px 20px;}

.whats-app2 h3 {color: #302ba0; text-align: center; font-size:20px; display: inline;}
.whats-app2 h3 span{color: #000;}
.whats-app2{display: table; margin: 0px auto; }
.whats-app2 img{width:270px; height: 250px;}
.whats1{width:250px !important; height:80px !important; display: inline;}

.searchResult ul a:hover{text-decoration: none; color: #000;}
.ser-log1{background: #302ba0 !important;
    color: #fff !important;}

.scroolMessage {
    height: 25px;	
    overflow: hidden;
    position: relative;
   }
   .scroolMessage span {
    white-space: nowrap;
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    line-height: 25px;
    text-align: center;
    /* Starting position */	
    transform:translateX(100%);
    /* Apply animation to this element */
    animation: scroolMessage 320s linear infinite;
   }
   /* Move it (define the animation) */
   @keyframes scroolMessage {
    0%   { /* Firefox bug fix */ /* Firefox bug fix */
    transform: translateX(100%); 		
    }
    100% { /* Firefox bug fix */ /* Firefox bug fix */
    transform: translateX(-500%); 
    }
   }
   .scroolMessage span:hover {
    animation-play-state: paused;
    }
.width-30{max-width:25% !important;}
.width-30 .nav-link{font-size: 12px;}
.swap-div{display:flex;}

.quick_links .btn-link .fontSizeClass ,
.quick_links a{color: #007bff !important;text-decoration: none;
    background-color: transparent !important;font-size: 12px !important;padding: 0 !important;}
.quick_links .card-header{background: transparent;} 
.marquee-vertical{animation: moveSlideshow 300s linear infinite;}
.marquee-vertical:hover{
    animation-play-state: paused;}
@keyframes moveSlideshow {100% {  transform: translateY(-66.6666%); }}
.site-menu .card-header{background-color: #fff !important;}
.p-0{padding: 0px 10px !important;}
.drop-footer .dropdown-item{color: rgba(var(--color-white-rgb), 0.7); transition: 0.3s; display: inline-block;line-height: 1;}
.para_text p {text-align: justify !important;}
.min-height-800{height: 800px !important; overflow: scroll;overflow-x: hidden; }
.f-11{font-size: 11px !important;font-weight: 500 !important;}
.border_bottom{border-bottom: 1px solid #727272 !important;}
.nav-item.nav_dropdown,
.nav-item-list.nav_dropdown{ color: #302ba0 !important;list-style: disc;}
#accordion .card-body .card-body {font-size: 13px; padding: 0px ; padding-bottom: 0px;}
.nav_dropdown .nav_dropdown .card-body a{font-size: 10px !important;line-height: 30px;}
.nav_dropdown .card-header.responsiveheader {background-color: #fff !important;font-size: 13px;}

.nav_dropdown .responsivemenudiv{background-color: #fff;}
.nav_dropdown #accordion .card { border: 0; margin: 0px;}
.nav_dropdown .nav-link{font-size: 17px !important;line-height: 20px;padding: 5px 5px 0px 0px; border-bottom: none !important; 
text-decoration: none;}
.nav_dropdown .responsiveheader .btn-link fontSizeClass,
.nav_dropdown .responsiveheader .btn-link fontSizeClass :hover{color: #302ba0 !important;padding: .5rem 0rem; font-weight: 500 !important; list-style-type: disc;
    font-size: 13px !important; background-color: #fff !important;}
.nav_dropdown .responsiveheader .btn-link fontSizeClass :focus{text-decoration: none; box-shadow:none;}
.bi-chevron-down::before {content: "\\f282";color: #302ba0 !important; }
.banner-container{height:200px; margin-top: 39px;}
.min-height-400{height: 300px !important;overflow: scroll !important;overflow-x: hidden !important;}
.section-main-heading2 h4{display: none;}
.card .card-header h5{    padding: 0 !important;
    font-size: 13px !important;
    background: #fff !important;
    line-height: 0px !important;
    margin: 0px !important;
}
.Schedule_Of_Fees{height: 400px; overflow: scroll;overflow-x: hidden;}
.menuList ul li{
    list-style-type: none;
}
.menuList ul{
    padding: 0;
}
.mbl-login{
    display: none;
}

.text_english{
    font-size:19px
  }
  .text_bengali{
    font-size: 23px 
  }

main {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: 50%;
}

.header {
    padding: 0px;
    /* z-index: -30 !important; */
}

.row {
    padding: 0px;
}

.header1 {
    float: left;
    width: 100%;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    padding: 5px 0px 8px 0px;
    background: #302ba0;
    background: -moz-linear-gradient(top, #f6f6fe 0%, #ffffff 100%);
    height: auto;
    line-height: 20px;
}

.header .logo img {
    position: relative;
    margin: 1px 0px 0px 0px;
    margin-right: 0px;
    max-height: inherit;
    width: 48px;
}

.header2 {
    background-color: rgba(0, 0, 0, 0.8);
    display: inline-block;
    width: 100%;
    padding: 2px 0px;
}

.lg span {
    display: inline-block;
    color: #fff;
    padding: 3px 0px 4px 10px;
    font-weight: bold;
    font-size: 22px;
    position: relative;
    top: 7px;
}
 /* new css  */
.arrow_icon{
margin-left: 8px;
 }
 .heading-1{
padding: 0px;
 }
 .head-part1{
align-items: center;
 }
 .message_board-card{
margin-top: 0px !important;
 }
/* p */

/* Define the initial state of the element */
.vertical-animation {
    opacity: 0; /* Start with opacity set to 0 */
    /* transform: translateY(20px); Move the element 20px down */
  }
  
  /* Apply the AOS animation class */
  [data-aos="fade-up"] {
    animation-name: fadeUp;
    animation-timing-function: ease-in-out; /* Specify timing function */
    animation-delay: 50000s !important; /* Specify animation delay, if needed */
    animation-iteration-count: 10; /* Specify the number of times the animation should run */
  }
  
  /* Define the keyframes for the animation */
  @keyframes fadeUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  

.navbar-fixed{
    background-color:rgba(0,0,0,0.7);
    position: fixed;
    top:77px;
    width: 100% !important;
    z-index: 999;
    padding: 0px 10px;
}

/* .hero2 .carousel-item img{
height: 120px;
} */
.navbar-fixed2{
    background-color: #0d0d0e;
    opacity: 0.9;
    height: 40px;
    position: fixed;
    top:77px;
    width: 100% !important;
    z-index: 999;
    padding: 0px 10px;
}
.NavBar_container{
display: none;
}
.nav-scroll-link{
    font-size: 13px;
    color: white;
    text-decoration: none;
    text-transform: uppercase;
}
.nav-scroll-link:hover{
    font-size: 13px;
    color: white;
    font-weight: bold;
}

/* .carousel-item-img{
  height: 220px;
  max-height: 500px;
} */

.carousel-caption {
    bottom: 60px !important;
    top: 48% !important;
    padding-bottom: 0px !important;
    
}

.Banner{
    position: relative;
}

.list-aggregate{
padding-left: 0px !important;
}


.lg p {
    color: #fff;
    padding: 7px 0px 0px 10px;
    font-weight: bold;
    margin: 0px;font-size: 18px;
}
.font-site-mbl{
display: none;
}
.language-mbl{
    display: none;
 }
 .language_dropdown{
    font-weight: 600;
    color: #fff;
    font-size: 13px;
    padding: 4px 10px !important;
    box-shadow: none;
    background-color: transparent !important;
    border: none !important;
 }
 .language .dropdown-toggle {
    border-radius: 4px !important;
    color: #ffde;
    padding: 4px 20px !important;
    box-shadow: none;

}
.search {
    margin: 17px 0px 0px 0px;
    width: 100%;
}

.head-part1 {
    margin: 17px 0px 0px 0px; float: right;}

.head-part1 .lang-set{
    width: 100px;
}
.head-part1 .lang-set .language{
    font-size: 13px; 
    background:#302ba0;
    z-index: 1111;
    font-size: 13px;
    color: #fff; 
    border: none; font-weight: bold;
}



.head-part1 select:focus-visible {outline:inherit}


.header2 .navbar a {
    padding: 14px 15px;
    color: #f6f6fe;
}

.search .input-group {
    width: 100%;
}

.search input {
    font-size: 13px;
    font-weight: normal;
    color: #ffffff;
    background-color: #4b46ac;
    border: none;
    padding-left: 14px;
    border-radius: 0 !important;
    height: 38px; width: 100%;
}

.search input:focus-visible{ outline: inherit;}

.search button {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-radius: 5px;
    border: none;
}

.search button:hover {
    border: none;
    background: none;
}

.search .input-group button i {
    font-weight: bolder !important;
    color: #c6c4e5;
}

.login-1 {
    margin: 0px 0px 0px 0px;
}

.login-1 .dropdown-toggle::after {
    display: none;
}

.login-1 .dropdown-toggle { color: #ffde; }

.login-1 .btn-secondary {
    background:none;
    color: #fff;
    font-weight: 600;
    padding:3px 10px;
    border: none;
}

.login-1 .btn-secondary:focus {
    border: none;
    box-shadow: none; background:none; border-radius:none;
    color: #302ba0;
    font-weight: 600;
   
}
.btn-secondary:hover {
    color: #fff !important;
    background-color: #302ba0 !important;
    border-color: #302ba0 !important;
}
.login-1 .dropdown-toggle:hover{color: #fff;}


.about .about-img img { height: 150px;}

.faq .accordion span img {
    width:30px;
}

.faq .accordion-button,
.accordion button {
    font-size: 12px;
    padding: 15px 20px 15px 20px;
    width: 100%;
    font-weight: 600;
    color: var(--color-default);
    text-align: left;
    background: var(--color-white);
    box-shadow: 0px 5px 25px 0px rgba(var(--color-black-rgb), 0.06);
    border-radius: 5px;
}
.faq .accordion-button:focus {box-shadow:none; }

.faq .content h3 {
    font-size: 24px;
}

.service-item .img img {
    height: 105px;
    width: 100%;
}

.portfolio .portfolio-item img {
    height: 100px;
    border-radius: 5px;
    width: 100%;
}

.portfolio2 .portfolio-item img {
    height: 160px;
    border-radius: 5px;
    width: 90%;
}

.portfolio .portfolio-item .portfolio-info .details-a {
    right: 65px;
}

.portfolio .portfolio-item .portfolio-info .preview-a {
    right: 100px;
    top: calc(-12% - 14px);
}

.portfolio .portfolio-item .portfolio-info .details-a {
    right: 60px;
    top: calc(-12% - 14px);
}

.portfolio-item {
    margin: 5px 0px 5px 0px;
}


.hero2 {
    height: 115px !important;
}
.col-lg-12.about-img2{padding: 0;}
.hero { min-height: 0;}


.inner-pad1 {
    padding: 25px 0px 25px 0px;
}

.section-main-heading2 {
    position: absolute;
    /* z-index: 111; */
    bottom: 25px;
}

.section-main-heading2 h4 {
    color: #fff;
    font-weight: normal;
    font-size: 15px;
}

.about-head1 h4 {
    padding: 10px;
    font-size: 15px;
    background: #F2F2F2;
    line-height: 25px;
}

.about-img2 img {
    width: 160px;
    height: 100px;
    border-radius: 5px;
    float: left;
    margin: 0px 20px 0px 0px;
}

.about-img2 p {
    font-size: 13px;
    line-height: 25px;
    color: #000;
    padding: 10px 0px 0px 0px;
}

.about-head1 h5 {
    padding: 4px 0px;
    font-size: 13px;
    /* background: #F2F2F2; */
    line-height: 25px;
    margin: 10px 0px 0px 0px;
}

.about-head1 p {
    padding: 5px 0px 0px 0px;
    font-size: 13px;
}

.about-head2 {
    height: 300px;
    overflow-y: scroll;
    margin: 50px 0px;
}
.responsiveheader .btn-link fontSizeClass ,
.nav-item-list.homebtn {
    color: #fff !important;
    background: none !important;
    width: 100%;
}

.card-header .btn-link fontSizeClass ,
.nav-item-list.homebtn {
    
    border: 0;
    color: #302ba0;
    text-align: left;
    box-shadow: none;
    border-radius: 5px;
    padding: 10px ;
    font-size: 13px;
}

.about-head2 p {
    padding: 5px 0px 0px 0px;
    font-size: 13px;
    line-height: 23px;
}

.inner-title h3 {
    font-size: 22px;
    text-transform: uppercase;
    padding: 0px 0px 10px 0px;
    color: #302ba0;
}

.inner-title2 h3 {
    font-size: 22px;
    text-transform: uppercase;
    padding: 0px 0px 0px 0px;
    color: #302ba0;
}



button.btn.btn-secondary.dropdown-toggle.user,
button.btn.btn-secondary.dropdown-toggle.user.show {
    border-radius: 30px;
    color: #ffde;
    padding: 8px 13px;
    outline: none;
    box-shadow: none;
    border: none;
}

button#dropdownMenuButton1 i {
    color: #ffde00;
}

.margin-128 {
    margin-top: 128px;
}

.jss368 {
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
}

.jss368:last-child {
    padding-bottom: 24px;
}

.jss332 {
    height: 56px;
    padding: 2px 4px;
    display: flex;
    box-shadow: 0px 2px rgb(0 0 0 / 23%);
    align-items: center;
    border-radius: 28px;
    background-color: #fff;
    width: 100%;
}

.jss333 {
    flex: 1 1;
    font-size: 16px;
    margin-left: 8px;
}

.home-search-input-style {
    border-radius: 28 !important;
    z-index: 1100;
    top: -22px;
}

.about-head1{width:100%}
.more-menu a{font-weight: 500 !important;
    font-size: 13px !important;
    color: #302ba0 !important;
    border-bottom: 1px solid #E5E9EF !important;
    list-style: disc;
    display: inherit;
    list-style-position: inside;height: 300px; overflow: scroll;}
.more-menu {height: 300px; overflow: scroll;}
.card{box-shadow:none; border:none !important;}
.show_responsive,
.responsive_menu{display: none;}
.responsivemenudiv { max-height: 150px;overflow: scroll; overflow-x: hidden; }
.card-body .card-body{margin-left: 20px;}
.responsivemenudiv a,
.responsivemenudiv option,
.responsivemenudiv .responsiveheader .btn-link fontSizeClass { padding: 0px 10px;font-size: 11px !important;line-height: 28px; color: #fff !important; list-style: disc; display: inherit; list-style-position: inside;}
.responsiveheader .responsiveheader .btn-link fontSizeClass { padding: 0px 10px;font-size: 11px !important;line-height: 28px; color: #302ba0 !important; list-style: disc; display: inherit; list-style-position: inside;}

.responsiveheader .btn-link fontSizeClass :hover {
    border: 0;
    color: #fff;
    text-decoration: none;
    
    background: #302ba0;
    box-shadow: none;
   
 
}
.responsiveheader{ display: flex; justify-content: space-between; padding: 0px 10px 0px 0px !important;}
.mayor-table.Heritage_Conservation_Architect{height: 460px;}



.rainmaker-card {
    color: #5f5c62;
    background-color: white;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    box-sizing: border-box;
    font-family: Poppins !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    border-radius: 3px;
    z-index: 1;
    margin: 16px 0px;
    padding: 12px 8px;
}

.service-item {
    padding: 0px !important;
    margin: 10px 0px 10px 0px;
}


/* Nav bar style css start */  

 .NavBar_container{
    margin-top: 83px;
} 

.react-multi-carousel-list {
    position: unset !important;
    
}

.NavBar_container--navbar{
    display: none;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    position: sticky;
    top: 0;
    /* z-index: 20; */
  }


  .nav_container--item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* height: 80px; */
    max-width: 1500px;
  }



  .main-container{
    content: '';
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background-color:rgba(0,0,0,0.4);
  }
  
  
  .nav-menu {
    display: flex;
    list-style: none;
    text-align: center;
    margin-right: 2rem;
    margin-bottom: 0px;
    width: 100%;
    overflow: hidden;
    justify-content: space-evenly;
  }

  .nav-links {
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    height: 100%;
    border-bottom: 3px solid transparent;
    text-align: center !important;
    font-size: 11px;
    color: #fff !important;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .fa-code {
    margin-left: 1rem;
  }
  
  /* .nav-item-list {
    line-height: 40px;
  } */
  .nav-item-list {
    line-height: 19px;
}
  
  .nav-item-list:after {
    content: "";
    display: block;
    height: 3px;
    width: 0;
    background: transparent;
    transition: width 0.7s ease, background-color 0.5s ease;
  }
  
  
  
  .nav-icon {
    display: none;
  }
  
 
  



/* Nav bar style css end */



.service-item .details h3 span {
    color: #302ba0;
}

.service-item .details {
    height: auto !important;
    padding: 11px 10px;
    margin: -33px 30px 0 30px;
    transition: all ease-in-out 0.3s;
    position: relative;
    background: rgba(var(--color-white-rgb), 0.9);
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);
}

.service-list {
    padding-top: 0px;
    padding-bottom: 0px;
}

.upper-row {
    margin-bottom: 30px;
}

.service-icon {
    width: 35px !important;
    fill: rgba(239, 214, 47, 1) !important;
    overflow: visible !important;
    height: 35px !important;
}

.module-page-icon {
    height: 30px;
    width: 30px;
    color: #fe7a51;
}

.card-content-style {
    padding: 0 !important;
}

.service-label-cont .label-text {
    word-break: inherit;
    word-wrap: inherit;
    font-size: 16px !important;
    font-weight: 600;
}

.jss1 {
    top: 75px;
    height: 56px;
    padding: 2px 4px;
    z-index: 1100;
    display: flex;
    position: fixed;
    box-shadow: 0px 2px rgb(0 0 0 / 23%);
    align-items: center;
    border-radius: 28px;
    background-color: #fff;
}

.label-container {
    display: block;
}

.jss9 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.jss3 {
    width: 10%;
    padding: 1%;
    flex-grow: 1;
}

.jss10 {
    margin: 0;
    box-sizing: border-box;
}

.jss6 {
    height: 90px;
    cursor: pointer;
    display: flex;
    margin-top: 0;
    align-items: center;
    border-radius: 0;
    justify-content: center;
}

.jss113 {
    overflow: hidden;
}

.jss117 {
    box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%);
}

.jss115 {
    border-radius: 4px;
}

.jss114 {
    background-color: #fff;
}

.jss57 {
    flex-grow: 0;
    max-width: 50%;
    flex-basis: 50%;
}

.jss43 {
    flex-grow: 0;
    max-width: 50%;
    flex-basis: 50%;
}

.jss10 {
    margin: 0;
    box-sizing: border-box;
}

.rainmaker-card {
    color: #5f5c62;
    background-color: #fff;
    transition: all .45s cubic-bezier(.23, 1, .32, 1) 0ms;
    box-sizing: border-box;
    font-family: Poppins !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-shadow: 0 1px 6px rgb(0 0 0 / 12%), 0 1px 4px rgb(0 0 0 / 12%);
    border-radius: 3px;
    z-index: 1;
    margin: 16px 0;
    padding: 12px 8px;
}

.local-information-cont {
    background-color: #fff;
    padding: 16px;
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-1 .dropdown-item {
    font-size: 13px;
    color: #fff;
    line-height: 26px;
}

.login-1 .show>.btn-secondary.dropdown-toggle:focus{box-shadow: none;}
.login-1 .btn-secondary:not(:disabled):not(.disabled):active:focus{box-shadow: none;}
.login-1 .btn-secondary:not(:disabled):not(.disabled):active{background: none; border: none;}
.language_dropdown:focus-visible {    box-shadow: none !important;
    background-color: transparent !important;
    border: none !important; outline: none;}


.show>.btn-secondary.dropdown-toggle {background-color:none; border-color:none !important; }
.basic_static_table{margin: 0 !important;}

.login-1 .dropdown-menu {
    background: #090253;
    min-width: 110px !important;
    z-index: 1111;
}

/* .login-1 .dropdown-item:hover {
    background: #000;
    color: #fff;
} */

.login-1 .dropdown-item:active {
    background: #000;
    color: #fff;
}



.language .dropdown-toggle::after {
    display: none;
}

.language .dropdown-toggle {
    border-radius: 30px;
    color: #ffde;
    padding: 6px 20px;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.language .btn-secondary {
    background: transparent;
    color: #ffffff;
    font-size: 13px;
    border: none;
}

.language .btn-secondary:focus {
    border: none;
    box-shadow: none;
    background-color: transparent;
}

.language .dropdown-item {
    font-size: 13px;
    color: #090253;
    line-height: 26px;
}

.language .dropdown-menu {
    background: #fff;
    min-width: 7rem;
}

.language .dropdown-item:hover {
    color: #090253;
}

.language .dropdown-item:active {
    color: #090253;
}

/* 12/28/2022 css */
.form-select option{
    color: #fff !important;
    font-size: 13px;
    padding:8px 10px !important; border: 1px solid rgba(0,0,0,.15);
    border-radius: 0.25rem;
    background: #090253; min-width: 110px !important;    z-index: 1000;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;    text-align: left;
    list-style: none;position: absolute;
    transform: translate3d(2px, 28px, 0px);
    top: 0px;
    left: 0px;
}


.font-site {font-size: 14px;
    text-transform: uppercase;
    color: #090253;
    padding: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95px;
    margin: 4px 0px 0px 0px;}
    .text-large:hover{
color: #fff;
    }

.hero .carousel-item .text-left ul {
    list-style: none;
    padding: 10px 0px;
    margin: 0px;
}

.hero .carousel-item .text-left ul li {
    list-style: none;
    padding: 20px 0px;
    margin: 0px;
    color: #070152;
    font-size: 19px;
    font-weight: 600;
}

.hero .carousel-item .text-left ul li i {
    font-weight: bolder;
}

.scrool-message {
    width: 100%;
    padding: 6px 10px;
    background-color: #fff085;
    display: inline-block;
    font-size: 12px;
    color: #000;
    font-weight: 600;
}

.scrool-message marquee p {
    margin: 0px;
    padding: 0px;
}

.hero {
    padding: 0px;
}

.hero .img {
    margin-bottom: 0px;
}

.about h3 {
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
}

section {
    padding: 10px 0;
}

.about .tab-content h4 {
    font-size: 14px;
}

.about .tab-content p {
    font-size: 13px;
}

.about h3 {
    margin-bottom: 0px;
}

.about .nav-a {
    font-size: 15px;
}

.about .tab-content p {
    margin: 0px 0px 8px 0px;
    text-align: justify;
}

.about .tab-content p span {
    margin: 10px 0px 0px 0px;
    color: #0541af;
}

.whats-new {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
    border-radius: 10px;
    padding: 0px 0px 6px 0px;
    height: auto;
}

.section-bg3 {
    background-color: #fff;
    width: 100%;
    display: inline-block;
    height: auto;
}

.section-title h4 {
    padding: 15px 0px 5px 30px;
    text-align: left;
    font-size: 20px;
}

.title2 h4 {
    padding: 20px 0px 10px 24px;
    text-align: left;
    font-size: 16px;
}

.body1-left-side {
    width: 100%;
    height: auto;
    margin: 0px 0px 0px 0px;
}

.block-hdnews {
    margin: 5px auto;
}

.title3 .list-wrpaaer {
    height: 250px
}

.list-wrpaaer {
    height: 325px
}

.list-wrpaaer ul {
    margin: 0px;
}

.list-wrpaaer ul li {
    list-style: none;
    padding: 4px 10px;
    display: inline-block;
    width: 100%;
}

.list-aggregate li {
    border-bottom-color: #e5e5e5;
    display: flex !important;
justify-content: center;
align-items: center;
}

.list-aggregate li a {
    color: #056db1;
}

.list-aggregate li a {
    color: #686666;
    padding: 0px 0px 0px 0px;
    margin: 0px;
    text-align: left;
    font-size: 12px;
    line-height: 17px;
}

.list-aggregate li:hover {
    background-color: rgba(36, 1, 77, 0.1);
}

.policy-img2 {
    width: 55px;
    height: 54px;
    border-radius: 50%;
    background-color: #302ba0;
    display: inline-block;
}

.policy-img2 h4 {
    font-size: 14px;
    line-height: 2px;
    color: #fff;
    margin: 0px;
    padding: 18px 0px 0px 0px;
}

.policy-img2 span {
    font-size: 8px;
    color: #fff;
}

.list-aggregate {
    left: -41px !important;
}

.buy-policy-2 {
    text-align: left;
    float: right;
    width: 80%;
    padding: 0px 15px;
}

.section-title h3 {
    padding: 15px 0px;
    font-size: 1.2rem;
}

.imp-a h2 {
    text-align: left;
    padding: 23px 0px 0px 0px;
    font-weight: normal;
    margin: 0px;
}

.download1 {
    display: inline-block;
    width: 100%;
}

.download1 .d1-icon {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    text-align: center;
    background: #050048;
    margin: 0px auto;
}

.download1 .d1-icon img {
    margin: 16px auto 0px auto;
}

.download1 h3 {
    text-align: center;
    color: #000;
    font-weight: bold;
    line-height: 26px;
    font-size: 13px;
    height: 52px;
}

.download1 a {
    text-align: center;
    color: #fff;
    font-size: 12px;
    background: #050048;
    padding: 6px 14px;
    letter-spacing: 1px;
    border-radius: 20px;
}

.download1 {
    margin: 20px 0px 0px 0px;
}

.download1 a:hover {
    transition: all ease-in-out 0.4s;
    background: #ffde00;
    color: #000;
}

.faq .accordion-body {
    font-size: 13px;
}

.more {
    margin: 30px auto 10px auto;
    text-align: center;
}

.more a {
    width: 65px;
    height: 65px;
    color: #ffde00;
    background: #050048;
    font-size: 30px;
    border-radius: 50%;
    display: inline-block;
    padding: 6px 0px 0px 0px;
    border: 5px solid;
    transition: all ease-in-out 0.4s;
}

.more a:hover {
    background: #ffde00;
    color: #000;
}

.import {
    padding-bottom: 30px;
}

.carousel-control-next-icon,.visually-hidden,.carousel-control-prev-icon{
    display: none !important;
}

.import .count-box {
    box-shadow: 0px 0 16px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background: #fff;
    margin-bottom: 30px;
    border-radius: 5px;
    display: inline-block;
    width: 100%;
    height: 185px;
}

.import .count-box2 {
    box-shadow: 0px 0 16px rgba(0, 0, 0, 0.1);
    padding: 10px 0px 0px 0px;
    background: #0579c6;
    margin-bottom: 30px;
    border-radius: 5px;
    height: 60px;
    text-align: center;
    transition: all ease-in-out 0.4s;
}

.import .count-box2 h4 {
    font-size: 14px;
    color: #fff;
    font-weight: normal;
    line-height: 33px;
}

.import .count-box2 h3 {
    font-size: 14px;
    color: #fff;
    font-weight: normal;
    line-height: 20px;
}

.import .count-box i {
    display: block;
    font-size: 64px;
    margin-bottom: 15px;
}

.import .count-box span {
    font-size: 42px;
    display: block;
    font-weight: 700;
    color: #1c5c93;
}

.import .count-box p {
    padding: 0;
    margin: 0;
    font-size: 14px;
}

.import .count-box2:hover {
    background-color: #000;
    transition: all ease-in-out 0.4s;
}

.footer-as p span {
    line-height: 26px;
    font-size: 13px;
}

.footer-newsletter p a {
    font-size: 14px;
    color: #000;
    padding: 10px 15px;
    text-align: center;
    margin: 20px 0px 0px 0px;
    background: #ffde00;
    display: inline-block;
}

.footer .footer-legal .credits a {
    color: #ffde00;
}

.footer .footer-content .footer-newsletter form input[type=submit]:hover {
    background: #302ba0;
    color: #fff;
}

.scrool-margin {
    margin-top: 170px;
}

.site-menu {
    background: #fff;
    color: #090253;
    font-size: 13px;
    margin: 10px 0px 10px 0px;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}
.site-menu2 {
    background: #fff;
    color: #090253;
    font-size: 13px;
    margin: 10px 0px;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}
.site-menu nav ul li .btn .bi-chevron-down::before{color: #302ba0 !important; padding: 0px 5px;}
/*.site-menu nav ul li a,
.site-menu nav ul li .btn {
    font-weight: 500 !important;
    font-size: 12px ;
    color: #302ba0 !important;
    border-bottom: 1px solid #E5E9EF !important;
    width: 100%; margin-left: 0px;
    display: inherit; text-align: left;
}*/
.site-menu nav ul li a,
.site-menu nav ul li .btn {
    font-weight: 500 !important;
    font-size: 11px ;
    color: #302ba0 !important;
    border-bottom: 1px solid #E5E9EF !important;
    width: 100%; 
    display: inline-block; 
    text-align: left;
    padding: 7px 15px;
}



.sidebar li .submenu li a {
    font-size: 11px !important;
}

.site-menu nav ul a.active1 {
    color: #0d6efd !important;
    background: rgba(229, 233, 239, 0.5);
}


.site-menu nav ul li a i::before {
    font-size: 15px;
    font-weight: bold !important;
}

.site-menu nav ul li a:hover,
.site-menu nav ul li a:focus-visible {
    color: #0d6efd !important; border: none; }

.sidebar li .submenu {
    list-style: none;
    margin: 0;
    padding: 0;
    padding-left: 1rem;
    padding-right: 1rem;
}

.sidebar .nav-a {
    font-weight: 500;
}



.certificate1 p {
    font-size: 13px;
    text-align: justify;
    line-height: 33px;
    padding: 10px 0px 0px 0px;
}

.certificate1 h4 {
    color: #090253;
}

.certificate1 h6 {
    padding: 10px 0px 0px 0px;
}

.certificate1 p span a {
    color: #0d6efd;
}

.certificate1 ul li {
    list-style: none;
}

.certificate1 ul li a {
    font-size: 11px;
    text-align: left;
    line-height: 20px;
    padding:4px 10px;
    color: #090253;
    font-weight: bold;
    width: 100%;
    background: #fff;
    border: 1px solid #E5E9EF !important;
    display: inline-block;
    margin: 2px 0px 2px 0px;text-decoration: none;
}

.certificate1 ul li a:hover {
    color: #fff;
    background: #302ba0;
}



.application1 {
    width: 100%;
    float: left;
    height: auto;
    background: rgba(255, 255, 255, 0.5);
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
    box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
    margin: 20px 0px 20px 0px;
}

.application1 h4 {
    background-color: rgba(114, 124, 245);
    opacity: 1;
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
    padding: 30px 20px;
    color: #fff;
    font-size: 23px;
    text-align: center;
}

.application1 .form1 {
    padding: 10px 20px;
}

.application1 .form1 .form-group {
    color: #000;
    margin: 0px 0px 20px 0px;
}

.application1 .form1 .form-group span {
    color: #FF0000;
}

.application1 .form1 .form-group select {
    font-size: 14px;
    padding: 10px 20px;
}

.application1 .form1 .form-group input {
    font-size: 14px;
    padding: 10px 20px;
}

.application1 .form1 .form-group .form-check-input {
    padding: 8px !important;
}

.application1 .form1 .form-titel-1 h5 {
    font-size: 22px;
    color: #090253;
    padding: 10px 0px;
}

.application1 .form1 .form-titel-1 h6 {
    font-size: 20px;
    color: #090253;
    padding: 10px
}

.application1 .form1 .form-group .form-check {
    display: inline-block;
}

.application1 .form1 .form-group .form-check label {
    padding: 0px 0px 0px 10px;
}

.styling {
    background: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 20px;
    text-align: center;
}

.certificate1 h3 {
    font-size: 24px;
    padding: 10px 0px;
}

.certificate1 ul {
    margin: 0px;
    padding: 0px;
}

.section-main-heading::after {
    border-bottom: 3px solid #302ba0 !important;
    width: 4%;
}

.section-main-heading p.main-heading-title {
    margin: 0;
    padding: 0px 0 4px;
    font-size: 21px;
    font-weight: 400;
    color: #000 !important;
    text-align: center;
    text-transform: uppercase;
}

.section-main-heading p.main-heading-title span.main-heading-border {
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 6px;
}

.section-main-heading p span {
    font-size: 18px;
}

.section-main-heading::after {
    left: 48%;
    position: absolute;
    content: "";
}


.alert.active {
    visibility: visible;
    opacity: 1;
}

.alert {
    position: fixed;
    visibility: visible;
    right: 15px;
    bottom: 15px;
    padding: 10px;
    width: 30%;
    background-color: #f44336;
    color: white;
    z-index: 995;
    -border-radius: 2px;
    transition: all 0.4s;
}

.closebtn {
    right: 10px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    cursor: pointer;
    transition: 0.3s;
    top: 0px;
    position: absolute;
    z-index: 11;
}

.closebtn:hover {
    color: black;
}

.message1 {
    float: left;
}

.message1 img {
    width: 80px;
}

.mayar {
    margin: 5px 7px 0px 0px;
    position: absolute;
    z-index: 11;
    top: -5px;
}

.mayar img {
    width: 63px;
}

.clients {
    padding: 0px !important;
}

.clients .swiper-slide img {
    transition: 0.3s;
}



.swiper {
    margin: 0px 0px 0px 30px;
}



.scrool-menu1 .swiper-slide {
    display: inline;
    text-align: center;
    border-radius: 3px;
}

.scrool-menu1 .swiper-slide a {
    text-align: center !important;
    font-size: 14px;
    color: #fff !important;
    text-transform: uppercase;
    display: table;
    margin: 0px auto;
}

.drop-footer ul li a {
    font-size: 12px;
}

.drop-footer ul li {
    padding: 5px 0px !important;
}

.drop-footer button {
    padding: 3px 20px !important;
}

.swiper2 {
    margin: 0px 0px 0px 0px !important;
}



.carousel-indicators .active {
    opacity: 1 !important;
    background: #ffec69 !important;
    width: 24px !important;
    margin-top: 10px;
    border-bottom: unset !important;
    border-top: unset !important;
}

.carousel-indicators button {
    cursor: pointer !important;
    background: rgba(255, 255, 255, 0.8) !important;
    margin: 0px 5px !important;
    overflow: hidden !important;
    border: 0 !important;
    width: 12px !important;
    height: 12px !important;
    border-radius: 50px !important;
    opacity: 0.6 !important;
    transition: 0.3s !important;
}

.carousel-indicators {
    justify-content: normal !important;
}

.alert.d-flex.align-items-center.justify-content-center .message1 {
    font-size: 16px;
}








.btn {
    font-size: 0.8rem;
    margin: 2px;
    padding: 10px 25px;
}

.btn-primary {
    font-size: 14px;
    background-color: rgb(42, 41, 84);
    padding: 10px 40px;
    margin: 0px 20px 0px 0px;
    border-width: initial;
    border-style: none;
}



::-webkit-scrollbar {
    width: 0.5em;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
}

::placeholder {
    color: #c6c4e5 !important;
    opacity: 1;
}

:-ms-input-placeholder {
    color: #c6c4e5 !important;
}

::-ms-input-placeholder {
    color: #c6c4e5 !important;
}



.input-group-append {
    font-size: 13px;

    background-color: #4b46ac;
    border: none;
    border-radius: 0 !important;
    height: 38px;
}


.language-txt {
    width: 17px;
}

a.text-large {

    color: #e3e3f2;
    font-size: 21px;
}
.login_btn{
font-size: 15px;
}

.carousel-caption.d-none.d-md-block h5 {
    text-align: left;
    font-size: 30px;
    color: #fff;

}

.carousel-caption.d-none.d-md-block p {
    text-align: left;
    font-size: 29px;
    color: #FFEC69;
    left: 8% !important;
    
}

.carousel-caption {
    position: absolute;
    right: 15%;
    top: 35%;
    left: 8%;text-align:left !important;
}

.white-bgtxt {
    background-color: #fff;
    border-radius: 6px;
    padding: 4px 10px;
    right: 8%;
    position: absolute;
    top: 27%;
    width: 32%;
    opacity: 0.8;
}

.border-btm {
    border-bottom: 2px solid #FFEC69;
    width: 58%;
    position: absolute;
    top: 27px;
    right: 69px;

}

.col-6.white-bgtxt h6 {
    color: #302BA0;
    border-bottom: 2px solid rgba(48, 43, 160, 1);
    font-size: 19px;
    padding: 8px 0px 7px 10px;
    font-weight: 600;
    letter-spacing: 1px;
}

.col-6.white-bgtxt ul li {
    color: #1e1e1e;
    padding: 5px 0px;
    font-size: 13px;
    font-weight: 600;
    color: rgba(48, 43, 160, 1);
}

.col-6.white-bgtxt ul li a {

    color: #000000;
}

.carousel-indicators {
    position: absolute;
    bottom: 1px !important;
    z-index: 2;
    display: flex;
    justify-content: center !important;
    padding: 0;
    margin-right: 0 !important;
    margin-bottom: 0 !important;
    margin-left: 0 !important;
    list-style: none;
}

.col-6.white-bgtxt span {
    font-size: 13px;
    text-decoration: underline;
    position: absolute;
    right: 36px;
    top: 15px;
    font-weight: 600;
}

.col-6.white-bgtxt span a {
    color: #000000;
}

.fix-none {
    position: inherit;
}

.header-bg {
    background: #090253 !important;
}

.services-item .details {
    height: 66px;
    padding: 11px 10px;
    margin: -39px 15px 0 15px;

}

.services-item .details h3 {
    font-size: 12px;
    margin: 15px 0 8px 0;
}

a.stretched-a {
    text-decoration: none;
}

.service-item .details .icon {
    font-size: 20px;
    width: 55px;
    height: 55px;
    top: -30px;
    margin: 0px 0px 0px 8px;
    background: #302ba0;
}

.accordion-item .accordion-header button{padding: 13px 12px; right: 25px; border: 1px solid #E5E9EF !important;}
.accordion-item .accordion-header button i{right: 25px;}

.faq .accordion-item {box-shadow: none;}

.faq .accordion-button i {
    position: absolute;
    right: 16px;
}

.faq .accordion-button:after {
    display: none;
}


.help {
    z-index: 11;
   position: relative;

}




.mayor-table .table-bor-1 {
    color: #302ba0 !important;
    background: rgba(229, 233, 239, 0.5);
}

.mayor-table table {
    width: 100%;
    margin: 0px ;
}

.mayer-tb2 table {
    width: 100%;
    margin: 0px;
}

.mayor-table table tr th {
    font-size: 13px;
    font-weight: normal;
}

.mayor-table table tr td {
    color: #302ba0;
    font-size: 13px;
}


.mayor-table {
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    margin:15px 0px 50px 0px;
}

.mayor-table2a {
    width: 100%;
    height: auto !important;
    overflow-y: inherit !important;
    overflow-x: inherit !important;
}

.mayor-table2 tr td a {
    font-size: 13px;
    color: #0d6efd;
}

.mayor-table2 tr td a:hover {
    color: #000;
}

.table-bor-2 th {
    font-weight: normal;
}

.inner-title3 h3 {
    font-size: 16px;
    text-transform: uppercase;
    display: inline-block;
    padding: 10px 0px 10px 0px;
    color: #302ba0;
}

.funct1 {
    height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.kmc-function-list{ padding: 0px 12px;}
.kmc-function-list li {
    line-height: 30px;
    font-size: 12px !important;
    
    /*  list-style-position: inside; */
   
}

.dig-login1 {
    width: 45%;
    height: auto;
    display: table;
    margin: 100px auto 0px auto;
    padding: 20px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}



.dig-login1 .log-form {
    display: inline-block;
    width: 100%;
}

.dig-login1 .log-form h3 {
    text-align: center;
    float: left;
    width: 100%;
    font-size: 18px;
    padding: 0px 0px 10px 0px;
    margin: 0px;
    color: #302ba0;
    text-transform: uppercase;
    font-weight: 600;
    border-bottom: 2px solid #f1da36;
}

.dig-login1 .log-form p {
    text-align: center;
    font-size: 12px;
    padding: 10px 0px 0px 0px;
    margin: 0px auto;
}


.log-form .form-group p {
    font-size: 12px;
    display: inline-block;
    padding: 0px;
    margin: 0px;
}

.log-form .form-group span {
    font-size: 12px;
    float: right;
}

.dig-login1 .log-form label {
    font-size: 14px;
    padding: 10px 0px 5px 0px;
    letter-spacing: 1px;
}

.dig-login1 .log-form label span {
    color: orangered;
}

.dig-login1 .log-form .form-group input {
    font-size: 13px;
    padding: 8px 15px;
    border: none;
    color: #000;
    border-bottom: 1px solid #302ba0;
    border-radius: inherit;
}

.inner-log-form .form-group input {
    font-size: 13px;
    padding: 10px 15px;
    color: #000;
    border: 1px solid #ced4da !important;
}

.dig-login1 .log-form .form-group select {
    font-size: 13px;
    padding: 8px 15px;
    border: none;
    color: #000;
    border-bottom: 1px solid #302ba0;
    border-radius: inherit;
}

.dig-login1 .log-form .form-group .form-check-input {
    border: 1px solid #000;
    padding: 0px;
    margin: 6px 0px 0px 0px;
}

.dig-login1 .log-form .form-group input::placeholder {
    color: #000 !important;
}

.dig-login1 .log-form .form-group p {
    font-size: 14px;
    text-align: right;
    color: #767676;
    padding: 0px 0px 0px 0px;
    margin-bottom: 20px;
}

.dig-login1 .log-form .form-group p span a {
    color: #f89a3f;
}

.dig-login1 .log-form .form-group .dropdown {
    float: right !important;
    margin: 10px 0px;
}

.dig-login1 .log-form .form-group .dropdown .btn-secondary {
    padding: 5px 10px;
    background-color: inherit;
    border-color: inherit;
    color: #000;
    border: none;
}

.dig-login1 .log-form .form-group .dropdown .btn-secondary:focus {
    box-shadow: none;
}

.dig-login1 .log-form .form-group .dropdown-menu {
    width: auto !important;
}

.dig-login1 .log-form .continu a {
    font-size: 14px;
    color: #fff;
    background: #302ba0;
    padding: 7px 25px;
    float: left;
    text-align: center;
    border-radius: 3px;
    margin: 0px 20px 0px 0px;
}

.dig-login1 .log-form .continu a:hover {
    background-color: #000;
}

.log-form .otp {
    float: left;
}

.dig-login1 .log-form .form-group strong {
    font-size: 12px;
    color: rgb(179, 179, 179);
    font-weight: normal;
    padding: 10px 0px;
}

.back-bottom i {
    color: #fff;
    font-size: 30px;
    padding: 30px 0px;
}

.login__field {
    position: relative;
    width: 90%;
    margin: 10px auto;
}


.bd-wid {
    width: 61px;
}



.carousel-indicators [data-bs-target] {
    transition: none;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    border: 0;
    width: 12px;
    height: 12px;
    border-radius: 50px;
    opacity: 0.6;
    transition: 0.3s;
}

.display-320 {
    display: none;
}

.faq .accordion-button:not(.collapsed) {
    color: #0d6efd !important;
}

.about-head1 .col-lg-12 .about-head1 p {
    display: inline-block;
    line-height: 25px;
    font-size: 13px;
    text-align: justify;
    margin: 0px;
    padding: 4px 10px;
}

.dig-form .log-form .form-group input {
    height: 40px;
    border-radius: 4px !important;
    margin: 5px 0 10px;
}


.table td,
.table th {
    padding: 0.5rem !important;
}


.table-warning,
.table-warning>td,
.table-warning>th,
.table-warning td,
.table-warning th,
.table-warning thead th {
    border-color: #302ba0 !important;
    background-color: #302ba0 !important;
}


#yearclsYear {
    display: none;
}

.site-menu nav ul a.active1 {
    color: #0d6efd !important;
    background: rgba(229, 233, 239, 0.5);
}

.swiper-wrapper.align-items-center.scrool-menu1 {
    width: 80%;
    white-space: nowrap;
}

.dropdown-submenu {
    position: relative;
}
.responsivemenudiv .dropdown-menu { background-color: #302ba0 !important;overflow: scroll;}
.responsivemenudiv .dropdown-menu .dropdown-item { display: list-item; }
.responsivemenudiv .dropdown-item{padding: 0 !important;}
.dropdown-submenu>.dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: 27px;
    margin-left: -128%;
    border-radius: 0 6px 6px 6px;
}

.dropdown-submenu:hover>.dropdown-menu {
    display: block;
}

.dropdown-submenu>a:after {
    display: block;
    content: " ";
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #ccc;
    margin-top: 5px;
    margin-right: -10px;
}

.dropdown-submenu:hover>a:after {
    border-left-color: #fff;
}

.dropdown-submenu.pull-left {
    float: none;
}

.dropdown-submenu.pull-left>.dropdown-menu {
    left: -100%;
    margin-left: 10px;
    border-radius: 6px 0 6px 6px;
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
    color: #dee2e6;
    background-color: #343a40;
    border-color: rgba(0, 0, 0, .15);
}

.dropdown-menu-dark .dropdown-item:focus,
.dropdown-menu-dark .dropdown-item:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .15);
}

.dropdown-menu-dark,
.footer-more .dropdown-menu.dropdown-menu-dark.hidden-as ul a,
.footer-more .dropdown-menu.dropdown-menu-dark.hidden-as {
    color: #dee2e6 !important;
    background-color: #343a40 !important;
    border-color: rgba(0, 0, 0, .15) !important;
}

.aos-init.aos-animate.aos-init.aos-animate {
    border: 0;
    /* margin-top: 10px !important; */
}

.scrool-menu1 .swiper-slide {
    display: inline;
    text-align: center;
    border-radius: 3px;
    width: 25%;
    position: relative;
    animation: myfirst 5s infinite;
    transition: transform 2s ease-in-out;
    animation-direction: right;
}

@keyframes myfirst {
    0% {
        left: 0px;
        top: 0px;
    }

    25% {
        left: 200px;
        top: 0px;
    }

}

.justify-content-center.gy-6 {
    position: relative;
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
}

.site-menu nav ul li .dropdown .btn {
    padding: 0px 0px 0px 17px;
    font-weight: 500 !important;
    font-size: 13px !important;
    color: #302ba0 !important;
    list-style: disc;
    display: inherit;
    list-style-position: inside;
}

.site-menu nav li .dropdown .btn::before {
    height: 1px;
    content: '';
    width: 1px;
    background-color: #302ba0;
    border-radius: 50%;
}

.alert.d-flex.align-items-center.justify-content-center {
    position: fixed;
}

.col-lg-7.col-md-7.text-center.aos-init.aos-animate {
    margin: 0px;
    padding: 0;
}

.col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate {
    margin: 0;
    box-shadow: none;
    display: flex !important;
}

.btn.btn-outline-warning.btn-lg {
    font-size: 12px;
}

.dropdown .btn.btn-secondary.dropdown-toggle {
    font-size: 13px; color: #fff; border: none; background: none;
}

@keyframes L_circle_rotate {
    0% {
        transform: rotate(0)
    }

    100% {
        transform: rotate(360deg)
    }
}

@keyframes L_stroke_rotate {
    0% {
        transform: rotate(0)
    }

    12.5% {
        transform: rotate(135deg)
    }

    25% {
        transform: rotate(270deg)
    }

    37.5% {
        transform: rotate(405deg)
    }

    50% {
        transform: rotate(540deg)
    }

    62.5% {
        transform: rotate(675deg)
    }

    75% {
        transform: rotate(810deg)
    }

    87.5% {
        transform: rotate(945deg)
    }

    100% {
        transform: rotate(1080deg)
    }
}

@keyframes L_stroke_left_grow {

    0%,
    100% {
        transform: rotate(-5deg)
    }

    50% {
        transform: rotate(-140deg)
    }
}

@keyframes L_stroke_right_grow {

    0%,
    100% {
        transform: rotate(5deg)
    }

    50% {
        transform: rotate(140deg)
    }
}

.loader-circle {
    top: 50%;
    left: 50%;
    z-index: 1;
    color: #444;
    margin-top: -1em;
    margin-left: -1em;
    position: absolute;
    animation: L_circle_rotate 1.568s linear infinite both
}

.loader-circle .loader-stroke-left:before,
.loader-circle .loader-stroke-right:before,
.loader-circle:before {
    content: '';
    display: block;
    border-style: solid;
    border-width: .21429em;
    border-color: currentColor
}

.loader-circle,
.loader-circle .loader-stroke-left,
.loader-circle .loader-stroke-left:before,
.loader-circle .loader-stroke-right,
.loader-circle .loader-stroke-right:before,
.loader-circle:before {
    width: 2em;
    height: 2em;
    border-radius: 50%;
    box-sizing: border-box
}

.loader-circle .loader-stroke-left:before,
.loader-circle .loader-stroke-right {
    position: absolute;
    clip: rect(0 2em 2em 1em)
}

.loader-circle .loader-stroke-left,
.loader-circle .loader-stroke-right:before {
    position: absolute;
    clip: rect(0 1em 2em 0)
}

.loader-circle:before {
    position: absolute;
    clip: rect(0 1.05em 1em .95em)
}

.loader-circle .loader-stroke-left,
.loader-circle .loader-stroke-right,
.loader-circle:before {
    animation: L_stroke_rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both
}

.loader-circle .loader-stroke-right:before {
    animation: L_stroke_right_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both
}

.loader-circle .loader-stroke-left:before {
    animation: L_stroke_left_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both
}

.mhn-slide.owl-carousel {
    display: flex;
    overflow: hidden;
}

.mhn-slide .mhn-item {
    padding: 0px !important;
    margin: 20px 0px 20px 0px;
    display: flex;
}

.mhn-slide .mhn-inner {
    width: 165.167px;
    margin-right: 25px;
    border-radius: 8px
}

.mhn-slide .mhn-item img {
    display: none;
    border-radius: 8px;
    overflow: hidden;
}

.mhn-slide .mhn-img {
    overflow: hidden;
    height: 120px;
    width: 100%;
    color: white;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) #eee no-repeat center/cover;
    position: relative
}

.mhn-slide .mhn-text {
    text-align: center;
    padding: 0 10px
}

.mhn-slide .mhn-text h4 {
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
}

.mhn-slide .mhn-text p {
    max-height: 4.5em;
    overflow: hidden
}

.mhn-slide .owl-stage-outer {
    z-index: 1
}

.mhn-slide .owl-nav {
    color: #333;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0
}

.mhn-slide .owl-nav svg {
    color: currentColor
}

.mhn-slide .owl-nav .disabled {
    display: none
}

.mhn-slide .owl-prev,
.mhn-slide .owl-next {
    top: 210px;
    z-index: 2;
    width: 40px;
    height: 40px;
    padding: 8px;
    margin-top: -20px;
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, .3), 0 0 4px rgba(0, 0, 0, .2)
}

.mhn-slide .owl-prev {
    left: -10px
}

.mhn-slide .owl-next {
    right: -10px
}

@keyframes scroll {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(calc(-250px * 1));
    }
}

.header-slider {
    margin: 0px 0px 0px 30px;
    touch-action: pan-y;
    list-style: none;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.header-slider::before,
.header-slider::after {
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
}

.header-slider::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
}

.header-slider::before {
    left: 0;
    top: 0;
}

.header-slider .header-slide-track {
    animation: scroll 30s linear infinite;
    display: flex;
    width: 120px;
}

.header-slider .header-slide {
    width: 177.2px;
    margin-right: 50px;
    flex-shrink: 0;
    height: 100%;
    position: relative;
    transition-property: transform;
}

.header-slider .header-slide a {
    text-decoration: none;
    text-align: center !important;
    font-size: 14px;
    color: #fff !important;
    text-transform: uppercase;
    display: table;
    margin: 0px auto;
}

.header-slider {
    margin: 0px 0px 0px 30px;
    touch-action: pan-y;
    list-style: none;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.header-slider::before,
.header-slider::after {
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
}

.header-slider::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
}

.header-slider::before {
    left: 0;
    top: 0;
}

.header-slider .header-slide-track {
    animation: scroll 30s linear infinite;
    display: flex;
    width: 120px;
}

.header-slider .header-slide {
    width: 177.2px;
    margin-right: 50px;
    flex-shrink: 0;
    height: 100%;
    position: relative;
    transition-property: transform;
}

.header-slider .header-slide a {
    text-align: center !important;
    font-size: 14px;
    color: #fff !important;
    text-transform: uppercase;
    display: table;
    margin: 0px auto;
}





.menu-slider {
    margin: 0px 0px 0px 30px;
    touch-action: pan-y;
    list-style: none;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.menu-slider::before,
.menu-slider::after {
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: -2;
}

.menu-slider::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
}

.menu-slider::before {
    left: 0;
    top: 0;
}

.menu-slider .menu-slide-track {
    animation: scroll 20s linear infinite;
    display: flex;
    width: 180px;
}

.menu-slider .menu-slide-track:hover {
    animation-play-state: paused;
}


.menu-slider .menu-slide {
    width: 177.2px;
    margin-right: 50px;
    flex-shrink: 0;
    height: 100%;
    position: relative;
    transition-property: transform;
}

.menu-slider .menu-slide a {
    text-align: center !important;
    font-size: 14px;
    color: black !important;
    text-decoration: none;
    text-transform: uppercase;
    display: table;
    margin: 0px auto;
}

a.stretched-a {
    text-decoration: none;
}

a.stretched-a {
    text-decoration: none;
}

.services-item .details .icon {
    margin: 0;
    width: 62px;
    height: 62px;
    background: var(--color-primary);
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    color: var(--color-white);
    font-size: 25px;
    transition: ease-in-out 0.3s;
    position: absolute;
    top: -40px;
    left: calc(50% - 36px);
    border: 6px solid var(--color-white);
}

.services-item .details .icon:hover {
    margin: 0;
    width: 62px;
    height: 62px;
    background: var(--color-white);
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    color: var(--color-white);
    font-size: 25px;
    transition: ease-in-out 0.3s;
    position: absolute;
    top: -40px;
    left: calc(50% - 36px);
    border: 6px solid var(--color-primary);
}

.bi-gear::before {
    content: "\\f3e5";
}

i.bi.bi-gear {
    color: #fff;
}

a.stretched-a h3 {
    color: black;
}

a.stretched-a h3 span {
    color: black;
}

.services .service-item:hover .details h3 {
    color: #302ba0;
}

.services .service-item:hover .details .icon i{color: #302ba0;}
.services .service-item:hover .details .icon{border: 2px solid #302ba0;}

.services .service-item .details h3 {
    color: black;
    font-size: 11px;
}


.bi::before,
[class^="bi-"]::before,
[class*=" bi-"]::before {
    display: inline-block;
    font-family: bootstrap-icons !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: -0.125em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.menu-slider .menu-slide .details {
    height: 60px;
    padding: 11px 10px;
    margin: -39px 15px 0 15px;
    transition: all ease-in-out 0.3s;
    text-align: center;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: rgb(198, 196, 196);
}

.position-relative {
    position: relative !important;
}

.menu-slider .menu-slide .details h3 {
    font-size: 11px;
    margin: 15px 0 8px 0;
    font-weight: 700;
    transition: ease-in-out 0.3s;
}

.menu-slider .menu-slide .details .icon {
    font-size: 20px;
    width: 45px;
    height: 45px;
    top: -22px;
    margin: 0;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: ease-in-out 0.3s;
    position: absolute;
    left: calc(50% - 27px);
}

.menu-slider .menu-slide .img {
    border-radius: 8px;
    overflow: hidden;
}

.container .section-main-heading {
    border: 0 !important;
    margin: -2px 0px 5px 0px !important;
}

/* .help {
    position: absolute;
    right: 0;
    z-index: 111;
    bottom: 0px;
} */

.help a img {
    width: 190px;
    position: absolute;
    right: 20px;
    bottom:6px;
    height: 187px;
}

.about-head1 h4 {
    text-align: justify;
}
.about-img2 p { text-align: justify;}

.about-head1 p {
    padding: 5px 0px 5px 10px;
}

.nav>li {
    display: list-item !important;
}

.site-menu nav ul li .dropdown {
    font-weight: 500 !important;
    font-size: 13px !important;
    padding-left: 15px;
    margin-top: 12px;
    color: #302ba0 !important;
    border-bottom: 1px solid #E5E9EF !important;
    list-style: disc;
    display: inherit;
    list-style-position: inside;
}


element.style {
    margin-left: 5px;
}

.site-menu nav ul li .dropdown .btn {
    margin-top: -22px;
}

.section-main-heading2 h5 {
    color: #fff;
    margin-top: 12px;
    font-style: italic;
}

.faq.birth_death .card-header a {
    padding: 15px 20px 20px 20px;
    font-weight: 600;
    border: 0;
    font-size: 14px;
    text-align: left;
    box-shadow: none;
    padding: 15px 20px 15px 20px;
    border-radius: 0px;
}

.faq.birth_death .card {
    border: none !important;
    border: 0;
    margin-top: 15px;
}

.faq.birth_death .card-header {
    background-color: #fff;
    padding: 10px 0px;
    border: none !important;
}

.faq.birth_death .card-header .card-a.collapsed {
    color: black !important;
}

.faq.birth_death .card .card-header .card-a {
    color: yellow !important;
}

.faq.birth_death .card-body {
    font-size: 13px;
    padding: 0px 20px;
}

#accordion .card-header a {
    font-weight: 600;
    border: 0;
    font-size: 13px;
    text-align: left;
    box-shadow: none;
    padding: 15px 20px 15px 20px;
    border-radius: 0px;
}

#accordion .card { border-bottom: 1px solid #d3d3d3 !important; border: 0; margin: 10px 0px;}
.language.login-1 .bi-chevron-down::before { padding: 4px; color: #fff !important;}
#accordion .card-header { padding: 0px; border: none !important;}
.card-header.responsiveheader{color: #fff !important; padding: 0px; border: none !important;}
#accordion .card-body {
    font-size: 13px;
    padding: 0px;
    padding-bottom: 0px;}


#accordion .card .card-header .card-a.collapsed {
    color: #000 !important;
}

.about-img3 p {
    font-size: 13px;
    line-height: 25px;
    color: #000;
    padding: 0px 0px 0px 0px;
    display: inline;
}

.about-img3 img {
    width: 200px;
    height: 120px;
    border-radius: 5px;
    float: left;
    margin: 0px 20px 0px 0px;
}

.about-head1 .w-50 .card {
    width: 50%;
}

.about-head1 .w-30 .card {
    width: 30%;
}


.about-head1 p {
    display: inline-block;
    line-height: 26px;
    font-size: 13px;
    text-align: left;
    margin: 0px;
    padding: 0px;
}

.btn-primary:focus {
    color: #fff;
    background-color: #0b5ed7;
    border-color: #0a58ca;
    box-shadow: 0 0 0 0.25rem rgb(49 132 253 / 50%);
}

.kmc-department th {
    font-size: 13px;
    font-weight: normal;
}

.kmc-department tr td {
    font-size: 13px;
}

.depart {
    min-height: 450px;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
}

.map2 a {
    color: #302ba0;
    margin: 7px 0px;
    display: inline-block;
    padding: 10px 10px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .125);
    font-size: 14px;
    width: 40%;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}

.depart.Tender_batra {
    height: 300px;
}


.dig-login2 {
    width: 100%;
    height: auto;
    margin: 10px 0px 20px 0px;
    padding: 20px;
    background: #fff;
    border-radius: 6px;
    display: table;
    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}
.dig-login2 .pdf-link1 h6 a{font-size: 13px;
    line-height: 27px;}
.dig-login2 .pdf-link1 h6 a:hover{text-decoration: none;}

.agent-code {
    border: 1px solid #1c5d9d;
    background: #dfe8f6;
    border-radius: 5px;
    padding: 16px;
    margin-left: 12px
}

.agent-code h4 {
    font-size: 14px;
    color: #1c5d9d;
    font-weight: 600
}

.agent-code h5 {
    font-size: 13px;
    color: #000;
    font-weight: 600;
    margin-bottom: 0
}

.agent-code p {
    font-size: 12px;
    color: #000;
    font-weight: 400;
    margin-bottom: 2px
}

.agent-code input {
    border: none;
    border-radius: 5px;
    width: 350px;
    font-size: 12px;
    height: 28px;
    margin-top: 4px;
    margin-left: 16px;
    padding: 0 8px
}

.agent-code button {
    width: 150px;
    border-radius: 5px;
    height: 30px;
    margin: auto;
    display: block;
    border: 1px solid #1c5d9d;
    margin-top: 24px;
    font-size: 13px;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    color: #1c5d9d;
    font-weight: 600
}

.no-margin {
    margin-top: 0
}

.advertisement .accordion-button {
    padding: 10px 20px 10px 20px;
    font-size: 13px
}

.advertisement .accordion-item {
    margin-top: 8px
}

.advertisement ul {
    margin-bottom: 0
}

.advertisement li {
    line-height: 24px;
    font-size: 13px
}

.advertisement .accordion-body {
    padding: 0 25px 12px 20px
}

.dig-form {
    width: 100%;
    height: auto;
    display: table;
    margin: 0px 20px 0px 0;
    padding: 16px 20px 0;
    background: #fff;
    border-radius: 6px;
}

.dig-form .log-form h3 {
    text-align: left;
    width: 100%;
}

.dig-form .log-form .continu a {
    margin: auto;
    display: block;
    width: 220px;
    float: none
}

.dig-form .form-group {
    margin-bottom: 0
}

.dig-form .subheader {
    font-size: 12px;
    margin-top: 0px;
    text-align: left !important;
    margin-left: 20px;
    margin-bottom: -10px
}

.dig-form .subtitle {
    font-size: 16px !important;
    margin-top: 6px;
    margin-bottom: 0px;
    text-align: left !important;
    padding-top: 6px !important
}

.dig-form .form-label {
    font-size: 13px !important;
    color: #302ba0;
    margin-bottom: 0;
    font-weight: 500
}

.dig-form .log-form .form-group input {
    border: 1px solid #302ba0;
    border-radius: inherit
}

.dig-form .login__field {
    margin-bottom: 1rem
}

.dig-form .break {
    margin-top: 2rem;
    margin-bottom: 2rem
}

.dig-form .disclaimer {
    font-size: 14px;
    margin-top: 0px;
    text-align: center !important;
    margin-bottom: 0;
    padding: 10px 2rem 0 2rem !important
}

.dig-form .log-form .form-group select {
    border: 1px solid #302ba0;
    -webkit-appearance: listbox !important;
}

.orbtn {
    color: #fff;
    font-size: 14px;
    text-align: center;
    margin: 10px auto 4px;
    background: #302ba0;
    width: 30px;
    border-radius: 50px;
    height: 30px;
    padding: 6px 2px;
}

.menu-show-more-btn { border: none !important; background: #fff !important; color: #090253 !important; text-align: right !important; font-weight: 600 !important;margin-top: 6px !important;}

.show-more-menu {
    display: none
}

.menu-show-less-btn {
    border: none;
    background: #fff;
    color: #302ba0;
    text-align: right;
    font-weight: 600;
    margin-top: 2px;
    float: right
}

.menu-show-less-btn:hover {
    color: #090253
}

.mayor-table .officials header-table td {
    color: #fff !important;
    font-weight: 500
}

.mayor-table .officials .content-table tr td {
    color: #000 !important;
    font-weight: 400
}

.list-of-forms h6 {
    text-decoration: underline;
    color: #0d6efd;
    font-size: 13px;
    font-weight: 400
}

.frms {
    margin-bottom: 1rem !important
}

.min-hg {
    min-height: 300px
}

.tb-1 {
    width: 100% !important
}

.tb-1 td {
    border-color: #dee2e6;
    border-style: solid;
    border-width: 1px;
    font-size: 13px
}

.tb-1 td b {
    text-decoration: underline;
    color: #0d6efd;
    pointer-events: button;
    font-weight: 400 !important;
    font-size: 12px
}

.dig-form .subtt-ad {
    font-size: 16px !important;
    margin-top: 6px;
    margin-bottom: 16px;
    text-align: left !important;
    padding-top: 6px !important
}

.dig-form tr .padd-tb {
    padding: 4px 6px;
    color: #000
}

.dig-form .rates {
    padding: 0 !important
}

.dig-form .rates .rm-mg {
    margin-left: 0 !important
}

.dig-form .rates .rm-mg td {
    padding: 4px 0
}

.list-items {
    padding-top: 20px
}

.list-items li {
    font-size: 13px;
    color: #000;
    font-weight: 400
}

.list-items b {
    font-size: 13px;
    margin-left: 20px
}

.dig-login1 .log-form .form-group select {
    height: 40px;
}

.table-warning{color:#fff !important;}
.col-lg-12.about-head1 { padding: 0;}
.li-style{color: #16181b !important; text-decoration: none; padding: 10px !important;    }
.li-style:hover{background-color: #e9ecef;}
.make_online_payment .card-body a{color: var(--color-links); text-decoration: none; font-size: 13px}
.make_online_payment .card-body{padding: 0;}
.faq .accordion-button:not(.collapsed) { color:#000; border-bottom: 0; box-shadow: none;}
.NavBar_container .dropdown .dropdown-menu a{font-weight: 500 !important;height: 25px;font-size: 13px !important; color: #302ba0 !important; list-style: disc;display: inherit;list-style-position: inside;}
.NavBar_container .dropdown .dropdown-menu{height: auto; }
.mayor-table table tr td.white-clr { color: #fff;}
.dropdown-menu.dept-menu{height: 280px; overflow: scroll;}
ul.dropdown-menu.multi-level.min-height-400.show {z-index: 1 !important;}

.carousel-caption {text-align: left;}

/* 11-01-2023 */
.carousel-item { width:100% !important; height: 200px; margin-right: inherit !important; }
.carousel-item img{height: 200px; width:100% !important;}
.bi-chevron-down::before {content: "\\f282";  color: #fff;}
.float_right{float: right;}

.faq .accordion-flush .collapse .card ul li a{ font-size: 12px !important; text-decoration: none; }
.faq .accordion-flush p{margin: 0px; font-size: 12px; line-height: 24px; padding: 0px 10px 0px 10px;}
.faq .accordion-flush button {padding: 10px 20px;}
.faq .accordion-flush p h3{ margin: 0px;}


.mayor-table-column{ margin: -20px 0px 0px 0px;}
.login-1 .btn-secondary:focus{background:none; box-shadow:none;}

.card-header .btn-link fontSizeClass :focus {text-decoration:none; box-shadow:none; } 
.card-header .btn-link fontSizeClass :hover{text-decoration: none;}
.history_of_kolkata .collapse{margin: 10px 0px;}

.card .card-header .m-2{ margin: 0px !important;}
.presid-1{width: 40%; border-radius: 10px; margin: 20px 0px 0px 0px;}


/* 17-02-2023 */
.about-head1 .more-but2 {margin: 10px 0px 10px 0px;}



/* ======================18-02-23=== */
.site-menu .nav_dropdown .nav-link{font-size: 11PX !important;}
.pdf-link1{border: 1px solid rgb(197, 196, 196); border-radius: 4px;}
.quick-part{display: inline-block; }
.q-link {background:#302ba0; color: #fff;}
.quick-part a{font-size: 14px; padding:8px 15px; 
    border-radius:5px; margin:5px 0px 0px 0px;
    display: inline-block;
    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);
    width: 100%; font-weight: 500;}
.mayor-table2 table .nav-link{padding: initial;}
/* AUROBINDA */
.site-menu .nav_dropdown .nav-link{font-size: 11PX !important;}
.quick-part{display: inline-block; }
.q-link {background:#302ba0; color: #fff;}
.quick-part a{font-size: 14px; 
    padding:6px 15px; 
    border-radius:5px; margin:5px 0px 0px 0px;
    display: inline-block;
    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);
    width: 100%; font-weight: 500;}

.faq .card .card-header{padding: 10px;}.faq .card .card-header button { margin-top: 15px; border: 0px; width: 100%; text-align: left; background: #fff;box-shadow: 0px 0 16px rgb(0 0 0 / 10%); font-weight: bold; font-size: 14px; color: #000;}
.faq .card .card-header button i{float: right;}
.faq .card .card-header button i::before{color: #000 !important; font-weight: bold; text-align: right; }
.faq .card .card-header .btn-link:focus {text-decoration: none;}
.faq .card .card-header button:hover {text-decoration: none;}
.scrl1{height:150px; overflow-y: scroll; overflow-x: hidden; }
.scrl1 p {text-align: left; padding: 0px 10px;}
.card-body p{text-align: justify;font-size: 13px;}
.nav-item.nav_dropdown .card-header .btn-link{padding-left: 0px !important;}
.card .card-header .btn-link{text-align: left;
    font-size: 13px;
    color: black; width: 100%;}
.text-justify{text-align: justify !important;}

/*==================== 24-02-2023 ================ */

.faq .card .card-header{padding: 10px;}
.faq .card .card-header button { margin-top: 15px; border: 0px; width: 100%; text-align: left; background: #fff;
  box-shadow: 0px 0 16px rgb(0 0 0 / 10%); font-weight: bold; font-size: 14px; color: #000;}
  .faq .card .card-header button i{float: right;}
  .faq .card .card-header button i::before{color: #000 !important; font-weight: bold; text-align: right; }
.faq .card .card-header .btn-link:focus {text-decoration: none;}
.faq .card .card-header button:hover {text-decoration: none;}
.scrl1{height:150px;  overflow-y: scroll; overflow-x: hidden; }
.scrl1 p {text-align: left; padding: 0px 10px;}

/*==================== 24-02-2023 ================ */
/*==================== 27-02-2023 ================ */
.eodb-site-menu .nav-pills{background-color:#fff; border-radius:0px;  }
.eodb-site-menu .nav-pills a { font-size: 13px; text-align: left; color:#302ba0; 
border-bottom: 1px solid #c6c4e5; border-radius:0px; line-height: 30px; font-weight: bold;}
.eodb-but1 .modal .modal-content .modal-title{font-size: 15px; color: #302ba0; font-weight: bold;}
.eodb-but1 .modal .modal-content .modal-footer button{background:#302ba0; padding:8px 20px; color: #fff;}
.eodb-but1 .modal .modal-content .modal-body .mod-hed-1 img{ width: 60px; float: left;}
.eodb-but1 .modal .modal-content .modal-body .mod-hed-1 p{ font-size: 13px; display: inline-block; 
 width:85%;  padding:10px; }
 .model-list{padding: 0px 0px 0px 2px;}
 .model-list li{ font-size: 14px; list-style: none; font-weight: bold; color:#302ba0;
     line-height: 30px;}
.eodb-but1 button:focus:not(:focus-visible){box-shadow:none}

.eodb-but1 button ul{  list-style: inside; margin: 0px 0px 0px -21px; color:#302ba0; 
    padding: 0px; display: flex; text-decoration: underline;}
.eodb-1 a ul{ list-style: inside; margin: 0px 0px 0px -21px; 
    color:#302ba0; padding: 0px; display: flex;}
.eodb-1 a ul li{text-decoration: underline; }

 .eodb-1 a,
 .eodb-pd-li button{padding:5px 66px 0px 19px; font-size: 15px; color: #302ba0; font-weight: bold;}
 .eodb-1 a:focus:not(:focus-visible){box-shadow:none}
 .eodb-1 .card-body{padding: 10px;}
 .eodb-but1{margin:5px 0px 0px 0px; }
 .eodb-but1 button{padding: 10px 20px 0px 20px; font-size: 15px; color: #302ba0; font-weight: bold; }
 .eodb-titl {color:#302ba0; font-size: 23px; background-color: #c6c4e5; padding: 10px 20px;}
 .eodb-1 p{margin: 0px;}
 .eodb-li{list-style: none; margin: -9px 0px 0px -10px; padding:10px 20px; width:35%; font-size: 13px;
    line-height: 30px;  border-radius: 3px; box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%), inset 0 -1px 0 rgb(255 255 255 / 15%);}
 .eodb-li li a{ margin:0px; padding:0px; line-height:30px; font-size: 13px; color:#000; border: none;}
 .eodb-li li a:hover{color:#007bff;}
 .eodb-pdf .eodb-pd-li {font-size: 15px; color: #302ba0; padding:5px 0px 0px 0px;
    line-height: 31px; list-style: inside; line-height: 35px; }
.eodb-pdf .eodb-pd-li a{color: #302ba0; font-weight: bold; text-decoration: underline; }
.eodb-1 .collapse .card img {float: left;}

.desh-bo-2 {width: 100%; display: inline-block;}
.desh-bo-2 .card .card-header button { width:100%; text-decoration: none;  
background:#fff; border: 1px solid #c6c4e5; font-size: 13px; text-align: left; 
color: #302ba0; font-weight: bold; padding: 10px 15px; }
.desh-bo-2 .card .card-header .active{color: #fff; background-color: #007bff; }
.desh-bo-2 #accordion .card-body{padding:5px; text-align: left; }
.desh-bo-2 #accordion .card{border-bottom:none !important; margin: 0px;}

.desh-bo-2 #accordion .card .collapse {position:relative; width: 100%; margin:0px 0px 0px 0px; z-index: 11111; }
.desh-bo-2 #accordion .card-body {border: 1px solid #c6c4e5; width: 100%; color: #000; z-index: 11111; 
    background: #fff; padding: 5px 10px 5px 10px; border-radius: 3px; font-size: 12px; text-align: justify; }


.desh-bo-ser {clear: both; }
.desh-bo-ser .card {margin:10px 0px;}
.desh-bo-ser .card .card-header{padding: 0px; border-bottom: none;}
.desh-bo-ser .card .card-header button{width: 100%; float: left;  color: #fff; padding: 8px 20px;
    text-align: justify; font-weight: bold; font-size:14px; text-decoration: none;}

.des2-list{height: 200px; overflow-y: scroll; padding: 10px 20px 10px 30px; }
.des2-list ul {padding: 0px;}
.des2-list ul li a{list-style: none; padding: 0px; font-size: 12px; color: #007bff;}
.des2-list ul li a:hover{color: #000;}

.desh-bo-ser .card .card-header h5 button i {float: right; color: #fff;}
.desh-bo-2 .card .card-header button i{float: right; color: #fff;}

.desh-bo-ser .card .card-header .btn .bi-chevron-down::before {color: #FFF !important;}

.colr1{ background-color: #191e57 !important;}

.colr2{background: #3e4bd6 !important;}

.colr3{background: #434457 !important; }

.colr4{background: #2f39a3 !important; }

.colr5{background: #6c5d9e !important; }

.colr6{background: #35246b !important; }

.colr7{ background: #d7a75f !important;}

.colr8{background: #9e7b5d !important; }

.colr9{background: #2f39a3 !important; }


/*==================== 27-02-2023 ================ */



.inner-title2 {float: left; width: 100%;}
.inner-pad1 .quick-t h3{padding: 0px 0px 0px 14px;}

/*==================== 13-03-2023 ================ */
.logo {float: left;}
.header-office_name {display: inline-block;}

.megamenu1 .navbar{
    padding-top: 0;
    padding-bottom: 0;
}
.megamenu1 .navbar-light .navbar-brand {
    color: #1b08c5;
}
.megamenu1 .navbar-light .navbar-nav .nav-link {
    color: #fff; font-weight: 300;
}
.megamenu1 .navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {
    color: #1ebdc2;
}
.megamenu1 .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #ffde00 !important;
}
.megamenu1 .navbar-light .navbar-nav .nav-link{
    padding-top:0px;
    padding-bottom: 0px;
    transition: 0.3s;
    padding:7px 15px 7px 15px;
    font-size: 14px; 
    color: #fff !important;
}
.megamenu1 .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover{
    transition: 0.3s;
}
.megamenu1 .dropdown-item:focus, .dropdown-item:hover {
   color: #fff !important;
   text-decoration: none;
   background-color: #302ba0 !important;
}
.megamenu1 .sm-menu{
   border-radius: 0px;
   border: 0px;
   top: 35px;
   background: #fff;
   color: #0a0185;
   box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
}
.megamenu1 .sm-menu a{padding:7px 10px; color: #000; border-bottom: 1px solid #f6f6fe;}

.megamenu1 .sm-menu h6{padding:0px 10px; color: #0a0185; font-size: 13px;}
.megamenu1 .sm-menu .navcol {color: #0a0185; font-size: 13px; font-weight: 500;}

.megamenu1 .dropdown-item {
   color: #302ba0; font-size: 12px;
}
.megamenu1 .dropdown-item.active, .dropdown-item:active {
   color: #fff;
   text-decoration: none;
   background-color: #2196F3;
}
.megamenu1 .navbar-toggler{
   outline: none !important;
}
.megamenu1 .navbar-tog{
   color: #1ebdc2;
}
.megamenu1 .megamenu-li {
   position: static;
}

.megamenu1 .megamenu {
   position: absolute;
   width: 100%;
   left: 0;
   right: 0;
   padding: 10px;
}
.megamenu1 .megamenu1 .megamenu h6{
   margin-left: 21px;
}
.megamenu1 .megamenu i{
   width: 20px;
}
.megamenu1 .navbar .nav-link{padding: 0px;}

/*==================== social-media ========================= */

.social-media {
    position: fixed;
    float: left;
    top: 44%;
    background: none;
    height: auto;
    width: 50px;
    z-index: 111;
    left: 0;
}


.social-media .facebook a {
    padding: 10px 5px;
    display: inline-block;
    background: #35528e;
    color: #fff;
    text-align: center; transition-duration:0.5s;
}
.social-media .facebook a:hover{padding: 10px 15px; color: #fff; background: #35528e; transition-duration: 0.5s;}
.social-media .facebook img{width: 30px; height:25px;}

.social-media .twitter a {
    padding: 10px 5px;
    display: inline-block;
    background: #1da1f2;
    color: #fff;
    text-align: center; transition-duration:0.5s;
}
.social-media .twitter a:hover{padding: 10px 15px; color: #fff; background: #1da1f2; transition-duration:0.5s;}
.social-media .twitter img{width: 30px; height:25px;}

.social-media .support a {
    padding: 10px 5px;
    display: inline-block;
    background: #302ba0;
    color: #fff;
    text-align: center; transition-duration:0.5s;
} 
.social-media .support a:hover{padding: 10px 15px; color:#fff; background: #302ba0; transition-duration:0.5s;}
.social-media .support img{width: 30px; height:25px;}


.social-media .whatsapp a {
    padding: 10px 5px;
    display: inline-block;
    background: #25D366;
    color: #fff;
    text-align: center; transition-duration:0.5s;
}

.social-media .whatsapp a:hover{padding: 10px 15px; color: #fff; background: #25D366; transition-duration:0.5s;}
.social-media .whatsapp img{width: 30px; height:25px;}


.quick1 .sidebar .nav .quick-scrl{overflow-x:hidden; overflow-y: scroll; height: 100px;} 
.site-menu nav ul li .btn:focus {box-shadow:none;}
.quick2 .sidebar .btn:focus {box-shadow:none;}

/*==================== 22-03-2023 ========================= */
.login-1 .dropdown button .bi-chevron-down::before{color: #fff !important;}
.NavBar_container .NavBar_container--navbar .nav-menu .nav-item-list .card-header 
.nav-item-list .bi-chevron-down::before {color: #fff !important;}

.glightbox-clean .gclose {
    width: 35px;
    height: 35px;
    top: 15px;
    right: 10px;
    position: absolute;
}

/*==================== 06-04-23 ========================= */
.more-but button{padding:5px 18px; font-size: 14px; color: #fff; background-color: #302ba0;}
.more-but button .bi-chevron-down::before{color: #fff !important;}

.about-img3 strong .btn{font-size: 13px; padding:3px 10px; background-color: #302ba0; color: #fff; margin: 0px 0px 0px 10px;}
.about-img3 strong .btn .bi-chevron-down::before {color: #fff !important; font-size: 12px; padding: 0px 0px 0px 3px;}

/*==================== 18-04-23 ========================= */

.table-bor-2a td{color: #fff; vertical-align: middle !important; text-align: right;}
.tab-bord1 {float: right;}
.tab-bord1 td {border: solid 1px #fff !important; text-align: center; padding: 3px 8px !important;}
.col-td1{width: 50%;}
.list-items2a ul{ text-align: justify;
    font-size: 13px;
    padding: 0px 0px 0px 0px;
    list-style: lower-roman inside;
    line-height: 25px; }
.rts-p{font-size: 12px; line-height: 30px;}
.tex-col-1b {color: #FF0000;}
.table-scl-3a {height: 250px; overflow-y: scroll; display: inline-block;}
.eng-tab-width1 {width: 50%;}
.center1 {text-align: center;}

.thumb .fancybox img {width: 100%; overflow-y: hidden; height: 150px; margin: 0px 0px 30px 0px;}
.gal-hight {margin: 70px 0px 0px 0px;}

.rtinner ul li a {list-style: none; line-height:30px; font-size: 15px; }
.rtinner ul {display: inline; list-style: inside;}

.btn-1{font-size: 10px !important;}
.nav-item a .bi-chevron-right::before{font-size:10px; text-align: right;}







/*==================== Only For Responsive========================= */


@media screen and (max-width:1920px) {
    .language .dropdown-toggle{padding:4px 20px;}   
    .hero2 img{width:100%;}
}
@media screen and (min-width:1357px) {
 .NavBar_container {  margin-top: 193px !important; }
}

@media screen and (max-width: 1200px) { 
    
    .megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}

    .Banner {margin-top:-65px; height:241px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:183px; width:100% !important;}
    .banner-container{height:248px;}
    .help a img {right: 25px; width: 177px; height: 174px;}

}

@media screen and (max-width: 1104px) {
    .text_english {font-size: 12px !important;}}

@media screen and (max-width: 1100px) {
    .text_english {font-size: 12px !important;}
    .megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}

    .Banner {margin-top:-65px; height:210px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:152px; width:100% !important;}
    .banner-container{height:214px;}
    .help a img {right: 25px; width: 153px; height: 145px;}
}

@media screen and (max-width: 1024px) { 
.text_english {font-size: 13px !important;}
.login-1 { margin: 0px -12px 0px 0px;}
.megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}

.Banner {margin-top:-65px; height:210px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:152px; width:100% !important;}
    .banner-container{height:214px;}
    .help a img {right: 13px; width: 153px; height: 145px;}

}

@media screen and (max-width: 992px) { 
    
    .megamenu1 .navbar-light .navbar-nav .nav-link{    font-size: 10px;}
    .text_english {font-size: 13px !important;}
    .login-1 { margin: 0px -12px 0px 0px;}

    /* ======= Mega menu =========*/
   .header2 { z-index: 111; position: relative; padding: 0px; }
   .megamenu1 {padding: 0px; }
   .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
   .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
   .megamenu1 .navbar-collapse { box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
   .megamenu1 .navbar{padding: 0px;}
   /* ======= Mega menu =========*/
   .Banner {margin-top:-65px; height:210px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:152px; width:100% !important;}
    .banner-container{height:214px;}
    .help a img {right: 13px; width: 115px; height: 114px;}

}


/*==================== 27-02-2023 ================ */
@media (max-width: 967px) {
.nav.nav-tabs{border-bottom:0;border-right:1px solid transparent;display:block; 
    margin-right:20px; width:100%!important}
.horizontal-tabs .nav-tabs{width:100%;padding:0}
}
/*==================== 27-02-2023 ================ */


@media screen and (max-width:890px) {
    .text_bengali {font-size: 18px;}
    .text_english {font-size: 14px; }
    .login-1 {margin: 0px -13px 0px 0px;}
   /* .container, .container-md, .container-sm { max-width: 840px; } */
   /* ======= Mega menu =========*/
   .header2 { z-index: 111; position: relative; padding: 0px; }
   .megamenu1 {padding: 0px; }
   .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
   .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
   .megamenu1 .navbar-collapse {padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
   .megamenu1 .navbar{padding: 0px;}
   /* ======= Mega menu =========*/
   .Banner {margin-top:-65px; height:190px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:133px; width:100% !important;}
    .banner-container{height:190px;}
    .help a img {right: 13px; width: 115px; height: 114px;}

}

@media screen and (max-width:870px) {
    .text_bengali {font-size: 12px !important;}
    .text_english {font-size: 12px !important;}
 }

@media screen and (max-width:850px) {
    .text_bengali {font-size: 12px !important;}
    .text_english {font-size: 12px !important;}
 }

@media screen and (max-width: 820px) {
.font-site {width: 72px;} 
.login-1{margin: 0px 0px 0px 0px !important;}
.text_english {font-size: 10px !important;}

 /* ======= Mega menu =========*/
 .header2 { z-index: 11111; position: relative; padding: 0px; }
 .megamenu1 {padding: 0px; }
 .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
 .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
 .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
 .megamenu1 .navbar{padding: 0px;}
 /* ======= Mega menu =========*/

.Banner {margin-top:-65px; height:180px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:123px; width:100% !important;}
    .banner-container{height:190px;}
    .help a img {right: 13px; width: 115px; height: 114px;}
    
}

@media screen and (max-width: 815px) {

    .font-site {width: 72px;} 
    /* ======= Mega menu =========*/
    .header2 { z-index: 111; position: relative; padding: 0px; }
    .megamenu1 {padding: 0px; }
    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
    .megamenu1 .navbar-collapse {padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
    .megamenu1 .navbar{padding: 0px;}
    /* ======= Mega menu =========*/
    .text_english {font-size: 10px !important;}
    .text_bengali{font-size: 13px !important;}


}

@media screen and (max-width: 768px) {
    .inner-pad1 {padding: 0px 0px 0px 0px;    }
    .container.aos-init.aos-animate .col-lg-3{padding: 0 !important;}
    .pdf-link1 h6{line-height: 30px;text-align: justify;}
    
    .inner-title2 h3 {padding: 25px 0px 0px 0px;}
    .text_english { font-size: 10px !important; padding: 10px 10px!important;}
    .language.login-1 { margin-right: 50px; }
    .language_dropdown { margin: -11px 0px 0px 0px;}
    .mayar img { width: 65px; }
    .col-lg-8.col-md-8.col-sm-12.message-board{flex: 100% 1; max-width: 100%;}
    /*.container, .container-sm { max-width: 90% !important;}*/
    .faq {margin-top: 20px;padding: 0;}
    .site-menu-div{ display: none;} 
    .NavBar_container{ position: sticky;  z-index: 999; bottom: 0px;right: 0px;margin-top: 0;    }
    .text_bengali {font-size: 15px; padding: 20px 10px 10px !important; }
    .header { padding: 0px;z-index:20 !important;}
    .modal-open{overflow:hidden !important; }   
    .nav-menu { display: flex; flex-direction: column; justify-content: unset; width: 100%; border-top: 1pxsolid #fff; 
	position: absolute;  padding: 0px; text-align: left; left: -110%; opacity: 1; height: 100%; transition: all 0.5s ease; } 
    .nav-menu.active{ background: #302ba0; left: 0px; opacity: 1; transition: all 0.5s ease; z-index: 1;
    position: fixed; top: 0; padding-top: 17px; bottom: 0; width: 84%; }
    .font-site-mbl,.font-site{ display: block; }
    .nav-item-list .active { color: #ffdd40;  border: none;}
    .nav-links { padding:0px 31px !important;  width: 100%;  display: table; text-align: left !important; } 
    .nav-icon { display: block; position: fixed; top: -27px; right: -18px; transform: translate(-100%, 60%); font-size: 1.8rem;
      cursor: pointer; color: #ffdd40; }
   /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex{flex: 50%; max-width: 50%;} */
    .mayar {margin: 5px -8px 0px 0px;}
  
    
    .lg span {  font-size: 15px;  top: 18px;  }
    .header .logo img { width: 40px; }
    .mayar img { width:50px; }
    .header1 {line-height: 0px; }
    .search { margin:9px 0px 0px 0px; }
    .language {margin: -10px 0px 0px 0px; }
    .font-site {  width:auto; margin: 0px; }
    .message1 { font-size: 9px; }
    .message1 img { width: 59px;}   
    .carousel-caption{ text-align: left !important; }
    .head-part1 {  margin: 12px 0px 0px 0px;  float: right;}
    
    /* ======= Mega menu =========*/
    .header2 { z-index: 111; position: relative; padding: 0px; }
    .megamenu1 {padding: 0px; }
    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
    .megamenu1 .navbar{padding: 0px;}
    /* ======= Mega menu =========*/

    .white-bgtxt { width: 45%;}
    .col-6.white-bgtxt ul li { font-size: 10px; padding: 3px 0px;}
    .col-6.white-bgtxt h6 { font-size: 16px;}
    .site-menu nav ul li a i::before { font-size: 10px; }
    .site-menu nav ul li a { font-size: 9px !important;}
    .carousel-indicators {  bottom: 20px !important; }
    .swiper-slide { width: 200px !important;  margin-right: 40px !important; }
    .certificate1 ul li a {font-size: 11px; }
    .navbar-fixed{top: 66px; z-index: 11;}
    .navbar-fixed2{top:66px; padding: 4px 10px; height: auto; z-index: 11;}
    .help a img { width:117px; bottom:0px; right:13px; height:119px;}

    .Banner {margin-top:-76px; height:180px;}
    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:123px; width:100% !important;}
    .banner-container{height:190px;}
    .login-1 {margin: 0px 56px 0px 0px; }
	/*.search-div{display: none;}*/
    .site-menu nav ul li .btn {font-size: 11px !important;}

    .lang-set{width: auto !important;}
    .login-1{margin: -7px 0px 0px 0px !important;}
    .site-menu nav ul li .btn .bi-chevron-down::before{padding: 0px 0px 0px 8px;}
    .site-menu .nav_dropdown .nav-link{font-size: 9PX !important;}
    .site-menu .nav_dropdown .btn-link fontSizeClass :focus {text-decoration: none; box-shadow: none;}

    .dig-form{margin: 16px 0px 0px 0;}
    
}

@media screen and (max-width: 767px) {.hid {display: none;}}

@media screen and (max-width: 760px) {
    .hid {display: none;}
 /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex{flex: 45%; max-width: 45%;} */
  .NavBar_container{ position: sticky; z-index: 999; bottom: 0px; right: 0px; margin-top: 0;}
  .header { padding: 0px; z-index:20 !important;}
  .modal-open{overflow:hidden !important;}    
  .nav-menu { display: flex; flex-direction: column; justify-content: unset; width: 100%; border-top: 1px solid #fff;
   position: absolute; padding: 0px; text-align: left; left: -110%; opacity: 1; height: 100%; transition: all 0.5s ease;} 
  .nav-menu.active{
   background: rgba(0,0,0,0.9); left: 0px; opacity: 1; transition: all 0.5s ease; z-index: 1; position: fixed; top: 0; padding-top: 17px;
    bottom: 0; width: 85%; }
  .font-site-mbl, .font-site{ display: block;}
  .nav-item-list .active { color: #ffdd40; border: none;}
  .nav-links { padding:0px 31px !important; width: 100%; display: table; text-align: left !important;} 
  .nav-icon { display: block; position: fixed; top: -18px; right: -18px; transform: translate(-100%, 60%);
   font-size: 1.8rem; cursor: pointer; color: #ffdd40;}
   
  }

  @media screen and (max-width: 740px) { .hid {display: none;}}

  @media screen and (max-width: 700px) {  
    
    .hid {display: none;}
    .mayar { margin: 5px 0px 0px 0px;}
   /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 65% ;max-width: 65%;} */
    .nav-icon{right:14px;}
    .text_english {font-size:9px; }
    .text_bengali {font-size:7px !important;}
    .title2 h4{padding: 8px 0px 5px 30px;}
    .whats-new{ padding: 0px 0px 0px 0px;}

    .policy-img2{ height: 58px;}
    .policy-img2 span{font-size: 8px;}
    .policy-img2 h4 {line-height: 5px;}

    .navbar-fixed{display: none;}

    /* ======= Mega menu =========*/
    .header2 { z-index: 111; position: relative; padding: 0px; }
    .megamenu1 {padding: 0px; }
    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
    .megamenu1 .navbar{padding: 0px;}
    /* ======= Mega menu =========*/
 
    /* .about .about-img img {width: 100%; height: auto;}
    .about .about-img {margin:0px 0 0 0px; width: 100%;} */
    .NavBar_container{display: block;   }
    .help a img { width: 112px; top: -124px; height: 118px;}

    .Banner {margin-top: -76px; height:173px;}
    .Banner .carousel-item { width:100% !important; height:115px; top: 58px; margin-right: inherit !important; }
    .Banner .carousel-item img{height:115px; width:100% !important;}
    .banner-container{height:188px;}

    .carousel-caption {bottom: 60px !important; top:45% !important;
     padding-bottom: 0px !important; left: 8% !important;}
     .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}

     .navbar-fixed2{display: none;}
     .login-1 {margin: -7px 3px 0px 0px !important; }

     .head-part1 { margin: 12px 0px 0px 0px;}
     .section.inner-pad1{margin-top: 20px;}
  }
  

@media screen and (max-width: 600px) {
    
    .mayar { margin: 5px 0px 0px 0px;}  
    /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 65% ;max-width: 65%;} */
    .hid {display: none;}
    .head-part1 { margin: 12px 7px 0px 0px;}
    .nav-icon { right: 0px;}

    .text_english {font-size:9px; }
    .text_bengali {font-size:7px !important;}
    .title2 h4{padding: 8px 0px 5px 30px;}
    .whats-new{ padding: 0px 0px 0px 0px;}

    .policy-img2{ height: 58px;}
    .policy-img2 span{font-size: 8px;}
    .policy-img2 h4 {line-height: 5px;}

    .navbar-fixed{display: none;}
 
    /* .about .about-img img {width: 100%; height: auto;}
    .about .about-img {margin:0px 0 0 0px; width: 100%;} */
    .NavBar_container{display: block;   }
    .help a img { width: 80px; top: -89px; height: 84px; }
    .nav-menu.active{ width: 79%;}

    .carousel-caption {bottom: 60px !important; top:45% !important;
     padding-bottom: 0px !important; left: 8% !important;}
     .search-div{display: none;}
     .navbar-fixed2{display: none;}
     .login-1 {margin: -7px 120px 0px 0px !important;}

    /* ======= Mega menu =========*/
    .header2 { z-index: 111; position: relative; padding: 0px; }
    .megamenu1 {padding: 0px; }
    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
    .megamenu1 .navbar{padding: 0px;}
    /* ======= Mega menu =========*/

     .Banner {margin-top:-39px !important; height:196px !important;}
     .Banner .carousel-item { width:100% !important; height:130px !important; top:98px; margin-right: inherit !important; }
     .Banner .carousel-item img{height:99px !important; width:100% !important;}
     .banner-container{height:210px !important;}

     .hero2{ height: 185px !important;}
    .hero .carousel-item { width:100% !important; height:110px !important; top:29px; 
        margin-right: inherit !important; }
    .hero2 .carousel-item img{height:80px !important; width:100% !important;}

     .site-menu nav ul li a{ font-size: 13px !important;}
     .mayor-table{margin: 0px 0px 20px 0px;}
     .funct1{margin: 0px 0px 20px 0px;}
    body{padding-top:0px;}

    .login-1 { margin: -7px 0px 0px 0px !important;}
    .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}

}

@media (max-width:580px) {
    .login-1 { margin: -7px 120px 0px 0px;  }

    .hero2{ height: 185px !important;}
    .hero .carousel-item { width:100% !important; height:110px !important; top:29px; 
        margin-right: inherit !important; }
    .hero2 .carousel-item img{height:80px !important; width:100% !important;}
    
    .site-menu nav ul li a{ font-size: 13px !important;}
    .title2 h4{font-size: 12px; padding:10px 0px !important;}
    .mayor-table{margin: 0px 0px 20px 0px;}
    .funct1{margin: 0px 0px 20px 0px;}
    .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}

    .login-1  { margin: -7px 0px 0px 0px !important;}

    .inner-title2 h3 {font-size: 15px; font-weight: 600;}
    .mayor-table2 .table .table-bordered td {font-size: 12px;}

    .map2 a{width: 100% !important;}
    .whats-app h1{font-size: 11px;}
    .whats-app {margin: 25px 0px 20px 0px;}
}

@media screen and (max-width:480px) {
    .header1 {padding: 5px 0px 2px 0px;}

    .head-part1 .lang-set { margin: -62px 0px 0px 0px;}
    .swap-div{display:flex; flex-direction: column-reverse; }
    .section-title.mes-title h4{font-size: 20px !important;}
    .inner-title2 h3,
    .inner-title h3 { padding: 10px 0px 10px 0px; font-size: 17px; }
    .font-site{display: none;  }
    .nav-icon {  right:0px;} 

/*=====Banner=======*/
    .Banner {margin-top:-29px !important; height:117px !important;}
    .Banner .carousel-item { width:100% !important; height:60px !important; top: 57px; 
    margin-right: inherit !important; }
    .Banner .carousel-item img{height:60px !important; width:100% !important;}
    .banner-container{height:124px !important; margin-top: 0px;}
/*====Banner========*/   
.social-media {display: none;}
    .hero .carousel-item { width:100% !important; height:110px !important; top: 58px; 
        margin-right: inherit !important; }
    .hero2 .carousel-item img{height:80px !important; width:100% !important;}  
    .title2 h4{font-size: 12px; padding:10px 0px !important;}
    .mayor-table{margin: 0px 0px 20px 0px;}
    .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 70% 1;max-width: 70% !important;}
    .col-lg-5.col-md-5.col-sm-6{flex: 30% 1;max-width: 30%;}
    .text_english {font-size: 13px; padding: 10px !important; }
    .about{padding-bottom: 10px;}
    .hero2 { height: unset !important; }
    .whats-new { width: 93%; margin-left: auto; margin-right: auto;}
    .col-lg-5.col-md-5.col-sm-6.about{flex: 100% 1;max-width: 100%;}
    .faq{ padding: 0px 0px;}  
    .certificate1{ padding: 7px 13px; }
    body{ padding-top: 70px;}  
   .navbar-fixed2,.navbar-fixed{ display: none;}
   .NavBar_container{ display: block; }
   .help a img { top: 230px; right: 8px; }
   .language-mbl,.font-site-mbl{ display: block; margin-left: 31px; }
   .site-menu nav ul li .dropdown .btn { font-size: 11px !important; }
 
   .show_responsive,
   .responsive_menu{display: block;}
   ul.dropdown-menu.multi-level.min-height-400.show {height: 300px; overflow: scroll; z-index: 1 !important; }
.responsive_menu .card-body ul li a{font-weight: 500 !important; font-size: 13px !important;
    color: #302ba0 !important; border-bottom: 1px solid #E5E9EF !important; list-style: disc;
    display: inherit; list-style-position: inside;}
.show_responsive .dropdown-submenu>a:after{content:none !important;}
.mobile_menu_dropdown{overflow: visible;} 
button.btn.btn-link fontSizeClass .collapsed, .btn-link fontSizeClass :hover { padding: 10px; }
#accordion .card-body {padding: 0px 10px;}
#accordion .card-body ul{ padding: 0px 12px; font-size: 13px;}
#accordion .card-body ul li{    line-height: 22px;font-size: 13px;font-weight: 400;}
.dig-form {width: 94%;margin: 10px;}
.dig-login1 { width: 100%; margin: 0px; padding: 10px;}
.form-group.continu{display: flex;}
.dig-login1 .log-form .continu a {padding: 7px 16px;}
.inner-title3 h3 {padding: 0px; font-size: 13px;}
.about-head1 h5 { padding: 4px 10px; font-size: 11px; line-height: 18px; margin: 6px 0px 0px 0px;    }
.funct1 { margin: 20px 0;}
.footer .footer-content{padding: 20px 0px;}
.menu-slider .menu-slide-track {animation: scroll 8s linear infinite;}
.header-office_name{ display: flex; flex-direction: column; justify-content: center;}   
.mbl-login{ display: block;}
.login-1 {display: block !important; margin: -50px 0px 0px 140px !important; position: absolute;}
.carousel-indicators{bottom: 3px !important;}
.carousel-caption{ display: block !important;}
.carousel-caption.d-none.d-md-block h5 { font-size: 19px; }
.header-office_name p{margin: 0px ; }
.text_english{ font-size: 8px !important; }
.text_bengali{ font-size: 14px !important;  }

.mayar{right:57%; top: 0%;}
.logo span { color: #fff;}
.header .logo img { max-height: initial; width: 40px;}
.help a img { width: 60px;height: 60px;top: -63px;right: 10px;}
.search {margin: 20px 0px 0px 0px; width: 100%;}
.search .input-group { width: 100%;}
.fixed-top {position: inherit;}
.language {margin: 0px 20px 0px 0px;}
.font-site {margin: 8px 45px 0px 0px;}
.mobile-nav-toggle { background: rgba(var(--color-secondary-rgb), 0.9); color: #fff; 
    font-size: 33px; top: 14px; right: 7px;}

/* ======= Mega menu =========*/
.header2 { z-index: 111; position: relative; padding: 0px; }
.megamenu1 {padding: 0px; }
.megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
.megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
.megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}
.megamenu1 .navbar{padding: 0px;}

/* ======= Mega menu =========*/

.head-part1 { margin: 5px 0px 0px 0px;}
.about-img3{ padding: 9px 0px !important;}
.alert { display: none !important;}
.swiper {margin: 0px 0px 0px 10px;}
.service-item .img img { height: 80px;}
.hero { margin-top:-30px; min-height: unset;}
.section-main-heading2 { bottom: 0px;}
.site-menu nav ul li a { font-size: 11px !important;}
.faq .accordion-button { font-size: 10px;}
.faq .content h3 { font-size: 22px; padding: 10px 0px;}
.service-item { margin: 0px 0px 0px 0px;}
.about .about-img {margin:20px 0px 0px 0px;}
.mayar img { width:41px;}
.section-main-heading p span {font-size: 16px;}
.section-main-heading { margin: 0px 0px 20px 0px;}
.services .details .icon {margin: 0px 0px 0px 8px;}
.none-320 { display: none;}
.display-320 { display: block;}
.width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}

section { padding: 0px;}
.mayor-table table { margin: 0px 15px 0px 15px;}
.m-ta-2 table { margin: 0px 0px 0px 0px;}
.mayor-table { overflow-x: scroll;}
.mayor-table-column{padding: 6px !important;}
.inner-title3{ margin-top: 20px;}
.mayor{margin-top: 20px;}
.mayor-table2a .row{ justify-content: center;}
.menu-slider { margin: 0;}
.list-aggregate { padding: 0;}
.search{ display: none;}
.carousel-control-next-icon, .carousel-control-prev-icon{ display: none !important;}
.login-1 .dropdown-toggle,
.language .dropdown-toggle {padding: 2px 0px;font-size: 12px;width: 50px !important;}
.search-div{display: none;}


.language_dropdown { margin: 9px 6px 0px 0px; font-size: 11px !important; font-weight: normal !important;
     padding: 0px !important;}
.mayar img { width: 30px;margin-top: -2px;}
.nav-icon{ top: -16px;right: -18px;}
.form-select option{ padding: 8px 10px !important;}
.responsivemenudiv .dropdown-item:focus{background: none;}
.responsivemenudiv .nav-link:hover{background: none;}

.inner-title3 { margin-top: 0px; padding: 0px 20px 10px 24px;}

.map2 a{width: 100% !important;}
.whats-app h1{font-size: 11px;}
.whats-app {margin: 25px 0px 20px 0px;}

}



@media screen and (max-width: 320px){

body{margin: 0px; padding: 0px;}

.header1 {padding: 5px 0px 2px 0px;}

/* ======= Mega menu =========*/
.header2 { z-index: 1111111; position: relative; padding: 0px; }
.megamenu1 {padding: 0px; }
.megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}
.megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}
.megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);
    height:320px;  overflow-y: scroll; overflow-x: hidden; display: inline-block;
}

.megamenu1 .navbar{padding: 0px;}
.megamenu1 .navbar {z-index: 111111;}

/* ======= Mega menu =========*/

.social-media{top: 52%; display: none;}
.text_bengali{ font-size: 14px !important;}
.text_english{ font-size: 8px !important;}
.dig-login1 { margin: 10px 0 10px;}
.about-head1 h4 { font-size: 12px; line-height: 20px; text-align: justify !important;  }
.map2 a {width: 100%;}
.about-img2 p {line-height: 20px;}
.inner-log-form .col-lg-6.col-md-12.form-group {margin: 20px 10px !important;  }
.col-lg-12.about-head2{padding: 0;}
.about-img2 p,
.col-lg-12.about-head2 p {text-align: justify;}
tr.table-warning.table-bor-2 th,
table.table-bordered tbody tr td { font-size: 11px; }
table.table-bordered tbody tr td .nav-item{list-style-type:none ;}
.depart.Tender_batra {height: 300px; width:100%;overflow: scroll; }
.form-group.continu .btn-primary { font-size: 11px;padding: 0px 10px; }
.dig-login1 .log-form .form-group select { width: 100%; }
.form-group.continu{margin: 0px !important;}
.dig-login1 .log-form h3 { font-size: 14px;}
.dig-form .subheader { display: none !important; }
.section-main-heading2 { bottom: 12px; }
.col-lg-12 .about-head1, .dig-login1.dig-form, .about-head1, .col-lg-12.about-head2{margin-bottom: 20px;}
.inner-title h3,
.inner-title2 h3 {font-size: 15px; font-weight: 600;}


.search-div{display: none;}
.scrool-message{width: 100%; }
.section-main-heading p.main-heading-title { margin: 0;padding: 0px 0 0px;}
.responsive_menu .aos-init .aos-animate .aos-init.aos-animate {  border: 0;  margin-top: 0;}
.text_english {font-size: 8px !important; }
.mayar { right: 57%; top: 0%;}
.width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}

.Banner {margin-top:39px !important; height:108px !important;}
.Banner .carousel-item { width:100% !important; height:52px !important; top: 58px; 
 margin-right: inherit !important; }
 .Banner .carousel-item img{height:52px !important; width:100% !important;}
.banner-container{height:118px !important; margin-top: 0px;}

.hero .carousel-item { width:100% !important; height:110px !important; top: 58px; 
    margin-right: inherit !important; }
.hero2 .carousel-item img{height:80px !important; width:100% !important;}

.title2 h4{font-size: 12px; padding:10px 0px !important;}
.mayor-table{margin: 0px 0px 20px 0px;}

.funct1{margin: 0px 0px;}

.mayar img { width: 30px;margin-top: -2px;}
.nav-icon{ top: -16px;right: -18px;}
.form-select option{ padding: 8px 10px !important;}
.responsivemenudiv .dropdown-item:focus{background: none;}
.responsivemenudiv .nav-link:hover{background: none;}
.help a img { width:45px;  position: absolute; right:6px; top:-47px; bottom:1px; height:48px;}

.language_dropdown { margin: 9px 6px 0px 0px; font-size: 11px !important; font-weight: normal !important;
     padding: 0px !important;}
.head-part1 .lang-set{ margin: -62px -20px 0px 0px !important;}
.hero.hero2{margin-top: 40px;}

.map2 a{width: 100% !important;}
.whats-app h1{font-size: 11px;}
.whats-app {margin: 85px 0px 20px 0px;}

}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,MAAM,+BAA+B,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;;AAE5E,cAAc,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,GAAG,kBAAkB,EAAE,yBAAyB;IAC9G,sBAAsB,EAAE,UAAU,EAAE,cAAc,EAAE,eAAe,EAAE,uCAAuC,CAAC;AACjH,kBAAkB,gBAAgB,EAAE,2BAA2B,CAAC;AAChE,oBAAoB,gBAAgB,EAAE,cAAc,EAAE,iBAAiB;IACnE,aAAa,EAAE,qBAAqB,GAAG;;IAEvC,cAAc,eAAe,EAAE,cAAc,EAAE,yBAAyB,CAAC;;AAE7E,gBAAgB,cAAc,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,CAAC;AACpF,oBAAoB,WAAW,CAAC;AAChC,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,gBAAgB,WAAW,EAAE,aAAa,CAAC;AAC3C,QAAQ,sBAAsB,EAAE,sBAAsB,EAAE,eAAe,CAAC;;AAExE,yBAAyB,qBAAqB,EAAE,WAAW,CAAC;AAC5D,UAAU,8BAA8B;IACpC,sBAAsB,CAAC;;AAE3B;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;GACnB;GACA;IACC,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IAGtB,0BAA0B;IAC1B,oCAAoC;IAGpC,6CAA6C;GAC9C;GACA,mCAAmC;GASnC;IACC,OACkC,oBAAoB,EACjB,oBAAoB;IACzD,2BAA2B;IAC3B;IACA,OACmC,oBAAoB,EACjB,oBAAoB;IAC1D,4BAA4B;IAC5B;GACD;GACA;IAGC,4BAA4B;IAC5B;AACJ,UAAU,wBAAwB,CAAC;AACnC,oBAAoB,eAAe,CAAC;AACpC,UAAU,YAAY,CAAC;;AAEvB;eACe,yBAAyB,CAAC,qBAAqB;IAC1D,wCAAwC,CAAC,0BAA0B,CAAC,qBAAqB,CAAC;AAC9F,0BAA0B,uBAAuB,CAAC;AAClD,kBAAkB,6CAA6C,CAAC;AAChE;IAGI,4BAA4B,CAAC;AACjC,0BAA0B,QAAQ,gCAAgC,EAAE,CAAC;AACrE,wBAAwB,iCAAiC,CAAC;AAC1D,KAAK,4BAA4B,CAAC;AAClC,4BAA4B,wCAAwC,EAAE,gBAAgB,EAAE,qBAAqB,CAAC,cAAc,CAAC;AAC7H,cAAc,8BAA8B,CAAC;AAC7C,gBAAgB,wBAAwB,EAAE,gBAAgB,CAAC,kBAAkB,EAAE;AAC/E,MAAM,0BAA0B,CAAC,2BAA2B,CAAC;AAC7D,eAAe,2CAA2C,CAAC;AAC3D;6BAC6B,yBAAyB,CAAC,gBAAgB,CAAC;AACxE,kCAAkC,eAAe,EAAE,aAAa,EAAE,mBAAmB,CAAC;AACtF,yCAAyC,0BAA0B,CAAC,iBAAiB,CAAC;AACtF,6CAA6C,iCAAiC,CAAC,eAAe,CAAC;;AAE/F,iCAAiC,sBAAsB,CAAC;AACxD,iCAAiC,SAAS,EAAE,WAAW,CAAC;AACxD,wBAAwB,0BAA0B,CAAC,iBAAiB,CAAC,wBAAwB,EAAE,8BAA8B;AAC7H,qBAAqB,CAAC;AACtB;+DAC+D,yBAAyB,CAAC,mBAAmB,EAAE,2BAA2B,EAAE,qBAAqB;IAC5J,0BAA0B,EAAE,iCAAiC,CAAC;AAClE,+DAA+D,qBAAqB,EAAE,eAAe,CAAC;AACtG,0BAA0B,gBAAgB,CAAC,yBAAyB,EAAE;AACtE,kBAAkB,YAAY,EAAE,gBAAgB,CAAC;AACjD,gBAAgB,wBAAwB,CAAC,2BAA2B,CAAC,6BAA6B,CAAC;AACnG,0BAA0B,aAAa,CAAC;AACxC,0BAA0B,qBAAqB;IAC3C,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA,kBAAkB,aAAa,EAAE,gBAAgB,CAAC,kBAAkB,CAAC;AACrE;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;;AAEA;IACI;EACF;EACA;IACE;EACF;;AAEF;IACI,yDAAyC;IACzC,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,2CAA2C;IAC3C,wBAAwB;IACxB,mBAAmB;IACnB,+DAA+D;IAC/D,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;CACC,aAAa;AACd;AACA,gBAAgB;CACf;CACA;AACD,YAAY;CACX;CACA;AACD,mBAAmB;CAClB;CACA;AACD,0BAA0B;CACzB;AACD,MAAM;;AAEN,4CAA4C;AAC5C;IACI,UAAU,EAAE,gCAAgC;IAC5C,4DAA4D;EAC9D;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,sCAAsC,EAAE,4BAA4B;IACpE,kCAAkC,EAAE,uCAAuC;IAC3E,6BAA6B,EAAE,yDAAyD;EAC1F;;EAEA,2CAA2C;EAC3C;IACE;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;;AAGF;IACI,gCAAgC;IAChC,eAAe;IACf,QAAQ;IACR,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;GAEG;AACH;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;AACA;AACA,aAAa;AACb;AACA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;GAGG;;AAEH;IACI,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;;AAElC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;AACA,4BAA4B;AAC5B;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,WAAW,CAAC,eAAe;AAC/B;AACA;AACA,aAAa;AACb;AACA;IACI,aAAa;CAChB;CACA;IACG,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,wCAAwC;IACxC,uBAAuB;CAC1B;CACA;IACG,6BAA6B;IAC7B,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;;AAEpB;AACA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,wBAAwB,EAAE,YAAY,CAAC;;AAE3C;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY,EAAE,iBAAiB;AACnC;;;;AAIA,kCAAkC,eAAe;;;AAGjD;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY,EAAE,WAAW;AAC7B;;AAEA,6BAA6B,gBAAgB,CAAC;;AAE9C;IACI,oCAAoC;IACpC,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA,4BAA4B,YAAY,EAAE;;AAE1C;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB,EAAE,eAAe,EAAE,kBAAkB;IACrD,cAAc;IACd,gBAAgB;;AAEpB;AACA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;AACA,gCAAgC,WAAW,CAAC;;;AAG5C,wBAAwB,aAAa,CAAC;;AAEtC;IACI,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,8BAA8B;IAC9B,+DAA+D;IAC/D,kBAAkB;AACtB;AACA,8BAA8B,eAAe,EAAE;;AAE/C;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,wBAAwB;AAC5B;AACA,sBAAsB,UAAU,CAAC;AACjC,QAAQ,aAAa,CAAC;;;AAGtB;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;;;IAGI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;AAClB;;;;AAIA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,UAAU;AACd;;AAEA,aAAa,UAAU;AACvB,aAAa,2BAA2B;IACpC,0BAA0B;IAC1B,yBAAyB;IACzB,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B,CAAC,aAAa,EAAE,gBAAgB,CAAC;AAChE,YAAY,aAAa,EAAE,gBAAgB,CAAC;AAC5C,MAAM,eAAe,EAAE,sBAAsB,CAAC;AAC9C;iBACiB,aAAa,CAAC;AAC/B,qBAAqB,iBAAiB,CAAC,gBAAgB,EAAE,kBAAkB,EAAE;AAC7E,sBAAsB,iBAAiB,CAAC;AACxC;;+DAE+D,iBAAiB,CAAC,0BAA0B,CAAC,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,2BAA2B,CAAC;AACvN,8DAA8D,iBAAiB,CAAC,0BAA0B,CAAC,iBAAiB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,2BAA2B,CAAC;;AAEzN;IACI,SAAS;IACT,WAAW;IACX,qBAAqB;;IAErB,mBAAmB;IACnB,gBAAgB;;;AAGpB;AACA,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,oCAAoC,CAAC;AACvG,6CAA6C,aAAa,CAAC;;;;AAI3D;IACI,cAAc;IACd,uBAAuB;IAGvB,wDAAwD;IAExD,sBAAsB;IACtB,+BAA+B;IAC/B,6CAA6C;IAE7C,4EAA4E;IAC5E,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;;AAGA,4BAA4B;;CAE3B;IACG,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;;AAE9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;;;EAIA;IACE,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;IACP,gCAAgC;EAClC;;;EAGA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;IACZ,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;EACH;IACE,iBAAiB;AACrB;;EAEE;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,QAAQ;IACR,uBAAuB;IACvB,uDAAuD;EACzD;;;;EAIA;IACE,aAAa;EACf;;;;;;;AAOF,0BAA0B;;;;AAI1B;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iHAAiH;AACrH;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;IAGtB,qDAAqD;IAErD,sBAAsB;IACtB,+BAA+B;IAC/B,6CAA6C;IAE7C,kEAAkE;IAClE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,YAAY;IAEZ,aAAa;IAEb,uBAAuB;IAEvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,oDAAoD,gBAAgB,CAAC;AACrE,mEAAmE,gBAAgB,CAAC;AACpF,6DAA6D,gBAAgB,EAAE,YAAY,CAAC;AAC5F,sCAAsC,2BAA2B;IAC7D,wCAAwC;IACxC,uBAAuB,EAAE,aAAa,CAAC;;;AAG3C,sCAAsC,qBAAqB,EAAE,4BAA4B,EAAE;AAC3F,oBAAoB,oBAAoB,CAAC;;AAEzC;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;;;GAGG;;AAEH;IACI,gBAAgB;IAChB,WAAW;AACf;;;;AAIA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,eAAe;IACf,2BAA2B,EAAE,iCAAiC;IAC9D,sBAAsB;IACtB,mBAAmB,EAAE,2BAA2B,KAAK,aAAa;IAClE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe,KAAK,gBAAgB;IACpC,gBAAgB,CAAC,kBAAkB;IACnC,sCAAsC;IACtC,QAAQ;IACR,SAAS;AACb;;;AAGA,YAAY,eAAe;IACvB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,uBAAuB,CAAC;IACxB;AACJ,WAAW;IACP;;AAEJ;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,uCAAuC;IACvC,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B,uBAAuB;AACvB,mBAAmB;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,uCAAuC;AAC3C;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uCAAuC;AAC3C;AACA,mDAAmD,yBAAyB,EAAE,gBAAgB,CAAC;AAC/F;;;;;;;;EAQE;AACF;;IAEI,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;IAC3C,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;;;AAIA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;;AAGA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB,EAAE,YAAY,EAAE;;AAE7C;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,qBAAqB;IACrB,uBAAuB,CAAC,qBAAqB;AACjD;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;;;AAIA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,0DAA0D;IAC1D,sDAAsD;IACtD,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,UAAU;IACV,0DAA0D;IAC1D,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,wBAAwB;AAC5B;;;;AAIA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;;;AAIA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,+CAA+C;IAC/C,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;;;;;;;;AASA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;AACtB;;;;AAIA;IACI,YAAY;AAChB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;;IAEf,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,YAAY;AAChB;;;AAGA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;AACA;AACA,eAAe;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ,CAAC,0BAA0B;AACvC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;;AAEf;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,kCAAkC;IAClC,UAAU;IACV,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;;AAE7B;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,yCAAyC,kBAAkB,EAAE,WAAW,EAAE,oCAAoC,CAAC;AAC/G,2CAA2C,WAAW,CAAC;;AAEvD,sBAAsB,gBAAgB,CAAC;;AAEvC;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;GACZ,kBAAkB;;AAErB;;;;;AAKA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA,oBAAoB,iBAAiB,CAAC;AACtC;IACI,iBAAiB;IACjB,0BAA0B;;IAE1B,kCAAkC;;AAEtC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;AAC3C;;;;AAIA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,WAAW;AACf;;;;AAIA;IACI,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;AACtB;;;AAGA;;IAEI,0BAA0B;AAC9B;;;AAGA;;;;;;IAMI,gCAAgC;IAChC,oCAAoC;AACxC;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;AACA,oCAAoC,oCAAoC,CAAC,gBAAgB,CAAC;AAC1F,mDAAmD,kBAAkB,EAAE;AACvE,kCAAkC,qBAAqB,CAAC;AACxD;IACI,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAGlB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IAGjB,4BAA4B;AAChC;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,0CAA0C;AAC9C;;AAEA;;;IAGI,yBAAyB;IACzB,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,QAAQ;IACZ;;AAEJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB;AAChE;;AAcA;IACI;QAEI;IACJ;;IAEA;QAEI;IACJ;AACJ;;AAiDA;IACI;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QAEI;IACJ;AACJ;;AAgBA;;IAEI;;QAGI;IACJ;;IAEA;QAEI;IACJ;AACJ;;AAgBA;;IAEI;;QAGI;IACJ;;IAEA;QAEI;IACJ;AACJ;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAElB;AACJ;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;;;;;;IAMI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;IAII;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,+EAA+J;IAC/J;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,uCAAuC;IAC3C;AACJ;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;;;;;AAMA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,MAAM;IACN,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,YAAY;AAChB;;AAEA;IAGI,4BAA4B;AAChC;;;AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,+CAA+C,cAAc,CAAC;AAC9D,6CAA6C,yBAAyB,CAAC;;AAEvE;IACI,YAAY;IACZ,eAAe;AACnB;;;AAGA;;;IAGI,qBAAqB;IACrB,uCAAuC;IACvC,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,wBAAwB;IACxB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;;;;;GAKG;;AAEH;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;AACA,gBAAgB,mBAAmB,CAAC;;AAEpC;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,mBAAmB,2CAA2C,EAAE,SAAS,EAAE,gBAAgB,CAAC;AAC5F,6CAA6C,YAAY,EAAE,sBAAsB,CAAC;AAClF,0BAA0B,YAAY,EAAE,uBAAuB,CAAC;AAChE,8BAA8B,sBAAsB,EAAE,YAAY,EAAE,uBAAuB,CAAC;AAC5F;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB,CAAC;;;AAGxB;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;IACrC,eAAe;IACf,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,uCAAuC;AAC3C;AACA,4BAA4B,eAAe;IACvC,iBAAiB,CAAC;AACtB,kCAAkC,qBAAqB,CAAC;;AAExD;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,sBAAsB,uBAAuB,EAAE,2BAA2B,EAAE,yBAAyB,EAAE,4BAA4B,EAAE,2BAA2B,CAAC,0BAA0B,CAAC;;AAE5L;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA,eAAe,qBAAqB,CAAC;AACrC,yBAAyB,UAAU,CAAC;AACpC,UAAU,yBAAyB,EAAE,qBAAqB,EAAE,wBAAwB,KAAK;AACzF,gBAAgB,yBAAyB,CAAC;AAC1C,kCAAkC,yBAAyB,EAAE,qBAAqB,EAAE,eAAe;AACnG,gCAAgC,UAAU,CAAC;AAC3C,yCAAyC,UAAU,EAAE,gBAAgB,EAAE,gBAAgB,CAAC;AACxF,6CAA6C,2BAA2B,CAAC,YAAY,CAAC,0BAA0B,EAAE,yBAAyB,EAAE,gBAAgB,CAAC,gBAAgB,CAAC,2BAA2B,CAAC;AAC3M,2CAA2C,YAAY,EAAE;AACzD,qCAAqC,WAAW,CAAC;AACjD,yBAAyB,aAAa,EAAE,gBAAgB,CAAC;AACzD,kDAAkD,qBAAqB,CAAC;;AAExE,mBAAmB,gBAAgB,CAAC;;AAEpC,eAAe;AACf,iBAAiB,qBAAqB,EAAE,aAAa,EAAE,gCAAgC,EAAE;AACzF,mBAAmB,aAAa,EAAE,qBAAqB,CAAC;AACxD,0BAA0B,gBAAgB,GAAG,WAAW,CAAC;AACzD,aAAa,YAAY,CAAC;;AAE1B,+CAA+C,0BAA0B,EAAE,qBAAqB,EAAE;AAClG,wBAAwB,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,0BAA0B,CAAC;AACpG,8BAA8B,kBAAkB,CAAC;AACjD,4BAA4B,WAAW,CAAC;;;AAGxC,qBAAqB,yBAAyB,CAAC;AAC/C,8BAA8B,eAAe,EAAE,eAAe,CAAC;;AAE/D,6CAA6C,oBAAoB,EAAE,eAAe,EAAE;AACpF,4CAA4C,qBAAqB,CAAC;AAClE,8BAA8B,gBAAgB,CAAC;;AAE/C,yBAAyB,sBAAsB,CAAC;AAChD,UAAU,UAAU,EAAE,mBAAmB,EAAE,wBAAwB,CAAC;;;AAGpE,eAAe;AACf,yBAAyB,yBAAyB,CAAC;;;;AAInD,sCAAsC;AACtC,mCAAmC,0BAA0B,CAAC;AAC9D,WAAW,oCAAoC,EAAE,kBAAkB,CAAC;AACpE,YAAY,qBAAqB,EAAE;AACnC,SAAS,kBAAkB,EAAE,WAAW,CAAC;AACzC,cAAc,eAAe,EAAE,gBAAgB;IAC3C,iBAAiB,EAAE,sBAAsB;IACzC,qBAAqB;IACrB,wDAAwD;IACxD,WAAW,EAAE,gBAAgB,CAAC;AAClC,8BAA8B,gBAAgB,CAAC;AAC/C,cAAc;AACd,mCAAmC,0BAA0B,CAAC;AAC9D,YAAY,qBAAqB,EAAE;AACnC,SAAS,kBAAkB,EAAE,WAAW,CAAC;AACzC,cAAc,eAAe;IACzB,gBAAgB;IAChB,iBAAiB,EAAE,sBAAsB;IACzC,qBAAqB;IACrB,wDAAwD;IACxD,WAAW,EAAE,gBAAgB,CAAC;;AAElC,wBAAwB,aAAa,CAAC,CAAC,iCAAiC,gBAAgB,EAAE,WAAW,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,CAAC,uCAAuC,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,CAAC;AAChP,iCAAiC,YAAY,CAAC;AAC9C,yCAAyC,sBAAsB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACvG,yCAAyC,qBAAqB,CAAC;AAC/D,sCAAsC,qBAAqB,CAAC;AAC5D,OAAO,YAAY,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC7D,UAAU,gBAAgB,EAAE,iBAAiB,CAAC;AAC9C,aAAa,mBAAmB,CAAC,eAAe,CAAC;AACjD,8CAA8C,4BAA4B,CAAC;AAC3E,6BAA6B,gBAAgB;IACzC,eAAe;IACf,YAAY,EAAE,WAAW,CAAC;AAC9B,cAAc,8BAA8B,CAAC;;AAE7C,oDAAoD;;AAEpD,wBAAwB,aAAa,CAAC;AACtC,iCAAiC,gBAAgB,EAAE,WAAW,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB;EAC7G,uCAAuC,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,CAAC;EACzF,iCAAiC,YAAY,CAAC;EAC9C,yCAAyC,sBAAsB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACzG,yCAAyC,qBAAqB,CAAC;AAC/D,sCAAsC,qBAAqB,CAAC;AAC5D,OAAO,YAAY,GAAG,kBAAkB,EAAE,kBAAkB,EAAE;AAC9D,UAAU,gBAAgB,EAAE,iBAAiB,CAAC;;AAE9C,oDAAoD;AACpD,oDAAoD;AACpD,2BAA2B,qBAAqB,EAAE,iBAAiB,GAAG;AACtE,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,aAAa;AAC/E,gCAAgC,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,iBAAiB,CAAC;AAC1F,8CAA8C,eAAe,EAAE,cAAc,EAAE,iBAAiB,CAAC;AACjG,sDAAsD,kBAAkB,EAAE,gBAAgB,EAAE,WAAW,CAAC;AACxG,6DAA6D,WAAW,EAAE,WAAW,CAAC;AACtF,2DAA2D,eAAe,EAAE,qBAAqB;CAChG,SAAS,GAAG,YAAY,EAAE;CAC1B,YAAY,wBAAwB,CAAC;CACrC,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,aAAa;KAC/E,iBAAiB,CAAC;AACvB,4CAA4C,eAAe;;AAE3D,uBAAuB,kBAAkB,EAAE,yBAAyB,EAAE,aAAa;IAC/E,YAAY,EAAE,aAAa,EAAE,0BAA0B,CAAC;AAC5D,cAAc,kBAAkB,EAAE,yBAAyB;IACvD,aAAa,EAAE,YAAY,EAAE,aAAa,CAAC;AAC/C,gBAAgB,0BAA0B,EAAE;;CAE3C;oBACmB,yBAAyB,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,CAAC;CACjG,oCAAoC,eAAe;CACnD,mBAAmB,aAAa,CAAC;CACjC,WAAW,sBAAsB,EAAE;CACnC,kBAAkB,2BAA2B,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;CACnG,YAAY,aAAa,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,CAAC;CAC1F,UAAU,WAAW,CAAC;CACtB,SAAS,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,SAAS,EAAE,eAAe;IACjG,iBAAiB,GAAG,kBAAkB,EAAE,iFAAiF,CAAC;CAC7H,eAAe,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE,YAAY,CAAC;CACpG,oBAAoB,aAAa,CAAC;CAClC,uBAAuB,eAAe,EAAE,cAAc,EAAE,uBAAuB;IAC5E,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC9D,wBAAwB,cAAc,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;AACvF,6BAA6B,WAAW,CAAC;;AAEzC,YAAY,WAAW,EAAE,qBAAqB,CAAC;AAC/C,uCAAuC,UAAU,EAAE,qBAAqB;AACxE,eAAe,EAAE,yBAAyB,EAAE,eAAe,EAAE,gBAAgB;AAC7E,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACvD,sCAAsC,WAAW,EAAE,yBAAyB,EAAE;AAC9E,iCAAiC,WAAW,EAAE,gBAAgB,EAAE;AAChE,4BAA4B,6BAA6B,EAAE,WAAW,CAAC;;AAEvE,uCAAuC,iBAAiB,EAAE,WAAW,EAAE,sBAAsB,EAAE,cAAc,EAAE;AAC/G,kCAAkC,yBAAyB,EAAE,WAAW,EAAE,WAAW,EAAE,cAAc;IACjG,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;;AAG5G,cAAc,WAAW,EAAE;AAC3B,oBAAoB,eAAe,CAAC;AACpC,gCAAgC,YAAY,EAAE,mBAAmB,CAAC;AAClE,uCAAuC,WAAW,EAAE,WAAW,GAAG,WAAW,EAAE,iBAAiB;IAC5F,mBAAmB,EAAE,iBAAiB,EAAE,cAAc,EAAE,qBAAqB,CAAC;;AAElF,WAAW,aAAa,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AAC5E,eAAe,YAAY,CAAC;AAC5B,mBAAmB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,CAAC;AACnF,yBAAyB,WAAW,CAAC;;AAErC,6CAA6C,YAAY,EAAE,WAAW,CAAC;AACvE,uCAAuC,YAAY,EAAE,WAAW,CAAC;;AAEjE,+DAA+D,sBAAsB,CAAC;;AAEtF,QAAQ,oCAAoC,CAAC;;AAE7C,OAAO,8BAA8B,CAAC;;AAEtC,OAAO,8BAA8B,EAAE;;AAEvC,OAAO,8BAA8B,EAAE;;AAEvC,OAAO,8BAA8B,EAAE;;AAEvC,OAAO,8BAA8B,EAAE;;AAEvC,QAAQ,8BAA8B,CAAC;;AAEvC,OAAO,8BAA8B,EAAE;;AAEvC,OAAO,8BAA8B,EAAE;;;AAGvC,oDAAoD;;;;AAIpD,eAAe,WAAW,EAAE,WAAW,CAAC;AACxC,wBAAwB,yBAAyB,CAAC;;AAElD,oDAAoD;AACpD,OAAO,WAAW,CAAC;AACnB,qBAAqB,qBAAqB,CAAC;;AAE3C;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW,EAAE,gBAAgB;AACjC;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;GACG,sBAAsB;GACtB,qBAAqB;GACrB,oCAAoC;AACvC;AACA;GACG,kBAAkB;GAClB,WAAW;GACX,SAAS;GACT,gBAAgB;GAChB,cAAc;GACd,uCAAuC;AAC1C;AACA,sBAAsB,gBAAgB,EAAE,WAAW,EAAE,gCAAgC,CAAC;;AAEtF,uBAAuB,gBAAgB,EAAE,cAAc,EAAE,eAAe,CAAC;AACzE,6BAA6B,cAAc,EAAE,eAAe,EAAE,gBAAgB,CAAC;;AAE/E;GACG,cAAc,EAAE,eAAe;AAClC;AACA;GACG,WAAW;GACX,qBAAqB;GACrB,yBAAyB;AAC5B;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;GAClB,WAAW;GACX,OAAO;GACP,QAAQ;GACR,aAAa;AAChB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,WAAW;AACd;AACA,6BAA6B,YAAY,CAAC;;AAE1C,+DAA+D;;AAE/D;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,OAAO;AACX;;;AAGA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE,wBAAwB;AAChD;AACA,gCAAgC,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,yBAAyB,CAAC;AAChH,4BAA4B,WAAW,EAAE,WAAW,CAAC;;AAErD;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE,wBAAwB;AAChD;AACA,+BAA+B,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,wBAAwB,CAAC;AAC9G,2BAA2B,WAAW,EAAE,WAAW,CAAC;;AAEpD;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE,wBAAwB;AAChD;AACA,+BAA+B,kBAAkB,EAAE,UAAU,EAAE,mBAAmB,EAAE,wBAAwB,CAAC;AAC7G,2BAA2B,WAAW,EAAE,WAAW,CAAC;;;AAGpD;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE,wBAAwB;AAChD;;AAEA,gCAAgC,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,wBAAwB,CAAC;AAC/G,4BAA4B,WAAW,EAAE,WAAW,CAAC;;;AAGrD,kCAAkC,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,CAAC;AACvF,iCAAiC,eAAe,CAAC;AACjD,6BAA6B,eAAe,CAAC;;AAE7C,6DAA6D;AAC7D,mDAAmD,sBAAsB,CAAC;AAC1E;yCACyC,sBAAsB,CAAC;;AAEhE;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA,2DAA2D;AAC3D,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE,yBAAyB,CAAC;AAC3F,0CAA0C,sBAAsB,CAAC;;AAEjE,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,WAAW,EAAE,wBAAwB,CAAC;AAC5H,kDAAkD,sBAAsB,EAAE,eAAe,EAAE,wBAAwB,CAAC;;AAEpH,2DAA2D;;AAE3D,iBAAiB,WAAW,EAAE,iCAAiC,EAAE,iBAAiB,CAAC;AACnF,YAAY,YAAY,CAAC;AACzB,eAAe,iCAAiC,EAAE,kBAAkB,EAAE,2BAA2B,CAAC;AAClG,SAAS,UAAU,CAAC;AACpB,kBAAkB,mBAAmB;IACjC,eAAe;IACf,wBAAwB;IACxB,8BAA8B;IAC9B,iBAAiB,EAAE;AACvB,OAAO,eAAe,EAAE,iBAAiB,CAAC;AAC1C,aAAa,cAAc,CAAC;AAC5B,eAAe,aAAa,EAAE,kBAAkB,EAAE,qBAAqB,CAAC;AACxE,iBAAiB,UAAU,CAAC;AAC5B,UAAU,kBAAkB,CAAC;;AAE7B,sBAAsB,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE,wBAAwB,CAAC;AAC/F,YAAY,wBAAwB,CAAC;;AAErC,kBAAkB,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACvE,aAAa,eAAe,EAAE,kBAAkB,CAAC;;AAEjD,OAAO,0BAA0B,CAAC;AAClC,sCAAsC,cAAc,EAAE,iBAAiB,CAAC;;;;;;;;AAQxE,qEAAqE;;;AAGrE;IACI,2BAA2B,gBAAgB,CAAC;IAC5C,WAAW,UAAU,CAAC;AAC1B;AACA;CACC,qBAAqB,4BAA4B,EAAE;AACpD;;AAEA;;IAEI,+CAA+C,eAAe,CAAC;;IAE/D,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACxC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;;AAE1D;;AAEA;IACI,eAAe,0BAA0B,CAAC,CAAC;;AAE/C;IACI,eAAe,0BAA0B,CAAC;IAC1C,+CAA+C,eAAe,CAAC;;IAE/D,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACxC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;AAC1D;;AAEA;AACA,eAAe,0BAA0B,CAAC;AAC1C,WAAW,yBAAyB,CAAC;AACrC,+CAA+C,eAAe,CAAC;;AAE/D,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACpC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;;AAE1D;;AAEA;;IAEI,mDAAmD,eAAe,CAAC;IACnE,eAAe,0BAA0B,CAAC;IAC1C,WAAW,yBAAyB,CAAC;;IAErC,+BAA+B;GAChC,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;GAC3D,YAAY,YAAY,EAAE;GAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;GACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;GACnF,8BAA8B,uCAAuC,CAAC;GACtE,mBAAmB,YAAY,CAAC;GAChC,+BAA+B;GAC/B,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACvC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;;AAE1D;;;AAGA,oDAAoD;AACpD;AACA,cAAc,eAAe,CAAC,kCAAkC,CAAC,aAAa;IAC1E,iBAAiB,EAAE,oBAAoB;AAC3C,2BAA2B,UAAU,CAAC,SAAS;AAC/C;AACA,oDAAoD;;;AAGpD;IACI,eAAe,eAAe,CAAC;IAC/B,eAAe,eAAe,EAAE;IAChC,UAAU,yBAAyB,CAAC;GACrC,mEAAmE;GACnE,+BAA+B;GAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;GAC3D,YAAY,YAAY,EAAE;GAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;GACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;GACnF,6BAA6B,yBAAyB,EAAE,uCAAuC,CAAC;GAChG,mBAAmB,YAAY,CAAC;GAChC,+BAA+B;GAC/B,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACvC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;;AAE1D;;AAEA;IACI,eAAe,0BAA0B,CAAC;IAC1C,eAAe,0BAA0B,CAAC;CAC7C;;AAED;IACI,eAAe,0BAA0B,CAAC;IAC1C,eAAe,0BAA0B,CAAC;CAC7C;;AAED;AACA,YAAY,WAAW,CAAC;AACxB,SAAS,kCAAkC,CAAC;AAC5C,eAAe,0BAA0B,CAAC;;CAEzC,+BAA+B;CAC/B,WAAW,cAAc,EAAE,kBAAkB,EAAE,YAAY,EAAE;CAC7D,YAAY,YAAY,EAAE;CAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;CACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;CACnF,8BAA8B,yBAAyB,EAAE,uCAAuC,CAAC;CACjG,mBAAmB,YAAY,CAAC;CAChC,+BAA+B;;AAEhC,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACpC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,aAAa,WAAW,EAAE,YAAY,EAAE,aAAa,CAAC;;AAE1D;;AAEA;;IAEI,YAAY,WAAW,CAAC;IACxB,+BAA+B;IAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;IAC3D,YAAY,YAAY,EAAE;IAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;IACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;IACnF,6BAA6B,yBAAyB,EAAE,uCAAuC,CAAC;IAChG,mBAAmB,YAAY,CAAC;IAChC,+BAA+B;IAC/B,eAAe,0BAA0B,CAAC;IAC1C,cAAc,0BAA0B,CAAC;;;AAG7C;;AAEA;IACI,aAAa,wBAAwB,KAAK;IAC1C,0CAA0C,qBAAqB,CAAC;IAChE,cAAc,iBAAiB,CAAC,mBAAmB,CAAC;;IAEpD,kBAAkB,yBAAyB,CAAC;IAC5C,gBAAgB,0BAA0B,EAAE,4BAA4B,CAAC;IACzE,oBAAoB,kBAAkB,EAAE;IACxC,qBAAqB,yBAAyB,CAAC;IAC/C,aAAa,WAAW,EAAE;IAC1B,2CAA2C,YAAU,EAAE,eAAe,CAAC;IACvE,0DAA0D;IAC1D,MAAM,gBAAgB,CAAC,UAAU,CAAC;IAClC,gBAAgB,aAAa,CAAC;IAC9B,mBAAmB,gBAAgB,GAAG,YAAY,EAAE,WAAW,CAAC,UAAU,CAAC,aAAa,KAAK;IAC7F,eAAe,eAAe,EAAE,kCAAkC,EAAE;IACpE,UAAU,YAAY,CAAC,qBAAqB,CAAC;IAC7C,YAAY,0BAA0B,EAAE;IACxC,YAAY,aAAa,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,WAAW,EAAE,yBAAyB;CACpH,kBAAkB,GAAG,YAAY,EAAE,gBAAgB,EAAE,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE,yBAAyB,EAAE;IACpH,kBAAkB,mBAAmB,EAAE,SAAS,EAAE,UAAU,EAAE,yBAAyB,EAAE,UAAU;IACnG,eAAe,EAAE,MAAM,EAAE,iBAAiB,EAAE,SAAS,EAAE,UAAU,EAAE;IACnE,2BAA2B,cAAc,EAAE;IAC3C,yBAAyB,cAAc,GAAG,YAAY,CAAC;IACvD,aAAa,2BAA2B,GAAG,WAAW,GAAG,cAAc,EAAE,2BAA2B,EAAE;IACtG,YAAY,cAAc,EAAE,eAAe,EAAE,UAAU,EAAE,YAAY,EAAE,gCAAgC,EAAE,iBAAiB;MACxH,eAAe,EAAE,cAAc,EAAE;GACpC,2FAA2F;IAC1F,QAAQ,wBAAwB,CAAC;;;IAGjC,YAAY,eAAe,GAAG,SAAS,GAAG;IAC1C,oBAAoB,WAAW,EAAE;IACjC,aAAa,UAAU,EAAE;IACzB,UAAU,gBAAgB,EAAE;IAC5B,UAAU,sBAAsB,EAAE;IAClC,WAAW,yBAAyB,EAAE;IACtC,cAAc,UAAU,EAAE,WAAW,EAAE;IACvC,YAAY,cAAc,EAAE;IAC5B,gBAAgB,WAAW,CAAC;IAC5B,mBAAmB,2BAA2B,EAAE;IAChD,eAAe,wBAAwB,GAAG,YAAY,CAAC;;IAEvD,+BAA+B;IAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;IAC3D,YAAY,YAAY,EAAE;IAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;IACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;IACnF,8BAA8B,yBAAyB,EAAE,uCAAuC,CAAC;IACjG,mBAAmB,YAAY,CAAC;IAChC,+BAA+B;;IAE/B,eAAe,UAAU,CAAC;IAC1B,2BAA2B,eAAe,EAAE,gBAAgB,CAAC;IAC7D,wBAAwB,eAAe,CAAC;IACxC,mCAAmC,eAAe,EAAE;IACpD,yBAAyB,yBAAyB,CAAC;IACnD,wBAAwB,uBAAuB,EAAE;IACjD,gBAAgB,uBAAuB,GAAG,6BAA6B,EAAE;IACzE,uBAAuB,eAAe,EAAE;IACxC,cAAc,SAAS,EAAE,WAAW,CAAC;IACrC,eAAe,QAAQ,EAAE,iBAAiB,EAAE,YAAY,EAAE,WAAW,CAAC;IACtE,cAAc,WAAW,EAAE,UAAU,EAAE,UAAU,EAAE,YAAY,CAAC;;IAEhE,SAAS,gBAAgB,EAAE,YAAY,CAAC;IACxC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;IAC/B,UAAU,wBAAwB,EAAE;CACvC,8BAA8B;IAC3B,2BAA2B,0BAA0B,CAAC;;IAEtD,UAAU,sBAAsB,CAAC;IACjC,SAAS,mCAAmC,CAAC;IAC7C,mDAAmD,wBAAwB,CAAC;IAC5E,mCAAmC,yBAAyB,CAAC;IAC7D,yDAAyD,qBAAqB,EAAE,gBAAgB,CAAC;;IAEjG,UAAU,sBAAsB,CAAC;;AAErC;;AAEA,sCAAsC,MAAM,aAAa,CAAC,CAAC;;AAE3D;IACI,MAAM,aAAa,CAAC;CACvB,2FAA2F;EAC1F,mBAAmB,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,aAAa,CAAC;EAC1F,UAAU,YAAY,EAAE,qBAAqB,CAAC;EAC9C,YAAY,0BAA0B,CAAC;EACvC,YAAY,aAAa,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,WAAW,EAAE,0BAA0B;GACjH,kBAAkB,EAAE,YAAY,EAAE,gBAAgB,EAAE,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE,yBAAyB,CAAC;EACtH;GACC,2BAA2B,EAAE,SAAS,EAAE,UAAU,EAAE,yBAAyB,EAAE,UAAU,EAAE,eAAe,EAAE,MAAM,EAAE,iBAAiB;IACpI,SAAS,EAAE,UAAU,EAAE;EACzB,4BAA4B,cAAc,CAAC;EAC3C,yBAAyB,cAAc,EAAE,YAAY,CAAC;EACtD,aAAa,2BAA2B,EAAE,WAAW,EAAE,cAAc,EAAE,2BAA2B,CAAC;EACnG,YAAY,cAAc,EAAE,eAAe,EAAE,UAAU,EAAE,YAAY,EAAE,gCAAgC;GACtG,iBAAiB,EAAE,eAAe,EAAE,cAAc,CAAC;;EAEpD;;EAEA,uCAAuC,MAAM,aAAa,CAAC,CAAC;;EAE5D;;IAEE,MAAM,aAAa,CAAC;IACpB,SAAS,uBAAuB,CAAC;GAClC,4FAA4F;IAC3F,UAAU,UAAU,CAAC;IACrB,eAAe,aAAa,EAAE;IAC9B,eAAe,wBAAwB,CAAC;IACxC,WAAW,yBAAyB,CAAC;IACrC,YAAY,wBAAwB,CAAC;;IAErC,cAAc,YAAY,CAAC;IAC3B,kBAAkB,cAAc,CAAC;IACjC,iBAAiB,gBAAgB,CAAC;;IAElC,cAAc,aAAa,CAAC;;IAE5B,+BAA+B;IAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;IAC3D,YAAY,YAAY,EAAE;IAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;IACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;IACnF,8BAA8B,yBAAyB,EAAE,uCAAuC,CAAC;IACjG,mBAAmB,YAAY,CAAC;IAChC,+BAA+B;;IAE/B;0DACsD;IACtD,kBAAkB,cAAc,IAAI;IACpC,cAAc,YAAY,EAAE,WAAW,EAAE,aAAa,CAAC;;IAEvD,SAAS,iBAAiB,EAAE,YAAY,CAAC;IACzC,yBAAyB,qBAAqB,EAAE,YAAY,EAAE,SAAS,EAAE,gCAAgC,EAAE;IAC3G,2BAA2B,YAAY,EAAE,qBAAqB,CAAC;IAC/D,kBAAkB,YAAY,CAAC;;IAE/B,mBAAmB,uBAAuB,EAAE,kBAAkB;KAC7D,8BAA8B,EAAE,mBAAmB,CAAC;KACpD,UAAU,0BAA0B,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,CAAC;;KAE5F,eAAe,aAAa,CAAC;KAC7B,UAAU,mCAAmC,EAAE;;KAE/C,cAAc,wBAAwB,CAAC;KACvC,oBAAoB,gBAAgB,CAAC;EACxC;;;AAGF;;IAEI,SAAS,uBAAuB,CAAC;IACjC,4FAA4F;IAC5F,MAAM,aAAa,CAAC;IACpB,cAAc,wBAAwB,CAAC;IACvC,YAAY,UAAU,CAAC;;IAEvB,eAAe,aAAa,EAAE;IAC9B,eAAe,wBAAwB,CAAC;IACxC,WAAW,yBAAyB,CAAC;IACrC,YAAY,wBAAwB,CAAC;;IAErC,cAAc,YAAY,CAAC;IAC3B,kBAAkB,cAAc,CAAC;IACjC,iBAAiB,gBAAgB,CAAC;;IAElC,cAAc,aAAa,CAAC;;IAE5B;0DACsD;IACtD,kBAAkB,cAAc,IAAI;IACpC,cAAc,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE;IACrD,kBAAkB,UAAU,CAAC;;IAE7B,mBAAmB,uBAAuB,EAAE,kBAAkB;KAC7D,8BAA8B,EAAE,mBAAmB,CAAC;KACpD,YAAY,aAAa,CAAC;KAC1B,eAAe,aAAa,CAAC;KAC7B,UAAU,qCAAqC,CAAC;;IAEjD,+BAA+B;IAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;IAC3D,YAAY,YAAY,EAAE;IAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;IACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;IACnF,8BAA8B,yBAAyB,EAAE,uCAAuC,CAAC;IACjG,mBAAmB,YAAY,CAAC;IAChC,+BAA+B;;KAE9B,SAAS,2BAA2B,EAAE,uBAAuB,CAAC;KAC9D,yBAAyB,qBAAqB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gCAAgC,EAAE;KACrH,2BAA2B,sBAAsB,EAAE,qBAAqB,CAAC;KACzE,kBAAkB,uBAAuB,CAAC;;KAE1C,QAAQ,wBAAwB,CAAC;IAClC,uBAAuB,qBAAqB,EAAE,uBAAuB,EAAE,QAAQ;QAC3E,gCAAgC,EAAE;IACtC,0BAA0B,sBAAsB,EAAE,qBAAqB,CAAC;;KAEvE,wBAAwB,0BAA0B,CAAC;KACnD,aAAa,wBAAwB,CAAC;KACtC,QAAQ,wBAAwB,CAAC;IAClC,KAAK,eAAe,CAAC;;IAErB,WAAW,mCAAmC,CAAC;IAC/C,UAAU,0BAA0B,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,CAAC;;AAEhG;;AAEA;IACI,WAAW,0BAA0B,GAAG;;IAExC,QAAQ,wBAAwB,CAAC;IACjC,uBAAuB,qBAAqB,EAAE,uBAAuB,EAAE,QAAQ;QAC3E,gCAAgC,EAAE;IACtC,0BAA0B,sBAAsB,EAAE,qBAAqB,CAAC;;IAExE,wBAAwB,0BAA0B,CAAC;IACnD,WAAW,eAAe,EAAE,2BAA2B,CAAC;IACxD,aAAa,wBAAwB,CAAC;IACtC,QAAQ,wBAAwB,CAAC;IACjC,UAAU,0BAA0B,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,CAAC;;IAE5F,YAAY,mCAAmC,CAAC;;IAEhD,kBAAkB,eAAe,EAAE,gBAAgB,CAAC;IACpD,yCAAyC,eAAe,CAAC;;IAEzD,QAAQ,sBAAsB,CAAC;IAC/B,cAAc,eAAe,CAAC;IAC9B,YAAY,yBAAyB,CAAC;AAC1C;;AAEA;IACI,UAAU,wBAAwB,CAAC;;IAEnC,wBAAwB,yBAAyB,CAAC;IAClD,UAAU,YAAY,EAAE,8BAA8B,EAAE;IACxD,4BAA4B,0BAA0B,CAAC;IACvD;sBACkB,0BAA0B,EAAE,eAAe,EAAE;IAC/D,WAAW,aAAa,GAAG;IAC3B,aAAa,SAAS,CAAC;;AAE3B,qBAAqB;IACjB,SAAS,2BAA2B,EAAE,uBAAuB,CAAC;IAC9D,yBAAyB,qBAAqB,EAAE,sBAAsB,EAAE,SAAS;IACjF,gCAAgC,EAAE;IAClC,2BAA2B,sBAAsB,EAAE,qBAAqB,CAAC;IACzE,kBAAkB,uBAAuB,EAAE,eAAe,CAAC;AAC/D,qBAAqB;AACrB,eAAe,aAAa,CAAC;IACzB,uBAAuB,qBAAqB,EAAE,uBAAuB,EAAE,SAAS;QAC5E,gCAAgC,EAAE;IACtC,0BAA0B,sBAAsB,EAAE,qBAAqB,CAAC;IACxE,WAAW,eAAe,EAAE,2BAA2B,CAAC;IACxD,aAAa,wBAAwB,CAAC;IACtC,4DAA4D,WAAW,CAAC,yBAAyB,CAAC;IAClG,4BAA4B,WAAW,CAAC,cAAc,CAAC;IACvD,eAAe,eAAe,EAAE,wBAAwB,EAAE;IAC1D,OAAO,oBAAoB,CAAC;IAC5B,SAAS,wBAAwB,EAAE;IACnC,aAAa,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,CAAC;IAC/D,kCAAkC,YAAY,CAAC,eAAe,CAAC;IAC/D,MAAM,gBAAgB,CAAC;IACvB,eAAe,iBAAiB,EAAE;IAClC,MAAM,iBAAiB,CAAC;GACzB,8BAA8B,aAAa,CAAC;GAC5C,mBAAmB,cAAc,EAAE;GACnC,cAAc,UAAU,EAAE,UAAU,EAAE;GACtC,8BAA8B,cAAc,EAAE,iBAAiB,EAAE;GACjE,sCAAsC,0BAA0B,EAAE;;GAElE;oBACiB,cAAc,CAAC;GAChC,kDAAkD,aAAa,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC7G,oCAAoC,2BAA2B,EAAE,0BAA0B;IACvF,yBAAyB,EAAE,2CAA2C,EAAE,gBAAgB;IACxF,gBAAgB,EAAE,2BAA2B,CAAC;AAClD,2CAA2C,uBAAuB,CAAC;AACnE,sBAAsB,iBAAiB,CAAC;AACxC,+EAA+E,aAAa,EAAE;AAC9F,uBAAuB,iBAAiB,CAAC;AACzC,0BAA0B,iBAAiB,EAAE,eAAe,CAAC;AAC7D,gCAAgC,iBAAiB,CAAC,eAAe,CAAC,gBAAgB,CAAC;AACnF,WAAW,UAAU,CAAC,YAAY,CAAC;AACnC,cAAc,WAAW,EAAE,WAAW,EAAE,aAAa,CAAC;AACtD,oBAAoB,aAAa,CAAC;AAClC,kCAAkC,iBAAiB,CAAC;AACpD,kBAAkB,YAAY,EAAE,eAAe,CAAC;AAChD,kBAAkB,iBAAiB,EAAE,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,KAAK;AACrG,UAAU,cAAc,CAAC;AACzB,wBAAwB,iBAAiB,CAAC;AAC1C,gCAAgC,oCAAoC,CAAC;AACrE,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,CAAC;AACpF,YAAY,cAAc,CAAC;AAC3B,UAAU,yBAAyB,EAAE,sCAAsC,EAAE,kBAAkB,CAAC;AAChG,qBAAqB,sBAAsB,CAAC;AAC5C,mBAAmB,yBAAyB,CAAC;AAC7C,yCAAyC,eAAe,EAAE;AAC1D,sBAAsB,YAAY,EAAE;AACpC,eAAe,yBAAyB,EAAE;AAC1C,eAAe,0BAA0B,GAAG;;AAE5C,OAAO,SAAS,EAAE,OAAO,CAAC;AAC1B,aAAa,WAAW,CAAC;AACzB,oBAAoB,mBAAmB,EAAE,WAAW,CAAC;AACrD,cAAc,WAAW,CAAC,YAAY,CAAC,UAAU,CAAC,WAAW,CAAC;AAC9D,SAAS,wBAAwB,EAAE,WAAW,CAAC;AAC/C,uBAAuB,WAAW,CAAC;AACnC,YAAY,iBAAiB,CAAC;AAC9B,WAAW,wBAAwB,CAAC;AACpC,YAAY,wBAAwB,CAAC;AACrC,qBAAqB,iDAAiD,EAAE,WAAW;IAC/E,eAAe,EAAE,SAAS,EAAE,UAAU,CAAC;;AAE3C,+BAA+B;AAC/B,WAAW,YAAY,EAAE,kBAAkB,EAAE,YAAY,EAAE;AAC3D,YAAY,YAAY,EAAE;AAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;AACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;AACnF,8BAA8B,yBAAyB,EAAE,uCAAuC,CAAC;AACjG,mBAAmB,YAAY,CAAC;;AAEhC,+BAA+B;;AAE/B,cAAc,uBAAuB,CAAC;AACtC,aAAa,2BAA2B,CAAC;AACzC,SAAS,wBAAwB,CAAC;AAClC,SAAS,wBAAwB,CAAC;AAClC,yBAAyB,YAAY,CAAC;AACtC,QAAQ,gBAAgB,EAAE,iBAAiB,CAAC;AAC5C,yBAAyB,WAAW,CAAC;AACrC,yBAAyB,0BAA0B,CAAC;AACpD,yBAAyB,eAAe,CAAC;AACzC,mBAAmB,eAAe,EAAE,iBAAiB,CAAC;AACtD,gBAAgB,uBAAuB,CAAC;AACxC,mBAAmB,uBAAuB,CAAC;AAC3C,aAAa,UAAU,CAAC;AACxB,8BAA8B,eAAe,CAAC;AAC9C,wBAAwB,wBAAwB,CAAC;AACjD,0BAA0B,uBAAuB,CAAC;AAClD,YAAY,aAAa,CAAC;AAC1B,eAAe,cAAc,CAAC;AAC9B,UAAU,0BAA0B,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,CAAC;;AAE5F,UAAU,YAAY,CAAC;AACvB,qBAAqB,yBAAyB,CAAC;AAC/C,gBAAgB,uBAAuB,CAAC;AACxC,eAAe,kBAAkB,CAAC;AAClC,oBAAoB,uBAAuB,CAAC;AAC5C,eAAe,gBAAgB,CAAC;AAChC,OAAO,gBAAgB,CAAC;AACxB,qBAAqB,uBAAuB,CAAC;AAC7C,eAAe,SAAS,CAAC;AACzB,kBAAkB,UAAU,CAAC;AAC7B,SAAS,aAAa,CAAC;AACvB,0DAA0D,wBAAwB,CAAC;AACnF;4BAC4B,gBAAgB,CAAC,eAAe,CAAC,sBAAsB,CAAC;AACpF,YAAY,aAAa,CAAC;;;AAG1B,qBAAqB,uBAAuB,EAAE,0BAA0B,EAAE,8BAA8B;KACnG,uBAAuB,CAAC;AAC7B,aAAa,WAAW,CAAC,gBAAgB,CAAC;AAC1C,WAAW,UAAU,CAAC,YAAY,CAAC;AACnC,qBAAqB,4BAA4B,CAAC;AAClD,wCAAwC,gBAAgB,CAAC;AACzD,mCAAmC,gBAAgB,CAAC;;AAEpD,gBAAgB,eAAe,EAAE,2BAA2B,CAAC;;AAE7D,QAAQ,sBAAsB,CAAC;AAC/B,cAAc,eAAe,CAAC;AAC9B,YAAY,yBAAyB,CAAC;;AAEtC;;;;AAIA;;AAEA,KAAK,WAAW,EAAE,YAAY,CAAC;;AAE/B,UAAU,wBAAwB,CAAC;;AAEnC,+BAA+B;AAC/B,WAAW,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE;AAC/D,YAAY,YAAY,EAAE;AAC1B,2CAA2C,WAAW,EAAE,eAAe,CAAC;AACxE,yCAAyC,WAAW,EAAE,4BAA4B,CAAC;AACnF,8BAA8B,yBAAyB,EAAE,uCAAuC;IAC5F,YAAY,GAAG,kBAAkB,EAAE,kBAAkB,EAAE,qBAAqB;AAChF;;AAEA,mBAAmB,YAAY,CAAC;AAChC,oBAAoB,eAAe,CAAC;;AAEpC,+BAA+B;;AAE/B,cAAc,QAAQ,EAAE,aAAa,CAAC;AACtC,eAAe,0BAA0B,CAAC;AAC1C,eAAe,yBAAyB,CAAC;AACzC,cAAc,mBAAmB,CAAC;AAClC,kBAAkB,eAAe,EAAE,iBAAiB,EAAE,8BAA8B,GAAG;AACvF,SAAS,WAAW,CAAC;AACrB,eAAe,iBAAiB,CAAC;AACjC,gDAAgD,4BAA4B,GAAG;AAC/E,uBAAuB,UAAU,CAAC;AAClC;0BAC0B,mBAAmB,CAAC;AAC9C;mCACmC,eAAe,EAAE;AACpD,2CAA2C,qBAAqB,CAAC;AACjE,sBAAsB,aAAa,EAAE,UAAU,CAAC,gBAAgB,EAAE;AAClE,mCAAmC,eAAe,CAAC,iBAAiB,EAAE;AACtE,2CAA2C,WAAW,EAAE;AACxD,oBAAoB,sBAAsB,CAAC;AAC3C,2BAA2B,eAAe,CAAC;AAC3C,uBAAuB,wBAAwB,EAAE;AACjD,yBAAyB,YAAY,EAAE;AACvC,oFAAoF,mBAAmB,CAAC;AACxG;kBACkB,eAAe,EAAE,gBAAgB,CAAC;;;AAGpD,YAAY,aAAa,CAAC;AAC1B,gBAAgB,WAAW,EAAE;AAC7B,6CAA6C,SAAS,CAAC,kBAAkB,CAAC;AAC1E,iEAAiE,SAAS,GAAG,aAAa,CAAC;AAC3F,eAAe,yBAAyB,EAAE;AAC1C,SAAS,UAAU,EAAE,OAAO,CAAC;AAC7B,UAAU,0BAA0B,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,CAAC;;AAE5F,SAAS,0BAA0B,EAAE,uBAAuB,CAAC;AAC7D,yBAAyB,qBAAqB,EAAE,sBAAsB,EAAE,SAAS;CAChF,gCAAgC,EAAE;CAClC,2BAA2B,sBAAsB,EAAE,qBAAqB,CAAC;AAC1E,kBAAkB,uBAAuB,EAAE,eAAe,CAAC;;AAE3D,uBAAuB,qBAAqB,EAAE,uBAAuB,EAAE,SAAS;IAC5E,gCAAgC,EAAE;AACtC,0BAA0B,sBAAsB,EAAE,qBAAqB,CAAC;;AAExE,WAAW,eAAe,EAAE,2BAA2B,CAAC;AACxD,aAAa,wBAAwB,CAAC;;AAEtC,QAAQ,eAAe,CAAC;;AAExB,aAAa,WAAW,CAAC,gBAAgB,CAAC;AAC1C,WAAW,UAAU,CAAC,YAAY,CAAC;AACnC,qBAAqB,4BAA4B,CAAC;AAClD,wCAAwC,gBAAgB,CAAC;AACzD,mCAAmC,gBAAgB,CAAC;AACpD,cAAc,UAAU,GAAG,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,CAAC;;AAE7F,qBAAqB,uBAAuB,EAAE,0BAA0B,EAAE,8BAA8B;KACnG,uBAAuB,CAAC;AAC7B,uBAAuB,sCAAsC,CAAC;AAC9D,YAAY,gBAAgB,CAAC;;AAE7B,QAAQ,sBAAsB,CAAC;AAC/B,cAAc,eAAe,CAAC;AAC9B,YAAY,yBAAyB,CAAC;;AAEtC","sourcesContent":["body {font-family: Poppins !important;padding-top: 77px;text-align: justify;}\n\n.searchResult{z-index: 11111; position: absolute; max-height:200px;  overflow-x: hidden; padding: 0px 0px 20px 0px;\n    background-color: #fff; width: 93%; color: #302ba0; cursor: default; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n.searchResult ul {list-style: none; padding: 0px 10px 20px 13px;}\n.searchResult ul a {list-style: none; font-size:13px; line-height: 30px; \n    color:#70757a; text-decoration: none;  }\n\n    .whats-app h1{display: inline; color: #302ba0; padding: 0px 0px 0px 20px;}\n\n.whats-app2 h3 {color: #302ba0; text-align: center; font-size:20px; display: inline;}\n.whats-app2 h3 span{color: #000;}\n.whats-app2{display: table; margin: 0px auto; }\n.whats-app2 img{width:270px; height: 250px;}\n.whats1{width:250px !important; height:80px !important; display: inline;}\n\n.searchResult ul a:hover{text-decoration: none; color: #000;}\n.ser-log1{background: #302ba0 !important;\n    color: #fff !important;}\n\n.scroolMessage {\n    height: 25px;\t\n    overflow: hidden;\n    position: relative;\n   }\n   .scroolMessage span {\n    white-space: nowrap;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    line-height: 25px;\n    text-align: center;\n    /* Starting position */\n    -moz-transform:translateX(100%);\n    -webkit-transform:translateX(100%);\t\n    transform:translateX(100%);\n    /* Apply animation to this element */\t\n    -moz-animation: scroolMessage 320s linear infinite;\n    -webkit-animation: scroolMessage 320s linear infinite;\n    animation: scroolMessage 320s linear infinite;\n   }\n   /* Move it (define the animation) */\n   @-moz-keyframes scroolMessage {\n    0%   { -moz-transform: translateX(100%); }\n    100% { -moz-transform: translateX(-500%); }\n   }\n   @-webkit-keyframes scroolMessage {\n    0%   { -webkit-transform: translateX(100%); }\n    100% { -webkit-transform: translateX(-500%); }\n   }\n   @keyframes scroolMessage {\n    0%   { \n    -moz-transform: translateX(100%); /* Firefox bug fix */\n    -webkit-transform: translateX(100%); /* Firefox bug fix */\n    transform: translateX(100%); \t\t\n    }\n    100% { \n    -moz-transform: translateX(-500%); /* Firefox bug fix */\n    -webkit-transform: translateX(-500%); /* Firefox bug fix */\n    transform: translateX(-500%); \n    }\n   }\n   .scroolMessage span:hover {\n    -moz-animation-play-state: paused;\n    -webkit-animation-play-state: paused;\n    animation-play-state: paused;\n    }\n.width-30{max-width:25% !important;}\n.width-30 .nav-link{font-size: 12px;}\n.swap-div{display:flex;}\n\n.quick_links .btn-link .fontSizeClass ,\n.quick_links a{color: #007bff !important;text-decoration: none;\n    background-color: transparent !important;font-size: 12px !important;padding: 0 !important;}\n.quick_links .card-header{background: transparent;} \n.marquee-vertical{animation: moveSlideshow 300s linear infinite;}\n.marquee-vertical:hover{\n    -moz-animation-play-state: paused;\n    -webkit-animation-play-state: paused;\n    animation-play-state: paused;}\n@keyframes moveSlideshow {100% {  transform: translateY(-66.6666%); }}\n.site-menu .card-header{background-color: #fff !important;}\n.p-0{padding: 0px 10px !important;}\n.drop-footer .dropdown-item{color: rgba(var(--color-white-rgb), 0.7); transition: 0.3s; display: inline-block;line-height: 1;}\n.para_text p {text-align: justify !important;}\n.min-height-800{height: 800px !important; overflow: scroll;overflow-x: hidden; }\n.f-11{font-size: 11px !important;font-weight: 500 !important;}\n.border_bottom{border-bottom: 1px solid #727272 !important;}\n.nav-item.nav_dropdown,\n.nav-item-list.nav_dropdown{ color: #302ba0 !important;list-style: disc;}\n#accordion .card-body .card-body {font-size: 13px; padding: 0px ; padding-bottom: 0px;}\n.nav_dropdown .nav_dropdown .card-body a{font-size: 10px !important;line-height: 30px;}\n.nav_dropdown .card-header.responsiveheader {background-color: #fff !important;font-size: 13px;}\n\n.nav_dropdown .responsivemenudiv{background-color: #fff;}\n.nav_dropdown #accordion .card { border: 0; margin: 0px;}\n.nav_dropdown .nav-link{font-size: 17px !important;line-height: 20px;padding: 5px 5px 0px 0px; border-bottom: none !important; \ntext-decoration: none;}\n.nav_dropdown .responsiveheader .btn-link fontSizeClass,\n.nav_dropdown .responsiveheader .btn-link fontSizeClass :hover{color: #302ba0 !important;padding: .5rem 0rem; font-weight: 500 !important; list-style-type: disc;\n    font-size: 13px !important; background-color: #fff !important;}\n.nav_dropdown .responsiveheader .btn-link fontSizeClass :focus{text-decoration: none; box-shadow:none;}\n.bi-chevron-down::before {content: \"\\f282\";color: #302ba0 !important; }\n.banner-container{height:200px; margin-top: 39px;}\n.min-height-400{height: 300px !important;overflow: scroll !important;overflow-x: hidden !important;}\n.section-main-heading2 h4{display: none;}\n.card .card-header h5{    padding: 0 !important;\n    font-size: 13px !important;\n    background: #fff !important;\n    line-height: 0px !important;\n    margin: 0px !important;\n}\n.Schedule_Of_Fees{height: 400px; overflow: scroll;overflow-x: hidden;}\n.menuList ul li{\n    list-style-type: none;\n}\n.menuList ul{\n    padding: 0;\n}\n.mbl-login{\n    display: none;\n}\n\n.text_english{\n    font-size:19px\n  }\n  .text_bengali{\n    font-size: 23px \n  }\n\nmain {\n    background-image: url(../img/hero-bg.png);\n    background-size: cover;\n    background-position: 50%;\n}\n\n.header {\n    padding: 0px;\n    /* z-index: -30 !important; */\n}\n\n.row {\n    padding: 0px;\n}\n\n.header1 {\n    float: left;\n    width: 100%;\n    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);\n    padding: 5px 0px 8px 0px;\n    background: #302ba0;\n    background: -moz-linear-gradient(top, #f6f6fe 0%, #ffffff 100%);\n    height: auto;\n    line-height: 20px;\n}\n\n.header .logo img {\n    position: relative;\n    margin: 1px 0px 0px 0px;\n    margin-right: 0px;\n    max-height: inherit;\n    width: 48px;\n}\n\n.header2 {\n    background-color: rgba(0, 0, 0, 0.8);\n    display: inline-block;\n    width: 100%;\n    padding: 2px 0px;\n}\n\n.lg span {\n    display: inline-block;\n    color: #fff;\n    padding: 3px 0px 4px 10px;\n    font-weight: bold;\n    font-size: 22px;\n    position: relative;\n    top: 7px;\n}\n /* new css  */\n.arrow_icon{\nmargin-left: 8px;\n }\n .heading-1{\npadding: 0px;\n }\n .head-part1{\nalign-items: center;\n }\n .message_board-card{\nmargin-top: 0px !important;\n }\n/* p */\n\n/* Define the initial state of the element */\n.vertical-animation {\n    opacity: 0; /* Start with opacity set to 0 */\n    /* transform: translateY(20px); Move the element 20px down */\n  }\n  \n  /* Apply the AOS animation class */\n  [data-aos=\"fade-up\"] {\n    animation-name: fadeUp;\n    animation-timing-function: ease-in-out; /* Specify timing function */\n    animation-delay: 50000s !important; /* Specify animation delay, if needed */\n    animation-iteration-count: 10; /* Specify the number of times the animation should run */\n  }\n  \n  /* Define the keyframes for the animation */\n  @keyframes fadeUp {\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n\n.navbar-fixed{\n    background-color:rgba(0,0,0,0.7);\n    position: fixed;\n    top:77px;\n    width: 100% !important;\n    z-index: 999;\n    padding: 0px 10px;\n}\n\n/* .hero2 .carousel-item img{\nheight: 120px;\n} */\n.navbar-fixed2{\n    background-color: #0d0d0e;\n    opacity: 0.9;\n    height: 40px;\n    position: fixed;\n    top:77px;\n    width: 100% !important;\n    z-index: 999;\n    padding: 0px 10px;\n}\n.NavBar_container{\ndisplay: none;\n}\n.nav-scroll-link{\n    font-size: 13px;\n    color: white;\n    text-decoration: none;\n    text-transform: uppercase;\n}\n.nav-scroll-link:hover{\n    font-size: 13px;\n    color: white;\n    font-weight: bold;\n}\n\n/* .carousel-item-img{\n  height: 220px;\n  max-height: 500px;\n} */\n\n.carousel-caption {\n    bottom: 60px !important;\n    top: 48% !important;\n    padding-bottom: 0px !important;\n    \n}\n\n.Banner{\n    position: relative;\n}\n\n.list-aggregate{\npadding-left: 0px !important;\n}\n\n\n.lg p {\n    color: #fff;\n    padding: 7px 0px 0px 10px;\n    font-weight: bold;\n    margin: 0px;font-size: 18px;\n}\n.font-site-mbl{\ndisplay: none;\n}\n.language-mbl{\n    display: none;\n }\n .language_dropdown{\n    font-weight: 600;\n    color: #fff;\n    font-size: 13px;\n    padding: 4px 10px !important;\n    box-shadow: none;\n    background-color: transparent !important;\n    border: none !important;\n }\n .language .dropdown-toggle {\n    border-radius: 4px !important;\n    color: #ffde;\n    padding: 4px 20px !important;\n    box-shadow: none;\n\n}\n.search {\n    margin: 17px 0px 0px 0px;\n    width: 100%;\n}\n\n.head-part1 {\n    margin: 17px 0px 0px 0px; float: right;}\n\n.head-part1 .lang-set{\n    width: 100px;\n}\n.head-part1 .lang-set .language{\n    font-size: 13px; \n    background:#302ba0;\n    z-index: 1111;\n    font-size: 13px;\n    color: #fff; \n    border: none; font-weight: bold;\n}\n\n\n\n.head-part1 select:focus-visible {outline:inherit}\n\n\n.header2 .navbar a {\n    padding: 14px 15px;\n    color: #f6f6fe;\n}\n\n.search .input-group {\n    width: 100%;\n}\n\n.search input {\n    font-size: 13px;\n    font-weight: normal;\n    color: #ffffff;\n    background-color: #4b46ac;\n    border: none;\n    padding-left: 14px;\n    border-radius: 0 !important;\n    height: 38px; width: 100%;\n}\n\n.search input:focus-visible{ outline: inherit;}\n\n.search button {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    border-radius: 5px;\n    border: none;\n}\n\n.search button:hover {\n    border: none;\n    background: none;\n}\n\n.search .input-group button i {\n    font-weight: bolder !important;\n    color: #c6c4e5;\n}\n\n.login-1 {\n    margin: 0px 0px 0px 0px;\n}\n\n.login-1 .dropdown-toggle::after {\n    display: none;\n}\n\n.login-1 .dropdown-toggle { color: #ffde; }\n\n.login-1 .btn-secondary {\n    background:none;\n    color: #fff;\n    font-weight: 600;\n    padding:3px 10px;\n    border: none;\n}\n\n.login-1 .btn-secondary:focus {\n    border: none;\n    box-shadow: none; background:none; border-radius:none;\n    color: #302ba0;\n    font-weight: 600;\n   \n}\n.btn-secondary:hover {\n    color: #fff !important;\n    background-color: #302ba0 !important;\n    border-color: #302ba0 !important;\n}\n.login-1 .dropdown-toggle:hover{color: #fff;}\n\n\n.about .about-img img { height: 150px;}\n\n.faq .accordion span img {\n    width:30px;\n}\n\n.faq .accordion-button,\n.accordion button {\n    font-size: 12px;\n    padding: 15px 20px 15px 20px;\n    width: 100%;\n    font-weight: 600;\n    color: var(--color-default);\n    text-align: left;\n    background: var(--color-white);\n    box-shadow: 0px 5px 25px 0px rgba(var(--color-black-rgb), 0.06);\n    border-radius: 5px;\n}\n.faq .accordion-button:focus {box-shadow:none; }\n\n.faq .content h3 {\n    font-size: 24px;\n}\n\n.service-item .img img {\n    height: 105px;\n    width: 100%;\n}\n\n.portfolio .portfolio-item img {\n    height: 100px;\n    border-radius: 5px;\n    width: 100%;\n}\n\n.portfolio2 .portfolio-item img {\n    height: 160px;\n    border-radius: 5px;\n    width: 90%;\n}\n\n.portfolio .portfolio-item .portfolio-info .details-a {\n    right: 65px;\n}\n\n.portfolio .portfolio-item .portfolio-info .preview-a {\n    right: 100px;\n    top: calc(-12% - 14px);\n}\n\n.portfolio .portfolio-item .portfolio-info .details-a {\n    right: 60px;\n    top: calc(-12% - 14px);\n}\n\n.portfolio-item {\n    margin: 5px 0px 5px 0px;\n}\n\n\n.hero2 {\n    height: 115px !important;\n}\n.col-lg-12.about-img2{padding: 0;}\n.hero { min-height: 0;}\n\n\n.inner-pad1 {\n    padding: 25px 0px 25px 0px;\n}\n\n.section-main-heading2 {\n    position: absolute;\n    /* z-index: 111; */\n    bottom: 25px;\n}\n\n.section-main-heading2 h4 {\n    color: #fff;\n    font-weight: normal;\n    font-size: 15px;\n}\n\n.about-head1 h4 {\n    padding: 10px;\n    font-size: 15px;\n    background: #F2F2F2;\n    line-height: 25px;\n}\n\n.about-img2 img {\n    width: 160px;\n    height: 100px;\n    border-radius: 5px;\n    float: left;\n    margin: 0px 20px 0px 0px;\n}\n\n.about-img2 p {\n    font-size: 13px;\n    line-height: 25px;\n    color: #000;\n    padding: 10px 0px 0px 0px;\n}\n\n.about-head1 h5 {\n    padding: 4px 0px;\n    font-size: 13px;\n    /* background: #F2F2F2; */\n    line-height: 25px;\n    margin: 10px 0px 0px 0px;\n}\n\n.about-head1 p {\n    padding: 5px 0px 0px 0px;\n    font-size: 13px;\n}\n\n.about-head2 {\n    height: 300px;\n    overflow-y: scroll;\n    margin: 50px 0px;\n}\n.responsiveheader .btn-link fontSizeClass ,\n.nav-item-list.homebtn {\n    color: #fff !important;\n    background: none !important;\n    width: 100%;\n}\n\n.card-header .btn-link fontSizeClass ,\n.nav-item-list.homebtn {\n    \n    border: 0;\n    color: #302ba0;\n    text-align: left;\n    box-shadow: none;\n    border-radius: 5px;\n    padding: 10px ;\n    font-size: 13px;\n}\n\n.about-head2 p {\n    padding: 5px 0px 0px 0px;\n    font-size: 13px;\n    line-height: 23px;\n}\n\n.inner-title h3 {\n    font-size: 22px;\n    text-transform: uppercase;\n    padding: 0px 0px 10px 0px;\n    color: #302ba0;\n}\n\n.inner-title2 h3 {\n    font-size: 22px;\n    text-transform: uppercase;\n    padding: 0px 0px 0px 0px;\n    color: #302ba0;\n}\n\n\n\nbutton.btn.btn-secondary.dropdown-toggle.user,\nbutton.btn.btn-secondary.dropdown-toggle.user.show {\n    border-radius: 30px;\n    color: #ffde;\n    padding: 8px 13px;\n    outline: none;\n    box-shadow: none;\n    border: none;\n}\n\nbutton#dropdownMenuButton1 i {\n    color: #ffde00;\n}\n\n.margin-128 {\n    margin-top: 128px;\n}\n\n.jss368 {\n    padding-top: 16px;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-bottom: 16px;\n}\n\n.jss368:last-child {\n    padding-bottom: 24px;\n}\n\n.jss332 {\n    height: 56px;\n    padding: 2px 4px;\n    display: flex;\n    box-shadow: 0px 2px rgb(0 0 0 / 23%);\n    align-items: center;\n    border-radius: 28px;\n    background-color: #fff;\n    width: 100%;\n}\n\n.jss333 {\n    flex: 1;\n    font-size: 16px;\n    margin-left: 8px;\n}\n\n.home-search-input-style {\n    border-radius: 28 !important;\n    z-index: 1100;\n    top: -22px;\n}\n\n.about-head1{width:100%}\n.more-menu a{font-weight: 500 !important;\n    font-size: 13px !important;\n    color: #302ba0 !important;\n    border-bottom: 1px solid #E5E9EF !important;\n    list-style: disc;\n    display: inherit;\n    list-style-position: inside;height: 300px; overflow: scroll;}\n.more-menu {height: 300px; overflow: scroll;}\n.card{box-shadow:none; border:none !important;}\n.show_responsive,\n.responsive_menu{display: none;}\n.responsivemenudiv { max-height: 150px;overflow: scroll; overflow-x: hidden; }\n.card-body .card-body{margin-left: 20px;}\n.responsivemenudiv a,\n.responsivemenudiv option,\n.responsivemenudiv .responsiveheader .btn-link fontSizeClass { padding: 0px 10px;font-size: 11px !important;line-height: 28px; color: #fff !important; list-style: disc; display: inherit; list-style-position: inside;}\n.responsiveheader .responsiveheader .btn-link fontSizeClass { padding: 0px 10px;font-size: 11px !important;line-height: 28px; color: #302ba0 !important; list-style: disc; display: inherit; list-style-position: inside;}\n\n.responsiveheader .btn-link fontSizeClass :hover {\n    border: 0;\n    color: #fff;\n    text-decoration: none;\n    \n    background: #302ba0;\n    box-shadow: none;\n   \n \n}\n.responsiveheader{ display: flex; justify-content: space-between; padding: 0px 10px 0px 0px !important;}\n.mayor-table.Heritage_Conservation_Architect{height: 460px;}\n\n\n\n.rainmaker-card {\n    color: #5f5c62;\n    background-color: white;\n    -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    -o-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-family: Poppins !important;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n    border-radius: 3px;\n    z-index: 1;\n    margin: 16px 0px;\n    padding: 12px 8px;\n}\n\n.service-item {\n    padding: 0px !important;\n    margin: 10px 0px 10px 0px;\n}\n\n\n/* Nav bar style css start */  \n\n .NavBar_container{\n    margin-top: 83px;\n} \n\n.react-multi-carousel-list {\n    position: unset !important;\n    \n}\n\n.NavBar_container--navbar{\n    display: none;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    position: sticky;\n    top: 0;\n    /* z-index: 20; */\n  }\n\n\n  .nav_container--item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    /* height: 80px; */\n    max-width: 1500px;\n  }\n\n\n\n  .main-container{\n    content: '';\n    position:absolute;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    background-color:rgba(0,0,0,0.4);\n  }\n  \n  \n  .nav-menu {\n    display: flex;\n    list-style: none;\n    text-align: center;\n    margin-right: 2rem;\n    margin-bottom: 0px;\n    width: 100%;\n    overflow: hidden;\n    justify-content: space-evenly;\n  }\n\n  .nav-links {\n    color: #fff;\n    text-decoration: none;\n    padding: 0.5rem 1rem;\n    height: 100%;\n    border-bottom: 3px solid transparent;\n    text-align: center !important;\n    font-size: 11px;\n    color: #fff !important;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  .fa-code {\n    margin-left: 1rem;\n  }\n  \n  /* .nav-item-list {\n    line-height: 40px;\n  } */\n  .nav-item-list {\n    line-height: 19px;\n}\n  \n  .nav-item-list:after {\n    content: \"\";\n    display: block;\n    height: 3px;\n    width: 0;\n    background: transparent;\n    transition: width 0.7s ease, background-color 0.5s ease;\n  }\n  \n  \n  \n  .nav-icon {\n    display: none;\n  }\n  \n \n  \n\n\n\n/* Nav bar style css end */\n\n\n\n.service-item .details h3 span {\n    color: #302ba0;\n}\n\n.service-item .details {\n    height: auto !important;\n    padding: 11px 10px;\n    margin: -33px 30px 0 30px;\n    transition: all ease-in-out 0.3s;\n    position: relative;\n    background: rgba(var(--color-white-rgb), 0.9);\n    text-align: center;\n    border-radius: 8px;\n    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);\n}\n\n.service-list {\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n\n.upper-row {\n    margin-bottom: 30px;\n}\n\n.service-icon {\n    width: 35px !important;\n    fill: rgba(239, 214, 47, 1) !important;\n    overflow: visible !important;\n    height: 35px !important;\n}\n\n.module-page-icon {\n    height: 30px;\n    width: 30px;\n    color: #fe7a51;\n}\n\n.card-content-style {\n    padding: 0 !important;\n}\n\n.service-label-cont .label-text {\n    word-break: inherit;\n    word-wrap: inherit;\n    font-size: 16px !important;\n    font-weight: 600;\n}\n\n.jss1 {\n    top: 75px;\n    height: 56px;\n    padding: 2px 4px;\n    z-index: 1100;\n    display: flex;\n    position: fixed;\n    box-shadow: 0px 2px rgb(0 0 0 / 23%);\n    align-items: center;\n    border-radius: 28px;\n    background-color: #fff;\n}\n\n.label-container {\n    display: block;\n}\n\n.jss9 {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    box-sizing: border-box;\n}\n\n.jss3 {\n    width: 10%;\n    padding: 1%;\n    flex-grow: 1;\n}\n\n.jss10 {\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.jss6 {\n    height: 90px;\n    cursor: pointer;\n    display: flex;\n    margin-top: 0;\n    align-items: center;\n    border-radius: 0;\n    justify-content: center;\n}\n\n.jss113 {\n    overflow: hidden;\n}\n\n.jss117 {\n    box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%);\n}\n\n.jss115 {\n    border-radius: 4px;\n}\n\n.jss114 {\n    background-color: #fff;\n}\n\n.jss57 {\n    flex-grow: 0;\n    max-width: 50%;\n    flex-basis: 50%;\n}\n\n.jss43 {\n    flex-grow: 0;\n    max-width: 50%;\n    flex-basis: 50%;\n}\n\n.jss10 {\n    margin: 0;\n    box-sizing: border-box;\n}\n\n.rainmaker-card {\n    color: #5f5c62;\n    background-color: #fff;\n    -webkit-transition: all .45s cubic-bezier(.23, 1, .32, 1) 0ms;\n    -o-transition: all .45s cubic-bezier(.23, 1, .32, 1) 0ms;\n    transition: all .45s cubic-bezier(.23, 1, .32, 1) 0ms;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    font-family: Poppins !important;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-box-shadow: rgb(0 0 0 / 12%) 0 1px 6px, rgb(0 0 0 / 12%) 0 1px 4px;\n    box-shadow: 0 1px 6px rgb(0 0 0 / 12%), 0 1px 4px rgb(0 0 0 / 12%);\n    border-radius: 3px;\n    z-index: 1;\n    margin: 16px 0;\n    padding: 12px 8px;\n}\n\n.local-information-cont {\n    background-color: #fff;\n    padding: 16px;\n    width: 100%;\n    height: 56px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.login-1 .dropdown-item {\n    font-size: 13px;\n    color: #fff;\n    line-height: 26px;\n}\n\n.login-1 .show>.btn-secondary.dropdown-toggle:focus{box-shadow: none;}\n.login-1 .btn-secondary:not(:disabled):not(.disabled):active:focus{box-shadow: none;}\n.login-1 .btn-secondary:not(:disabled):not(.disabled):active{background: none; border: none;}\n.language_dropdown:focus-visible {    box-shadow: none !important;\n    background-color: transparent !important;\n    border: none !important; outline: none;}\n\n\n.show>.btn-secondary.dropdown-toggle {background-color:none; border-color:none !important; }\n.basic_static_table{margin: 0 !important;}\n\n.login-1 .dropdown-menu {\n    background: #090253;\n    min-width: 110px !important;\n    z-index: 1111;\n}\n\n/* .login-1 .dropdown-item:hover {\n    background: #000;\n    color: #fff;\n} */\n\n.login-1 .dropdown-item:active {\n    background: #000;\n    color: #fff;\n}\n\n\n\n.language .dropdown-toggle::after {\n    display: none;\n}\n\n.language .dropdown-toggle {\n    border-radius: 30px;\n    color: #ffde;\n    padding: 6px 20px;\n    box-shadow: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.language .btn-secondary {\n    background: transparent;\n    color: #ffffff;\n    font-size: 13px;\n    border: none;\n}\n\n.language .btn-secondary:focus {\n    border: none;\n    box-shadow: none;\n    background-color: transparent;\n}\n\n.language .dropdown-item {\n    font-size: 13px;\n    color: #090253;\n    line-height: 26px;\n}\n\n.language .dropdown-menu {\n    background: #fff;\n    min-width: 7rem;\n}\n\n.language .dropdown-item:hover {\n    color: #090253;\n}\n\n.language .dropdown-item:active {\n    color: #090253;\n}\n\n/* 12/28/2022 css */\n.form-select option{\n    color: #fff !important;\n    font-size: 13px;\n    padding:8px 10px !important; border: 1px solid rgba(0,0,0,.15);\n    border-radius: 0.25rem;\n    background: #090253; min-width: 110px !important;    z-index: 1000;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;    text-align: left;\n    list-style: none;position: absolute;\n    transform: translate3d(2px, 28px, 0px);\n    top: 0px;\n    left: 0px;\n}\n\n\n.font-site {font-size: 14px;\n    text-transform: uppercase;\n    color: #090253;\n    padding: 0 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 95px;\n    margin: 4px 0px 0px 0px;}\n    .text-large:hover{\ncolor: #fff;\n    }\n\n.hero .carousel-item .text-left ul {\n    list-style: none;\n    padding: 10px 0px;\n    margin: 0px;\n}\n\n.hero .carousel-item .text-left ul li {\n    list-style: none;\n    padding: 20px 0px;\n    margin: 0px;\n    color: #070152;\n    font-size: 19px;\n    font-weight: 600;\n}\n\n.hero .carousel-item .text-left ul li i {\n    font-weight: bolder;\n}\n\n.scrool-message {\n    width: 100%;\n    padding: 6px 10px;\n    background-color: #fff085;\n    display: inline-block;\n    font-size: 12px;\n    color: #000;\n    font-weight: 600;\n}\n\n.scrool-message marquee p {\n    margin: 0px;\n    padding: 0px;\n}\n\n.hero {\n    padding: 0px;\n}\n\n.hero .img {\n    margin-bottom: 0px;\n}\n\n.about h3 {\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 25px;\n}\n\nsection {\n    padding: 10px 0;\n}\n\n.about .tab-content h4 {\n    font-size: 14px;\n}\n\n.about .tab-content p {\n    font-size: 13px;\n}\n\n.about h3 {\n    margin-bottom: 0px;\n}\n\n.about .nav-a {\n    font-size: 15px;\n}\n\n.about .tab-content p {\n    margin: 0px 0px 8px 0px;\n    text-align: justify;\n}\n\n.about .tab-content p span {\n    margin: 10px 0px 0px 0px;\n    color: #0541af;\n}\n\n.whats-new {\n    width: 100%;\n    background-color: #fff;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n    border-radius: 10px;\n    padding: 0px 0px 6px 0px;\n    height: auto;\n}\n\n.section-bg3 {\n    background-color: #fff;\n    width: 100%;\n    display: inline-block;\n    height: auto;\n}\n\n.section-title h4 {\n    padding: 15px 0px 5px 30px;\n    text-align: left;\n    font-size: 20px;\n}\n\n.title2 h4 {\n    padding: 20px 0px 10px 24px;\n    text-align: left;\n    font-size: 16px;\n}\n\n.body1-left-side {\n    width: 100%;\n    height: auto;\n    margin: 0px 0px 0px 0px;\n}\n\n.block-hdnews {\n    margin: 5px auto;\n}\n\n.title3 .list-wrpaaer {\n    height: 250px\n}\n\n.list-wrpaaer {\n    height: 325px\n}\n\n.list-wrpaaer ul {\n    margin: 0px;\n}\n\n.list-wrpaaer ul li {\n    list-style: none;\n    padding: 4px 10px;\n    display: inline-block;\n    width: 100%;\n}\n\n.list-aggregate li {\n    border-bottom-color: #e5e5e5;\n    display: flex !important;\njustify-content: center;\nalign-items: center;\n}\n\n.list-aggregate li a {\n    color: #056db1;\n}\n\n.list-aggregate li a {\n    color: #686666;\n    padding: 0px 0px 0px 0px;\n    margin: 0px;\n    text-align: left;\n    font-size: 12px;\n    line-height: 17px;\n}\n\n.list-aggregate li:hover {\n    background-color: rgba(36, 1, 77, 0.1);\n}\n\n.policy-img2 {\n    width: 55px;\n    height: 54px;\n    border-radius: 50%;\n    background-color: #302ba0;\n    display: inline-block;\n}\n\n.policy-img2 h4 {\n    font-size: 14px;\n    line-height: 2px;\n    color: #fff;\n    margin: 0px;\n    padding: 18px 0px 0px 0px;\n}\n\n.policy-img2 span {\n    font-size: 8px;\n    color: #fff;\n}\n\n.list-aggregate {\n    left: -41px !important;\n}\n\n.buy-policy-2 {\n    text-align: left;\n    float: right;\n    width: 80%;\n    padding: 0px 15px;\n}\n\n.section-title h3 {\n    padding: 15px 0px;\n    font-size: 1.2rem;\n}\n\n.imp-a h2 {\n    text-align: left;\n    padding: 23px 0px 0px 0px;\n    font-weight: normal;\n    margin: 0px;\n}\n\n.download1 {\n    display: inline-block;\n    width: 100%;\n}\n\n.download1 .d1-icon {\n    width: 100px;\n    height: 100px;\n    border-radius: 50px;\n    text-align: center;\n    background: #050048;\n    margin: 0px auto;\n}\n\n.download1 .d1-icon img {\n    margin: 16px auto 0px auto;\n}\n\n.download1 h3 {\n    text-align: center;\n    color: #000;\n    font-weight: bold;\n    line-height: 26px;\n    font-size: 13px;\n    height: 52px;\n}\n\n.download1 a {\n    text-align: center;\n    color: #fff;\n    font-size: 12px;\n    background: #050048;\n    padding: 6px 14px;\n    letter-spacing: 1px;\n    border-radius: 20px;\n}\n\n.download1 {\n    margin: 20px 0px 0px 0px;\n}\n\n.download1 a:hover {\n    transition: all ease-in-out 0.4s;\n    background: #ffde00;\n    color: #000;\n}\n\n.faq .accordion-body {\n    font-size: 13px;\n}\n\n.more {\n    margin: 30px auto 10px auto;\n    text-align: center;\n}\n\n.more a {\n    width: 65px;\n    height: 65px;\n    color: #ffde00;\n    background: #050048;\n    font-size: 30px;\n    border-radius: 50%;\n    display: inline-block;\n    padding: 6px 0px 0px 0px;\n    border: 5px solid;\n    transition: all ease-in-out 0.4s;\n}\n\n.more a:hover {\n    background: #ffde00;\n    color: #000;\n}\n\n.import {\n    padding-bottom: 30px;\n}\n\n.carousel-control-next-icon,.visually-hidden,.carousel-control-prev-icon{\n    display: none !important;\n}\n\n.import .count-box {\n    box-shadow: 0px 0 16px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    background: #fff;\n    margin-bottom: 30px;\n    border-radius: 5px;\n    display: inline-block;\n    width: 100%;\n    height: 185px;\n}\n\n.import .count-box2 {\n    box-shadow: 0px 0 16px rgba(0, 0, 0, 0.1);\n    padding: 10px 0px 0px 0px;\n    background: #0579c6;\n    margin-bottom: 30px;\n    border-radius: 5px;\n    height: 60px;\n    text-align: center;\n    transition: all ease-in-out 0.4s;\n}\n\n.import .count-box2 h4 {\n    font-size: 14px;\n    color: #fff;\n    font-weight: normal;\n    line-height: 33px;\n}\n\n.import .count-box2 h3 {\n    font-size: 14px;\n    color: #fff;\n    font-weight: normal;\n    line-height: 20px;\n}\n\n.import .count-box i {\n    display: block;\n    font-size: 64px;\n    margin-bottom: 15px;\n}\n\n.import .count-box span {\n    font-size: 42px;\n    display: block;\n    font-weight: 700;\n    color: #1c5c93;\n}\n\n.import .count-box p {\n    padding: 0;\n    margin: 0;\n    font-size: 14px;\n}\n\n.import .count-box2:hover {\n    background-color: #000;\n    transition: all ease-in-out 0.4s;\n}\n\n.footer-as p span {\n    line-height: 26px;\n    font-size: 13px;\n}\n\n.footer-newsletter p a {\n    font-size: 14px;\n    color: #000;\n    padding: 10px 15px;\n    text-align: center;\n    margin: 20px 0px 0px 0px;\n    background: #ffde00;\n    display: inline-block;\n}\n\n.footer .footer-legal .credits a {\n    color: #ffde00;\n}\n\n.footer .footer-content .footer-newsletter form input[type=submit]:hover {\n    background: #302ba0;\n    color: #fff;\n}\n\n.scrool-margin {\n    margin-top: 170px;\n}\n\n.site-menu {\n    background: #fff;\n    color: #090253;\n    font-size: 13px;\n    margin: 10px 0px 10px 0px;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n.site-menu2 {\n    background: #fff;\n    color: #090253;\n    font-size: 13px;\n    margin: 10px 0px;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n.site-menu nav ul li .btn .bi-chevron-down::before{color: #302ba0 !important; padding: 0px 5px;}\n/*.site-menu nav ul li a,\n.site-menu nav ul li .btn {\n    font-weight: 500 !important;\n    font-size: 12px ;\n    color: #302ba0 !important;\n    border-bottom: 1px solid #E5E9EF !important;\n    width: 100%; margin-left: 0px;\n    display: inherit; text-align: left;\n}*/\n.site-menu nav ul li a,\n.site-menu nav ul li .btn {\n    font-weight: 500 !important;\n    font-size: 11px ;\n    color: #302ba0 !important;\n    border-bottom: 1px solid #E5E9EF !important;\n    width: 100%; \n    display: inline-block; \n    text-align: left;\n    padding: 7px 15px;\n}\n\n\n\n.sidebar li .submenu li a {\n    font-size: 11px !important;\n}\n\n.site-menu nav ul a.active1 {\n    color: #0d6efd !important;\n    background: rgba(229, 233, 239, 0.5);\n}\n\n\n.site-menu nav ul li a i::before {\n    font-size: 15px;\n    font-weight: bold !important;\n}\n\n.site-menu nav ul li a:hover,\n.site-menu nav ul li a:focus-visible {\n    color: #0d6efd !important; border: none; }\n\n.sidebar li .submenu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n\n.sidebar .nav-a {\n    font-weight: 500;\n}\n\n\n\n.certificate1 p {\n    font-size: 13px;\n    text-align: justify;\n    line-height: 33px;\n    padding: 10px 0px 0px 0px;\n}\n\n.certificate1 h4 {\n    color: #090253;\n}\n\n.certificate1 h6 {\n    padding: 10px 0px 0px 0px;\n}\n\n.certificate1 p span a {\n    color: #0d6efd;\n}\n\n.certificate1 ul li {\n    list-style: none;\n}\n\n.certificate1 ul li a {\n    font-size: 11px;\n    text-align: left;\n    line-height: 20px;\n    padding:4px 10px;\n    color: #090253;\n    font-weight: bold;\n    width: 100%;\n    background: #fff;\n    border: 1px solid #E5E9EF !important;\n    display: inline-block;\n    margin: 2px 0px 2px 0px;text-decoration: none;\n}\n\n.certificate1 ul li a:hover {\n    color: #fff;\n    background: #302ba0;\n}\n\n\n\n.application1 {\n    width: 100%;\n    float: left;\n    height: auto;\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n    box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);\n    margin: 20px 0px 20px 0px;\n}\n\n.application1 h4 {\n    background-color: rgba(114, 124, 245);\n    opacity: 1;\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n    padding: 30px 20px;\n    color: #fff;\n    font-size: 23px;\n    text-align: center;\n}\n\n.application1 .form1 {\n    padding: 10px 20px;\n}\n\n.application1 .form1 .form-group {\n    color: #000;\n    margin: 0px 0px 20px 0px;\n}\n\n.application1 .form1 .form-group span {\n    color: #FF0000;\n}\n\n.application1 .form1 .form-group select {\n    font-size: 14px;\n    padding: 10px 20px;\n}\n\n.application1 .form1 .form-group input {\n    font-size: 14px;\n    padding: 10px 20px;\n}\n\n.application1 .form1 .form-group .form-check-input {\n    padding: 8px !important;\n}\n\n.application1 .form1 .form-titel-1 h5 {\n    font-size: 22px;\n    color: #090253;\n    padding: 10px 0px;\n}\n\n.application1 .form1 .form-titel-1 h6 {\n    font-size: 20px;\n    color: #090253;\n    padding: 10px\n}\n\n.application1 .form1 .form-group .form-check {\n    display: inline-block;\n}\n\n.application1 .form1 .form-group .form-check label {\n    padding: 0px 0px 0px 10px;\n}\n\n.styling {\n    background: #f5f5f5;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 20px;\n    text-align: center;\n}\n\n.certificate1 h3 {\n    font-size: 24px;\n    padding: 10px 0px;\n}\n\n.certificate1 ul {\n    margin: 0px;\n    padding: 0px;\n}\n\n.section-main-heading::after {\n    border-bottom: 3px solid #302ba0 !important;\n    width: 4%;\n}\n\n.section-main-heading p.main-heading-title {\n    margin: 0;\n    padding: 0px 0 4px;\n    font-size: 21px;\n    font-weight: 400;\n    color: #000 !important;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.section-main-heading p.main-heading-title span.main-heading-border {\n    border-bottom: 1px solid #e7e7e7;\n    padding-bottom: 6px;\n}\n\n.section-main-heading p span {\n    font-size: 18px;\n}\n\n.section-main-heading::after {\n    left: 48%;\n    position: absolute;\n    content: \"\";\n}\n\n\n.alert.active {\n    visibility: visible;\n    opacity: 1;\n}\n\n.alert {\n    position: fixed;\n    visibility: visible;\n    right: 15px;\n    bottom: 15px;\n    padding: 10px;\n    width: 30%;\n    background-color: #f44336;\n    color: white;\n    z-index: 995;\n    -border-radius: 2px;\n    transition: all 0.4s;\n}\n\n.closebtn {\n    right: 10px;\n    color: white;\n    font-weight: bold;\n    float: right;\n    font-size: 22px;\n    cursor: pointer;\n    transition: 0.3s;\n    top: 0px;\n    position: absolute;\n    z-index: 11;\n}\n\n.closebtn:hover {\n    color: black;\n}\n\n.message1 {\n    float: left;\n}\n\n.message1 img {\n    width: 80px;\n}\n\n.mayar {\n    margin: 5px 7px 0px 0px;\n    position: absolute;\n    z-index: 11;\n    top: -5px;\n}\n\n.mayar img {\n    width: 63px;\n}\n\n.clients {\n    padding: 0px !important;\n}\n\n.clients .swiper-slide img {\n    transition: 0.3s;\n}\n\n\n\n.swiper {\n    margin: 0px 0px 0px 30px;\n}\n\n\n\n.scrool-menu1 .swiper-slide {\n    display: inline;\n    text-align: center;\n    border-radius: 3px;\n}\n\n.scrool-menu1 .swiper-slide a {\n    text-align: center !important;\n    font-size: 14px;\n    color: #fff !important;\n    text-transform: uppercase;\n    display: table;\n    margin: 0px auto;\n}\n\n.drop-footer ul li a {\n    font-size: 12px;\n}\n\n.drop-footer ul li {\n    padding: 5px 0px !important;\n}\n\n.drop-footer button {\n    padding: 3px 20px !important;\n}\n\n.swiper2 {\n    margin: 0px 0px 0px 0px !important;\n}\n\n\n\n.carousel-indicators .active {\n    opacity: 1 !important;\n    background: #ffec69 !important;\n    width: 24px !important;\n    margin-top: 10px;\n    border-bottom: unset !important;\n    border-top: unset !important;\n}\n\n.carousel-indicators button {\n    cursor: pointer !important;\n    background: rgba(255, 255, 255, 0.8) !important;\n    margin: 0px 5px !important;\n    overflow: hidden !important;\n    border: 0 !important;\n    width: 12px !important;\n    height: 12px !important;\n    border-radius: 50px !important;\n    opacity: 0.6 !important;\n    transition: 0.3s !important;\n}\n\n.carousel-indicators {\n    justify-content: normal !important;\n}\n\n.alert.d-flex.align-items-center.justify-content-center .message1 {\n    font-size: 16px;\n}\n\n\n\n\n\n\n\n\n.btn {\n    font-size: 0.8rem;\n    margin: 2px;\n    padding: 10px 25px;\n}\n\n.btn-primary {\n    font-size: 14px;\n    background-color: rgb(42, 41, 84);\n    padding: 10px 40px;\n    margin: 0px 20px 0px 0px;\n    border-width: initial;\n    border-style: none;\n}\n\n\n\n::-webkit-scrollbar {\n    width: 0.5em;\n}\n\n::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: darkgrey;\n    outline: 1px solid slategrey;\n}\n\n::placeholder {\n    color: #c6c4e5 !important;\n    opacity: 1;\n}\n\n:-ms-input-placeholder {\n    color: #c6c4e5 !important;\n}\n\n::-ms-input-placeholder {\n    color: #c6c4e5 !important;\n}\n\n\n\n.input-group-append {\n    font-size: 13px;\n\n    background-color: #4b46ac;\n    border: none;\n    border-radius: 0 !important;\n    height: 38px;\n}\n\n\n.language-txt {\n    width: 17px;\n}\n\na.text-large {\n\n    color: #e3e3f2;\n    font-size: 21px;\n}\n.login_btn{\nfont-size: 15px;\n}\n\n.carousel-caption.d-none.d-md-block h5 {\n    text-align: left;\n    font-size: 30px;\n    color: #fff;\n\n}\n\n.carousel-caption.d-none.d-md-block p {\n    text-align: left;\n    font-size: 29px;\n    color: #FFEC69;\n    left: 8% !important;\n    \n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    top: 35%;\n    left: 8%;text-align:left !important;\n}\n\n.white-bgtxt {\n    background-color: #fff;\n    border-radius: 6px;\n    padding: 4px 10px;\n    right: 8%;\n    position: absolute;\n    top: 27%;\n    width: 32%;\n    opacity: 0.8;\n}\n\n.border-btm {\n    border-bottom: 2px solid #FFEC69;\n    width: 58%;\n    position: absolute;\n    top: 27px;\n    right: 69px;\n\n}\n\n.col-6.white-bgtxt h6 {\n    color: #302BA0;\n    border-bottom: 2px solid rgba(48, 43, 160, 1);\n    font-size: 19px;\n    padding: 8px 0px 7px 10px;\n    font-weight: 600;\n    letter-spacing: 1px;\n}\n\n.col-6.white-bgtxt ul li {\n    color: #1e1e1e;\n    padding: 5px 0px;\n    font-size: 13px;\n    font-weight: 600;\n    color: rgba(48, 43, 160, 1);\n}\n\n.col-6.white-bgtxt ul li a {\n\n    color: #000000;\n}\n\n.carousel-indicators {\n    position: absolute;\n    bottom: 1px !important;\n    z-index: 2;\n    display: flex;\n    justify-content: center !important;\n    padding: 0;\n    margin-right: 0 !important;\n    margin-bottom: 0 !important;\n    margin-left: 0 !important;\n    list-style: none;\n}\n\n.col-6.white-bgtxt span {\n    font-size: 13px;\n    text-decoration: underline;\n    position: absolute;\n    right: 36px;\n    top: 15px;\n    font-weight: 600;\n}\n\n.col-6.white-bgtxt span a {\n    color: #000000;\n}\n\n.fix-none {\n    position: inherit;\n}\n\n.header-bg {\n    background: #090253 !important;\n}\n\n.services-item .details {\n    height: 66px;\n    padding: 11px 10px;\n    margin: -39px 15px 0 15px;\n\n}\n\n.services-item .details h3 {\n    font-size: 12px;\n    margin: 15px 0 8px 0;\n}\n\na.stretched-a {\n    text-decoration: none;\n}\n\n.service-item .details .icon {\n    font-size: 20px;\n    width: 55px;\n    height: 55px;\n    top: -30px;\n    margin: 0px 0px 0px 8px;\n    background: #302ba0;\n}\n\n.accordion-item .accordion-header button{padding: 13px 12px; right: 25px; border: 1px solid #E5E9EF !important;}\n.accordion-item .accordion-header button i{right: 25px;}\n\n.faq .accordion-item {box-shadow: none;}\n\n.faq .accordion-button i {\n    position: absolute;\n    right: 16px;\n}\n\n.faq .accordion-button:after {\n    display: none;\n}\n\n\n.help {\n    z-index: 11;\n   position: relative;\n\n}\n\n\n\n\n.mayor-table .table-bor-1 {\n    color: #302ba0 !important;\n    background: rgba(229, 233, 239, 0.5);\n}\n\n.mayor-table table {\n    width: 100%;\n    margin: 0px ;\n}\n\n.mayer-tb2 table {\n    width: 100%;\n    margin: 0px;\n}\n\n.mayor-table table tr th {\n    font-size: 13px;\n    font-weight: normal;\n}\n\n.mayor-table table tr td {\n    color: #302ba0;\n    font-size: 13px;\n}\n\n\n.mayor-table {\n    height: 300px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    width: 100%;\n    margin:15px 0px 50px 0px;\n}\n\n.mayor-table2a {\n    width: 100%;\n    height: auto !important;\n    overflow-y: inherit !important;\n    overflow-x: inherit !important;\n}\n\n.mayor-table2 tr td a {\n    font-size: 13px;\n    color: #0d6efd;\n}\n\n.mayor-table2 tr td a:hover {\n    color: #000;\n}\n\n.table-bor-2 th {\n    font-weight: normal;\n}\n\n.inner-title3 h3 {\n    font-size: 16px;\n    text-transform: uppercase;\n    display: inline-block;\n    padding: 10px 0px 10px 0px;\n    color: #302ba0;\n}\n\n.funct1 {\n    height: 200px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n.kmc-function-list{ padding: 0px 12px;}\n.kmc-function-list li {\n    line-height: 30px;\n    font-size: 12px !important;\n    \n    /*  list-style-position: inside; */\n   \n}\n\n.dig-login1 {\n    width: 45%;\n    height: auto;\n    display: table;\n    margin: 100px auto 0px auto;\n    padding: 20px;\n    background: #fff;\n    border-radius: 6px;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n\n\n\n.dig-login1 .log-form {\n    display: inline-block;\n    width: 100%;\n}\n\n.dig-login1 .log-form h3 {\n    text-align: center;\n    float: left;\n    width: 100%;\n    font-size: 18px;\n    padding: 0px 0px 10px 0px;\n    margin: 0px;\n    color: #302ba0;\n    text-transform: uppercase;\n    font-weight: 600;\n    border-bottom: 2px solid #f1da36;\n}\n\n.dig-login1 .log-form p {\n    text-align: center;\n    font-size: 12px;\n    padding: 10px 0px 0px 0px;\n    margin: 0px auto;\n}\n\n\n.log-form .form-group p {\n    font-size: 12px;\n    display: inline-block;\n    padding: 0px;\n    margin: 0px;\n}\n\n.log-form .form-group span {\n    font-size: 12px;\n    float: right;\n}\n\n.dig-login1 .log-form label {\n    font-size: 14px;\n    padding: 10px 0px 5px 0px;\n    letter-spacing: 1px;\n}\n\n.dig-login1 .log-form label span {\n    color: orangered;\n}\n\n.dig-login1 .log-form .form-group input {\n    font-size: 13px;\n    padding: 8px 15px;\n    border: none;\n    color: #000;\n    border-bottom: 1px solid #302ba0;\n    border-radius: inherit;\n}\n\n.inner-log-form .form-group input {\n    font-size: 13px;\n    padding: 10px 15px;\n    color: #000;\n    border: 1px solid #ced4da !important;\n}\n\n.dig-login1 .log-form .form-group select {\n    font-size: 13px;\n    padding: 8px 15px;\n    border: none;\n    color: #000;\n    border-bottom: 1px solid #302ba0;\n    border-radius: inherit;\n}\n\n.dig-login1 .log-form .form-group .form-check-input {\n    border: 1px solid #000;\n    padding: 0px;\n    margin: 6px 0px 0px 0px;\n}\n\n.dig-login1 .log-form .form-group input::placeholder {\n    color: #000 !important;\n}\n\n.dig-login1 .log-form .form-group p {\n    font-size: 14px;\n    text-align: right;\n    color: #767676;\n    padding: 0px 0px 0px 0px;\n    margin-bottom: 20px;\n}\n\n.dig-login1 .log-form .form-group p span a {\n    color: #f89a3f;\n}\n\n.dig-login1 .log-form .form-group .dropdown {\n    float: right !important;\n    margin: 10px 0px;\n}\n\n.dig-login1 .log-form .form-group .dropdown .btn-secondary {\n    padding: 5px 10px;\n    background-color: inherit;\n    border-color: inherit;\n    color: #000;\n    border: none;\n}\n\n.dig-login1 .log-form .form-group .dropdown .btn-secondary:focus {\n    box-shadow: none;\n}\n\n.dig-login1 .log-form .form-group .dropdown-menu {\n    width: auto !important;\n}\n\n.dig-login1 .log-form .continu a {\n    font-size: 14px;\n    color: #fff;\n    background: #302ba0;\n    padding: 7px 25px;\n    float: left;\n    text-align: center;\n    border-radius: 3px;\n    margin: 0px 20px 0px 0px;\n}\n\n.dig-login1 .log-form .continu a:hover {\n    background-color: #000;\n}\n\n.log-form .otp {\n    float: left;\n}\n\n.dig-login1 .log-form .form-group strong {\n    font-size: 12px;\n    color: rgb(179, 179, 179);\n    font-weight: normal;\n    padding: 10px 0px;\n}\n\n.back-bottom i {\n    color: #fff;\n    font-size: 30px;\n    padding: 30px 0px;\n}\n\n.login__field {\n    position: relative;\n    width: 90%;\n    margin: 10px auto;\n}\n\n\n.bd-wid {\n    width: 61px;\n}\n\n\n\n.carousel-indicators [data-bs-target] {\n    transition: none;\n    cursor: pointer;\n    background: rgba(255, 255, 255, 0.8);\n    overflow: hidden;\n    border: 0;\n    width: 12px;\n    height: 12px;\n    border-radius: 50px;\n    opacity: 0.6;\n    transition: 0.3s;\n}\n\n.display-320 {\n    display: none;\n}\n\n.faq .accordion-button:not(.collapsed) {\n    color: #0d6efd !important;\n}\n\n.about-head1 .col-lg-12 .about-head1 p {\n    display: inline-block;\n    line-height: 25px;\n    font-size: 13px;\n    text-align: justify;\n    margin: 0px;\n    padding: 4px 10px;\n}\n\n.dig-form .log-form .form-group input {\n    height: 40px;\n    border-radius: 4px !important;\n    margin: 5px 0 10px;\n}\n\n\n.table td,\n.table th {\n    padding: 0.5rem !important;\n}\n\n\n.table-warning,\n.table-warning>td,\n.table-warning>th,\n.table-warning td,\n.table-warning th,\n.table-warning thead th {\n    border-color: #302ba0 !important;\n    background-color: #302ba0 !important;\n}\n\n\n#yearclsYear {\n    display: none;\n}\n\n.site-menu nav ul a.active1 {\n    color: #0d6efd !important;\n    background: rgba(229, 233, 239, 0.5);\n}\n\n.swiper-wrapper.align-items-center.scrool-menu1 {\n    width: 80%;\n    white-space: nowrap;\n}\n\n.dropdown-submenu {\n    position: relative;\n}\n.responsivemenudiv .dropdown-menu { background-color: #302ba0 !important;overflow: scroll;}\n.responsivemenudiv .dropdown-menu .dropdown-item { display: list-item; }\n.responsivemenudiv .dropdown-item{padding: 0 !important;}\n.dropdown-submenu>.dropdown-menu {\n    top: 0;\n    left: 100%;\n    margin-top: 27px;\n    margin-left: -128%;\n    -webkit-border-radius: 0 6px 6px 6px;\n    -moz-border-radius: 0 6px 6px;\n    border-radius: 0 6px 6px 6px;\n}\n\n.dropdown-submenu:hover>.dropdown-menu {\n    display: block;\n}\n\n.dropdown-submenu>a:after {\n    display: block;\n    content: \" \";\n    float: right;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #ccc;\n    margin-top: 5px;\n    margin-right: -10px;\n}\n\n.dropdown-submenu:hover>a:after {\n    border-left-color: #fff;\n}\n\n.dropdown-submenu.pull-left {\n    float: none;\n}\n\n.dropdown-submenu.pull-left>.dropdown-menu {\n    left: -100%;\n    margin-left: 10px;\n    -webkit-border-radius: 6px 0 6px 6px;\n    -moz-border-radius: 6px 0 6px 6px;\n    border-radius: 6px 0 6px 6px;\n}\n\n.dropdown-menu-dark .dropdown-item.active,\n.dropdown-menu-dark .dropdown-item:active {\n    color: #dee2e6;\n    background-color: #343a40;\n    border-color: rgba(0, 0, 0, .15);\n}\n\n.dropdown-menu-dark .dropdown-item:focus,\n.dropdown-menu-dark .dropdown-item:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .15);\n}\n\n.dropdown-menu-dark,\n.footer-more .dropdown-menu.dropdown-menu-dark.hidden-as ul a,\n.footer-more .dropdown-menu.dropdown-menu-dark.hidden-as {\n    color: #dee2e6 !important;\n    background-color: #343a40 !important;\n    border-color: rgba(0, 0, 0, .15) !important;\n}\n\n.aos-init.aos-animate.aos-init.aos-animate {\n    border: 0;\n    /* margin-top: 10px !important; */\n}\n\n.scrool-menu1 .swiper-slide {\n    display: inline;\n    text-align: center;\n    border-radius: 3px;\n    width: 25%;\n    position: relative;\n    animation: myfirst 5s infinite;\n    transition: transform 2s ease-in-out;\n    animation-direction: right;\n}\n\n@keyframes myfirst {\n    0% {\n        left: 0px;\n        top: 0px;\n    }\n\n    25% {\n        left: 200px;\n        top: 0px;\n    }\n\n}\n\n.justify-content-center.gy-6 {\n    position: relative;\n}\n\n.swiper-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    display: flex;\n    transition-property: transform;\n    box-sizing: content-box;\n}\n\n.site-menu nav ul li .dropdown .btn {\n    padding: 0px 0px 0px 17px;\n    font-weight: 500 !important;\n    font-size: 13px !important;\n    color: #302ba0 !important;\n    list-style: disc;\n    display: inherit;\n    list-style-position: inside;\n}\n\n.site-menu nav li .dropdown .btn::before {\n    height: 1px;\n    content: '';\n    width: 1px;\n    background-color: #302ba0;\n    border-radius: 50%;\n}\n\n.alert.d-flex.align-items-center.justify-content-center {\n    position: fixed;\n}\n\n.col-lg-7.col-md-7.text-center.aos-init.aos-animate {\n    margin: 0px;\n    padding: 0;\n}\n\n.col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate {\n    margin: 0;\n    box-shadow: none;\n    display: flex !important;\n}\n\n.btn.btn-outline-warning.btn-lg {\n    font-size: 12px;\n}\n\n.dropdown .btn.btn-secondary.dropdown-toggle {\n    font-size: 13px; color: #fff; border: none; background: none;\n}\n\n@-webkit-keyframes L_circle_rotate {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0)\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes L_circle_rotate {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0)\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}\n\n@-webkit-keyframes L_stroke_rotate {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0)\n    }\n\n    12.5% {\n        -webkit-transform: rotate(135deg);\n        transform: rotate(135deg)\n    }\n\n    25% {\n        -webkit-transform: rotate(270deg);\n        transform: rotate(270deg)\n    }\n\n    37.5% {\n        -webkit-transform: rotate(405deg);\n        transform: rotate(405deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(540deg);\n        transform: rotate(540deg)\n    }\n\n    62.5% {\n        -webkit-transform: rotate(675deg);\n        transform: rotate(675deg)\n    }\n\n    75% {\n        -webkit-transform: rotate(810deg);\n        transform: rotate(810deg)\n    }\n\n    87.5% {\n        -webkit-transform: rotate(945deg);\n        transform: rotate(945deg)\n    }\n\n    100% {\n        -webkit-transform: rotate(1080deg);\n        transform: rotate(1080deg)\n    }\n}\n\n@keyframes L_stroke_rotate {\n    0% {\n        -webkit-transform: rotate(0);\n        transform: rotate(0)\n    }\n\n    12.5% {\n        -webkit-transform: rotate(135deg);\n        transform: rotate(135deg)\n    }\n\n    25% {\n        -webkit-transform: rotate(270deg);\n        transform: rotate(270deg)\n    }\n\n    37.5% {\n        -webkit-transform: rotate(405deg);\n        transform: rotate(405deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(540deg);\n        transform: rotate(540deg)\n    }\n\n    62.5% {\n        -webkit-transform: rotate(675deg);\n        transform: rotate(675deg)\n    }\n\n    75% {\n        -webkit-transform: rotate(810deg);\n        transform: rotate(810deg)\n    }\n\n    87.5% {\n        -webkit-transform: rotate(945deg);\n        transform: rotate(945deg)\n    }\n\n    100% {\n        -webkit-transform: rotate(1080deg);\n        transform: rotate(1080deg)\n    }\n}\n\n@-webkit-keyframes L_stroke_left_grow {\n\n    0%,\n    100% {\n        -webkit-transform: rotate(-5deg);\n        transform: rotate(-5deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(-140deg);\n        transform: rotate(-140deg)\n    }\n}\n\n@keyframes L_stroke_left_grow {\n\n    0%,\n    100% {\n        -webkit-transform: rotate(-5deg);\n        transform: rotate(-5deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(-140deg);\n        transform: rotate(-140deg)\n    }\n}\n\n@-webkit-keyframes L_stroke_right_grow {\n\n    0%,\n    100% {\n        -webkit-transform: rotate(5deg);\n        transform: rotate(5deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(140deg);\n        transform: rotate(140deg)\n    }\n}\n\n@keyframes L_stroke_right_grow {\n\n    0%,\n    100% {\n        -webkit-transform: rotate(5deg);\n        transform: rotate(5deg)\n    }\n\n    50% {\n        -webkit-transform: rotate(140deg);\n        transform: rotate(140deg)\n    }\n}\n\n.loader-circle {\n    top: 50%;\n    left: 50%;\n    z-index: 1;\n    color: #444;\n    margin-top: -1em;\n    margin-left: -1em;\n    position: absolute;\n    -webkit-animation: L_circle_rotate 1.568s linear infinite both;\n    animation: L_circle_rotate 1.568s linear infinite both\n}\n\n.loader-circle .loader-stroke-left:before,\n.loader-circle .loader-stroke-right:before,\n.loader-circle:before {\n    content: '';\n    display: block;\n    border-style: solid;\n    border-width: .21429em;\n    border-color: currentColor\n}\n\n.loader-circle,\n.loader-circle .loader-stroke-left,\n.loader-circle .loader-stroke-left:before,\n.loader-circle .loader-stroke-right,\n.loader-circle .loader-stroke-right:before,\n.loader-circle:before {\n    width: 2em;\n    height: 2em;\n    border-radius: 50%;\n    box-sizing: border-box\n}\n\n.loader-circle .loader-stroke-left:before,\n.loader-circle .loader-stroke-right {\n    position: absolute;\n    clip: rect(0 2em 2em 1em)\n}\n\n.loader-circle .loader-stroke-left,\n.loader-circle .loader-stroke-right:before {\n    position: absolute;\n    clip: rect(0 1em 2em 0)\n}\n\n.loader-circle:before {\n    position: absolute;\n    clip: rect(0 1.05em 1em .95em)\n}\n\n.loader-circle .loader-stroke-left,\n.loader-circle .loader-stroke-right,\n.loader-circle:before {\n    -webkit-animation: L_stroke_rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n    animation: L_stroke_rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both\n}\n\n.loader-circle .loader-stroke-right:before {\n    -webkit-animation: L_stroke_right_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n    animation: L_stroke_right_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both\n}\n\n.loader-circle .loader-stroke-left:before {\n    -webkit-animation: L_stroke_left_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n    animation: L_stroke_left_grow 1333ms cubic-bezier(.4, 0, .2, 1) infinite both\n}\n\n.mhn-slide.owl-carousel {\n    display: flex;\n    overflow: hidden;\n}\n\n.mhn-slide .mhn-item {\n    padding: 0px !important;\n    margin: 20px 0px 20px 0px;\n    display: flex;\n}\n\n.mhn-slide .mhn-inner {\n    width: 165.167px;\n    margin-right: 25px;\n    border-radius: 8px\n}\n\n.mhn-slide .mhn-item img {\n    display: none;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.mhn-slide .mhn-img {\n    overflow: hidden;\n    height: 120px;\n    width: 100%;\n    color: white;\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=) #eee no-repeat center/cover;\n    position: relative\n}\n\n.mhn-slide .mhn-text {\n    text-align: center;\n    padding: 0 10px\n}\n\n.mhn-slide .mhn-text h4 {\n    font-weight: 700;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden\n}\n\n.mhn-slide .mhn-text p {\n    max-height: 4.5em;\n    overflow: hidden\n}\n\n.mhn-slide .owl-stage-outer {\n    z-index: 1\n}\n\n.mhn-slide .owl-nav {\n    color: #333;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0\n}\n\n.mhn-slide .owl-nav svg {\n    color: currentColor\n}\n\n.mhn-slide .owl-nav .disabled {\n    display: none\n}\n\n.mhn-slide .owl-prev,\n.mhn-slide .owl-next {\n    top: 210px;\n    z-index: 2;\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n    margin-top: -20px;\n    position: absolute;\n    border-radius: 50%;\n    background-color: #fff;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, .3), 0 0 4px rgba(0, 0, 0, .2)\n}\n\n.mhn-slide .owl-prev {\n    left: -10px\n}\n\n.mhn-slide .owl-next {\n    right: -10px\n}\n\n@keyframes scroll {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(calc(-250px * 1));\n    }\n}\n\n.header-slider {\n    margin: 0px 0px 0px 30px;\n    touch-action: pan-y;\n    list-style: none;\n    position: relative;\n    overflow: hidden;\n    list-style: none;\n    padding: 0;\n    z-index: 1;\n}\n\n.header-slider::before,\n.header-slider::after {\n    content: \"\";\n    height: 100px;\n    position: absolute;\n    width: 200px;\n    z-index: 2;\n}\n\n.header-slider::after {\n    right: 0;\n    top: 0;\n    transform: rotateZ(180deg);\n}\n\n.header-slider::before {\n    left: 0;\n    top: 0;\n}\n\n.header-slider .header-slide-track {\n    animation: scroll 30s linear infinite;\n    display: flex;\n    width: 120px;\n}\n\n.header-slider .header-slide {\n    width: 177.2px;\n    margin-right: 50px;\n    flex-shrink: 0;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n}\n\n.header-slider .header-slide a {\n    text-decoration: none;\n    text-align: center !important;\n    font-size: 14px;\n    color: #fff !important;\n    text-transform: uppercase;\n    display: table;\n    margin: 0px auto;\n}\n\n.header-slider {\n    margin: 0px 0px 0px 30px;\n    touch-action: pan-y;\n    list-style: none;\n    position: relative;\n    overflow: hidden;\n    list-style: none;\n    padding: 0;\n    z-index: 1;\n}\n\n.header-slider::before,\n.header-slider::after {\n    content: \"\";\n    height: 100px;\n    position: absolute;\n    width: 200px;\n    z-index: 2;\n}\n\n.header-slider::after {\n    right: 0;\n    top: 0;\n    transform: rotateZ(180deg);\n}\n\n.header-slider::before {\n    left: 0;\n    top: 0;\n}\n\n.header-slider .header-slide-track {\n    animation: scroll 30s linear infinite;\n    display: flex;\n    width: 120px;\n}\n\n.header-slider .header-slide {\n    width: 177.2px;\n    margin-right: 50px;\n    flex-shrink: 0;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n}\n\n.header-slider .header-slide a {\n    text-align: center !important;\n    font-size: 14px;\n    color: #fff !important;\n    text-transform: uppercase;\n    display: table;\n    margin: 0px auto;\n}\n\n\n\n\n\n.menu-slider {\n    margin: 0px 0px 0px 30px;\n    touch-action: pan-y;\n    list-style: none;\n    position: relative;\n    overflow: hidden;\n    list-style: none;\n    padding: 0;\n    z-index: 1;\n}\n\n.menu-slider::before,\n.menu-slider::after {\n    content: \"\";\n    height: 100px;\n    position: absolute;\n    width: 200px;\n    z-index: -2;\n}\n\n.menu-slider::after {\n    right: 0;\n    top: 0;\n    transform: rotateZ(180deg);\n}\n\n.menu-slider::before {\n    left: 0;\n    top: 0;\n}\n\n.menu-slider .menu-slide-track {\n    animation: scroll 20s linear infinite;\n    display: flex;\n    width: 180px;\n}\n\n.menu-slider .menu-slide-track:hover {\n    -moz-animation-play-state: paused;\n    -webkit-animation-play-state: paused;\n    animation-play-state: paused;\n}\n\n\n.menu-slider .menu-slide {\n    width: 177.2px;\n    margin-right: 50px;\n    flex-shrink: 0;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n}\n\n.menu-slider .menu-slide a {\n    text-align: center !important;\n    font-size: 14px;\n    color: black !important;\n    text-decoration: none;\n    text-transform: uppercase;\n    display: table;\n    margin: 0px auto;\n}\n\na.stretched-a {\n    text-decoration: none;\n}\n\na.stretched-a {\n    text-decoration: none;\n}\n\n.services-item .details .icon {\n    margin: 0;\n    width: 62px;\n    height: 62px;\n    background: var(--color-primary);\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    color: var(--color-white);\n    font-size: 25px;\n    transition: ease-in-out 0.3s;\n    position: absolute;\n    top: -40px;\n    left: calc(50% - 36px);\n    border: 6px solid var(--color-white);\n}\n\n.services-item .details .icon:hover {\n    margin: 0;\n    width: 62px;\n    height: 62px;\n    background: var(--color-white);\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    color: var(--color-white);\n    font-size: 25px;\n    transition: ease-in-out 0.3s;\n    position: absolute;\n    top: -40px;\n    left: calc(50% - 36px);\n    border: 6px solid var(--color-primary);\n}\n\n.bi-gear::before {\n    content: \"\\f3e5\";\n}\n\ni.bi.bi-gear {\n    color: #fff;\n}\n\na.stretched-a h3 {\n    color: black;\n}\n\na.stretched-a h3 span {\n    color: black;\n}\n\n.services .service-item:hover .details h3 {\n    color: #302ba0;\n}\n\n.services .service-item:hover .details .icon i{color: #302ba0;}\n.services .service-item:hover .details .icon{border: 2px solid #302ba0;}\n\n.services .service-item .details h3 {\n    color: black;\n    font-size: 11px;\n}\n\n\n.bi::before,\n[class^=\"bi-\"]::before,\n[class*=\" bi-\"]::before {\n    display: inline-block;\n    font-family: bootstrap-icons !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    vertical-align: -0.125em;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.menu-slider .menu-slide .details {\n    height: 60px;\n    padding: 11px 10px;\n    margin: -39px 15px 0 15px;\n    transition: all ease-in-out 0.3s;\n    text-align: center;\n    border-radius: 8px;\n    background-color: #fff;\n    box-shadow: rgb(198, 196, 196);\n}\n\n.position-relative {\n    position: relative !important;\n}\n\n.menu-slider .menu-slide .details h3 {\n    font-size: 11px;\n    margin: 15px 0 8px 0;\n    font-weight: 700;\n    transition: ease-in-out 0.3s;\n}\n\n.menu-slider .menu-slide .details .icon {\n    font-size: 20px;\n    width: 45px;\n    height: 45px;\n    top: -22px;\n    margin: 0;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    transition: ease-in-out 0.3s;\n    position: absolute;\n    left: calc(50% - 27px);\n}\n\n.menu-slider .menu-slide .img {\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.container .section-main-heading {\n    border: 0 !important;\n    margin: -2px 0px 5px 0px !important;\n}\n\n/* .help {\n    position: absolute;\n    right: 0;\n    z-index: 111;\n    bottom: 0px;\n} */\n\n.help a img {\n    width: 190px;\n    position: absolute;\n    right: 20px;\n    bottom:6px;\n    height: 187px;\n}\n\n.about-head1 h4 {\n    text-align: justify;\n}\n.about-img2 p { text-align: justify;}\n\n.about-head1 p {\n    padding: 5px 0px 5px 10px;\n}\n\n.nav>li {\n    display: list-item !important;\n}\n\n.site-menu nav ul li .dropdown {\n    font-weight: 500 !important;\n    font-size: 13px !important;\n    padding-left: 15px;\n    margin-top: 12px;\n    color: #302ba0 !important;\n    border-bottom: 1px solid #E5E9EF !important;\n    list-style: disc;\n    display: inherit;\n    list-style-position: inside;\n}\n\n\nelement.style {\n    margin-left: 5px;\n}\n\n.site-menu nav ul li .dropdown .btn {\n    margin-top: -22px;\n}\n\n.section-main-heading2 h5 {\n    color: #fff;\n    margin-top: 12px;\n    font-style: italic;\n}\n\n.faq.birth_death .card-header a {\n    padding: 15px 20px 20px 20px;\n    font-weight: 600;\n    border: 0;\n    font-size: 14px;\n    text-align: left;\n    box-shadow: none;\n    padding: 15px 20px 15px 20px;\n    border-radius: 0px;\n}\n\n.faq.birth_death .card {\n    border: none !important;\n    border: 0;\n    margin-top: 15px;\n}\n\n.faq.birth_death .card-header {\n    background-color: #fff;\n    padding: 10px 0px;\n    border: none !important;\n}\n\n.faq.birth_death .card-header .card-a.collapsed {\n    color: black !important;\n}\n\n.faq.birth_death .card .card-header .card-a {\n    color: yellow !important;\n}\n\n.faq.birth_death .card-body {\n    font-size: 13px;\n    padding: 0px 20px;\n}\n\n#accordion .card-header a {\n    font-weight: 600;\n    border: 0;\n    font-size: 13px;\n    text-align: left;\n    box-shadow: none;\n    padding: 15px 20px 15px 20px;\n    border-radius: 0px;\n}\n\n#accordion .card { border-bottom: 1px solid #d3d3d3 !important; border: 0; margin: 10px 0px;}\n.language.login-1 .bi-chevron-down::before { padding: 4px; color: #fff !important;}\n#accordion .card-header { padding: 0px; border: none !important;}\n.card-header.responsiveheader{color: #fff !important; padding: 0px; border: none !important;}\n#accordion .card-body {\n    font-size: 13px;\n    padding: 0px;\n    padding-bottom: 0px;}\n\n\n#accordion .card .card-header .card-a.collapsed {\n    color: #000 !important;\n}\n\n.about-img3 p {\n    font-size: 13px;\n    line-height: 25px;\n    color: #000;\n    padding: 0px 0px 0px 0px;\n    display: inline;\n}\n\n.about-img3 img {\n    width: 200px;\n    height: 120px;\n    border-radius: 5px;\n    float: left;\n    margin: 0px 20px 0px 0px;\n}\n\n.about-head1 .w-50 .card {\n    width: 50%;\n}\n\n.about-head1 .w-30 .card {\n    width: 30%;\n}\n\n\n.about-head1 p {\n    display: inline-block;\n    line-height: 26px;\n    font-size: 13px;\n    text-align: left;\n    margin: 0px;\n    padding: 0px;\n}\n\n.btn-primary:focus {\n    color: #fff;\n    background-color: #0b5ed7;\n    border-color: #0a58ca;\n    box-shadow: 0 0 0 0.25rem rgb(49 132 253 / 50%);\n}\n\n.kmc-department th {\n    font-size: 13px;\n    font-weight: normal;\n}\n\n.kmc-department tr td {\n    font-size: 13px;\n}\n\n.depart {\n    min-height: 450px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    width: 100%;\n}\n\n.map2 a {\n    color: #302ba0;\n    margin: 7px 0px;\n    display: inline-block;\n    padding: 10px 10px;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, .125);\n    font-size: 14px;\n    width: 40%;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n\n.depart.Tender_batra {\n    height: 300px;\n}\n\n\n.dig-login2 {\n    width: 100%;\n    height: auto;\n    margin: 10px 0px 20px 0px;\n    padding: 20px;\n    background: #fff;\n    border-radius: 6px;\n    display: table;\n    box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n.dig-login2 .pdf-link1 h6 a{font-size: 13px;\n    line-height: 27px;}\n.dig-login2 .pdf-link1 h6 a:hover{text-decoration: none;}\n\n.agent-code {\n    border: 1px solid #1c5d9d;\n    background: #dfe8f6;\n    border-radius: 5px;\n    padding: 16px;\n    margin-left: 12px\n}\n\n.agent-code h4 {\n    font-size: 14px;\n    color: #1c5d9d;\n    font-weight: 600\n}\n\n.agent-code h5 {\n    font-size: 13px;\n    color: #000;\n    font-weight: 600;\n    margin-bottom: 0\n}\n\n.agent-code p {\n    font-size: 12px;\n    color: #000;\n    font-weight: 400;\n    margin-bottom: 2px\n}\n\n.agent-code input {\n    border: none;\n    border-radius: 5px;\n    width: 350px;\n    font-size: 12px;\n    height: 28px;\n    margin-top: 4px;\n    margin-left: 16px;\n    padding: 0 8px\n}\n\n.agent-code button {\n    width: 150px;\n    border-radius: 5px;\n    height: 30px;\n    margin: auto;\n    display: block;\n    border: 1px solid #1c5d9d;\n    margin-top: 24px;\n    font-size: 13px;\n    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);\n    color: #1c5d9d;\n    font-weight: 600\n}\n\n.no-margin {\n    margin-top: 0\n}\n\n.advertisement .accordion-button {\n    padding: 10px 20px 10px 20px;\n    font-size: 13px\n}\n\n.advertisement .accordion-item {\n    margin-top: 8px\n}\n\n.advertisement ul {\n    margin-bottom: 0\n}\n\n.advertisement li {\n    line-height: 24px;\n    font-size: 13px\n}\n\n.advertisement .accordion-body {\n    padding: 0 25px 12px 20px\n}\n\n.dig-form {\n    width: 100%;\n    height: auto;\n    display: table;\n    margin: 0px 20px 0px 0;\n    padding: 16px 20px 0;\n    background: #fff;\n    border-radius: 6px;\n}\n\n.dig-form .log-form h3 {\n    text-align: left;\n    width: 100%;\n}\n\n.dig-form .log-form .continu a {\n    margin: auto;\n    display: block;\n    width: 220px;\n    float: none\n}\n\n.dig-form .form-group {\n    margin-bottom: 0\n}\n\n.dig-form .subheader {\n    font-size: 12px;\n    margin-top: 0px;\n    text-align: left !important;\n    margin-left: 20px;\n    margin-bottom: -10px\n}\n\n.dig-form .subtitle {\n    font-size: 16px !important;\n    margin-top: 6px;\n    margin-bottom: 0px;\n    text-align: left !important;\n    padding-top: 6px !important\n}\n\n.dig-form .form-label {\n    font-size: 13px !important;\n    color: #302ba0;\n    margin-bottom: 0;\n    font-weight: 500\n}\n\n.dig-form .log-form .form-group input {\n    border: 1px solid #302ba0;\n    border-radius: inherit\n}\n\n.dig-form .login__field {\n    margin-bottom: 1rem\n}\n\n.dig-form .break {\n    margin-top: 2rem;\n    margin-bottom: 2rem\n}\n\n.dig-form .disclaimer {\n    font-size: 14px;\n    margin-top: 0px;\n    text-align: center !important;\n    margin-bottom: 0;\n    padding: 10px 2rem 0 2rem !important\n}\n\n.dig-form .log-form .form-group select {\n    border: 1px solid #302ba0;\n    -webkit-appearance: listbox !important;\n}\n\n.orbtn {\n    color: #fff;\n    font-size: 14px;\n    text-align: center;\n    margin: 10px auto 4px;\n    background: #302ba0;\n    width: 30px;\n    border-radius: 50px;\n    height: 30px;\n    padding: 6px 2px;\n}\n\n.menu-show-more-btn { border: none !important; background: #fff !important; color: #090253 !important; text-align: right !important; font-weight: 600 !important;margin-top: 6px !important;}\n\n.show-more-menu {\n    display: none\n}\n\n.menu-show-less-btn {\n    border: none;\n    background: #fff;\n    color: #302ba0;\n    text-align: right;\n    font-weight: 600;\n    margin-top: 2px;\n    float: right\n}\n\n.menu-show-less-btn:hover {\n    color: #090253\n}\n\n.mayor-table .officials header-table td {\n    color: #fff !important;\n    font-weight: 500\n}\n\n.mayor-table .officials .content-table tr td {\n    color: #000 !important;\n    font-weight: 400\n}\n\n.list-of-forms h6 {\n    text-decoration: underline;\n    color: #0d6efd;\n    font-size: 13px;\n    font-weight: 400\n}\n\n.frms {\n    margin-bottom: 1rem !important\n}\n\n.min-hg {\n    min-height: 300px\n}\n\n.tb-1 {\n    width: 100% !important\n}\n\n.tb-1 td {\n    border-color: #dee2e6;\n    border-style: solid;\n    border-width: 1px;\n    font-size: 13px\n}\n\n.tb-1 td b {\n    text-decoration: underline;\n    color: #0d6efd;\n    pointer-events: button;\n    font-weight: 400 !important;\n    font-size: 12px\n}\n\n.dig-form .subtt-ad {\n    font-size: 16px !important;\n    margin-top: 6px;\n    margin-bottom: 16px;\n    text-align: left !important;\n    padding-top: 6px !important\n}\n\n.dig-form tr .padd-tb {\n    padding: 4px 6px;\n    color: #000\n}\n\n.dig-form .rates {\n    padding: 0 !important\n}\n\n.dig-form .rates .rm-mg {\n    margin-left: 0 !important\n}\n\n.dig-form .rates .rm-mg td {\n    padding: 4px 0\n}\n\n.list-items {\n    padding-top: 20px\n}\n\n.list-items li {\n    font-size: 13px;\n    color: #000;\n    font-weight: 400\n}\n\n.list-items b {\n    font-size: 13px;\n    margin-left: 20px\n}\n\n.dig-login1 .log-form .form-group select {\n    height: 40px;\n}\n\n.table-warning{color:#fff !important;}\n.col-lg-12.about-head1 { padding: 0;}\n.li-style{color: #16181b !important; text-decoration: none; padding: 10px !important;    }\n.li-style:hover{background-color: #e9ecef;}\n.make_online_payment .card-body a{color: var(--color-links); text-decoration: none; font-size: 13px}\n.make_online_payment .card-body{padding: 0;}\n.faq .accordion-button:not(.collapsed) { color:#000; border-bottom: 0; box-shadow: none;}\n.NavBar_container .dropdown .dropdown-menu a{font-weight: 500 !important;height: 25px;font-size: 13px !important; color: #302ba0 !important; list-style: disc;display: inherit;list-style-position: inside;}\n.NavBar_container .dropdown .dropdown-menu{height: auto; }\n.mayor-table table tr td.white-clr { color: #fff;}\n.dropdown-menu.dept-menu{height: 280px; overflow: scroll;}\nul.dropdown-menu.multi-level.min-height-400.show {z-index: 1 !important;}\n\n.carousel-caption {text-align: left;}\n\n/* 11-01-2023 */\n.carousel-item { width:100% !important; height: 200px; margin-right: inherit !important; }\n.carousel-item img{height: 200px; width:100% !important;}\n.bi-chevron-down::before {content: \"\\f282\";  color: #fff;}\n.float_right{float: right;}\n\n.faq .accordion-flush .collapse .card ul li a{ font-size: 12px !important; text-decoration: none; }\n.faq .accordion-flush p{margin: 0px; font-size: 12px; line-height: 24px; padding: 0px 10px 0px 10px;}\n.faq .accordion-flush button {padding: 10px 20px;}\n.faq .accordion-flush p h3{ margin: 0px;}\n\n\n.mayor-table-column{ margin: -20px 0px 0px 0px;}\n.login-1 .btn-secondary:focus{background:none; box-shadow:none;}\n\n.card-header .btn-link fontSizeClass :focus {text-decoration:none; box-shadow:none; } \n.card-header .btn-link fontSizeClass :hover{text-decoration: none;}\n.history_of_kolkata .collapse{margin: 10px 0px;}\n\n.card .card-header .m-2{ margin: 0px !important;}\n.presid-1{width: 40%; border-radius: 10px; margin: 20px 0px 0px 0px;}\n\n\n/* 17-02-2023 */\n.about-head1 .more-but2 {margin: 10px 0px 10px 0px;}\n\n\n\n/* ======================18-02-23=== */\n.site-menu .nav_dropdown .nav-link{font-size: 11PX !important;}\n.pdf-link1{border: 1px solid rgb(197, 196, 196); border-radius: 4px;}\n.quick-part{display: inline-block; }\n.q-link {background:#302ba0; color: #fff;}\n.quick-part a{font-size: 14px; padding:8px 15px; \n    border-radius:5px; margin:5px 0px 0px 0px;\n    display: inline-block;\n    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);\n    width: 100%; font-weight: 500;}\n.mayor-table2 table .nav-link{padding: initial;}\n/* AUROBINDA */\n.site-menu .nav_dropdown .nav-link{font-size: 11PX !important;}\n.quick-part{display: inline-block; }\n.q-link {background:#302ba0; color: #fff;}\n.quick-part a{font-size: 14px; \n    padding:6px 15px; \n    border-radius:5px; margin:5px 0px 0px 0px;\n    display: inline-block;\n    box-shadow: 0px 0 25px rgba(var(--color-black-rgb), 0.1);\n    width: 100%; font-weight: 500;}\n\n.faq .card .card-header{padding: 10px;}.faq .card .card-header button { margin-top: 15px; border: 0px; width: 100%; text-align: left; background: #fff;box-shadow: 0px 0 16px rgb(0 0 0 / 10%); font-weight: bold; font-size: 14px; color: #000;}\n.faq .card .card-header button i{float: right;}\n.faq .card .card-header button i::before{color: #000 !important; font-weight: bold; text-align: right; }\n.faq .card .card-header .btn-link:focus {text-decoration: none;}\n.faq .card .card-header button:hover {text-decoration: none;}\n.scrl1{height:150px; overflow-y: scroll; overflow-x: hidden; }\n.scrl1 p {text-align: left; padding: 0px 10px;}\n.card-body p{text-align: justify;font-size: 13px;}\n.nav-item.nav_dropdown .card-header .btn-link{padding-left: 0px !important;}\n.card .card-header .btn-link{text-align: left;\n    font-size: 13px;\n    color: black; width: 100%;}\n.text-justify{text-align: justify !important;}\n\n/*==================== 24-02-2023 ================ */\n\n.faq .card .card-header{padding: 10px;}\n.faq .card .card-header button { margin-top: 15px; border: 0px; width: 100%; text-align: left; background: #fff;\n  box-shadow: 0px 0 16px rgb(0 0 0 / 10%); font-weight: bold; font-size: 14px; color: #000;}\n  .faq .card .card-header button i{float: right;}\n  .faq .card .card-header button i::before{color: #000 !important; font-weight: bold; text-align: right; }\n.faq .card .card-header .btn-link:focus {text-decoration: none;}\n.faq .card .card-header button:hover {text-decoration: none;}\n.scrl1{height:150px;  overflow-y: scroll; overflow-x: hidden; }\n.scrl1 p {text-align: left; padding: 0px 10px;}\n\n/*==================== 24-02-2023 ================ */\n/*==================== 27-02-2023 ================ */\n.eodb-site-menu .nav-pills{background-color:#fff; border-radius:0px;  }\n.eodb-site-menu .nav-pills a { font-size: 13px; text-align: left; color:#302ba0; \nborder-bottom: 1px solid #c6c4e5; border-radius:0px; line-height: 30px; font-weight: bold;}\n.eodb-but1 .modal .modal-content .modal-title{font-size: 15px; color: #302ba0; font-weight: bold;}\n.eodb-but1 .modal .modal-content .modal-footer button{background:#302ba0; padding:8px 20px; color: #fff;}\n.eodb-but1 .modal .modal-content .modal-body .mod-hed-1 img{ width: 60px; float: left;}\n.eodb-but1 .modal .modal-content .modal-body .mod-hed-1 p{ font-size: 13px; display: inline-block; \n width:85%;  padding:10px; }\n .model-list{padding: 0px 0px 0px 2px;}\n .model-list li{ font-size: 14px; list-style: none; font-weight: bold; color:#302ba0;\n     line-height: 30px;}\n.eodb-but1 button:focus:not(:focus-visible){box-shadow:none}\n\n.eodb-but1 button ul{  list-style: inside; margin: 0px 0px 0px -21px; color:#302ba0; \n    padding: 0px; display: flex; text-decoration: underline;}\n.eodb-1 a ul{ list-style: inside; margin: 0px 0px 0px -21px; \n    color:#302ba0; padding: 0px; display: flex;}\n.eodb-1 a ul li{text-decoration: underline; }\n\n .eodb-1 a,\n .eodb-pd-li button{padding:5px 66px 0px 19px; font-size: 15px; color: #302ba0; font-weight: bold;}\n .eodb-1 a:focus:not(:focus-visible){box-shadow:none}\n .eodb-1 .card-body{padding: 10px;}\n .eodb-but1{margin:5px 0px 0px 0px; }\n .eodb-but1 button{padding: 10px 20px 0px 20px; font-size: 15px; color: #302ba0; font-weight: bold; }\n .eodb-titl {color:#302ba0; font-size: 23px; background-color: #c6c4e5; padding: 10px 20px;}\n .eodb-1 p{margin: 0px;}\n .eodb-li{list-style: none; margin: -9px 0px 0px -10px; padding:10px 20px; width:35%; font-size: 13px;\n    line-height: 30px;  border-radius: 3px; box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%), inset 0 -1px 0 rgb(255 255 255 / 15%);}\n .eodb-li li a{ margin:0px; padding:0px; line-height:30px; font-size: 13px; color:#000; border: none;}\n .eodb-li li a:hover{color:#007bff;}\n .eodb-pdf .eodb-pd-li {font-size: 15px; color: #302ba0; padding:5px 0px 0px 0px;\n    line-height: 31px; list-style: inside; line-height: 35px; }\n.eodb-pdf .eodb-pd-li a{color: #302ba0; font-weight: bold; text-decoration: underline; }\n.eodb-1 .collapse .card img {float: left;}\n\n.desh-bo-2 {width: 100%; display: inline-block;}\n.desh-bo-2 .card .card-header button { width:100%; text-decoration: none;  \nbackground:#fff; border: 1px solid #c6c4e5; font-size: 13px; text-align: left; \ncolor: #302ba0; font-weight: bold; padding: 10px 15px; }\n.desh-bo-2 .card .card-header .active{color: #fff; background-color: #007bff; }\n.desh-bo-2 #accordion .card-body{padding:5px; text-align: left; }\n.desh-bo-2 #accordion .card{border-bottom:none !important; margin: 0px;}\n\n.desh-bo-2 #accordion .card .collapse {position:relative; width: 100%; margin:0px 0px 0px 0px; z-index: 11111; }\n.desh-bo-2 #accordion .card-body {border: 1px solid #c6c4e5; width: 100%; color: #000; z-index: 11111; \n    background: #fff; padding: 5px 10px 5px 10px; border-radius: 3px; font-size: 12px; text-align: justify; }\n\n\n.desh-bo-ser {clear: both; }\n.desh-bo-ser .card {margin:10px 0px;}\n.desh-bo-ser .card .card-header{padding: 0px; border-bottom: none;}\n.desh-bo-ser .card .card-header button{width: 100%; float: left;  color: #fff; padding: 8px 20px;\n    text-align: justify; font-weight: bold; font-size:14px; text-decoration: none;}\n\n.des2-list{height: 200px; overflow-y: scroll; padding: 10px 20px 10px 30px; }\n.des2-list ul {padding: 0px;}\n.des2-list ul li a{list-style: none; padding: 0px; font-size: 12px; color: #007bff;}\n.des2-list ul li a:hover{color: #000;}\n\n.desh-bo-ser .card .card-header h5 button i {float: right; color: #fff;}\n.desh-bo-2 .card .card-header button i{float: right; color: #fff;}\n\n.desh-bo-ser .card .card-header .btn .bi-chevron-down::before {color: #FFF !important;}\n\n.colr1{ background-color: #191e57 !important;}\n\n.colr2{background: #3e4bd6 !important;}\n\n.colr3{background: #434457 !important; }\n\n.colr4{background: #2f39a3 !important; }\n\n.colr5{background: #6c5d9e !important; }\n\n.colr6{background: #35246b !important; }\n\n.colr7{ background: #d7a75f !important;}\n\n.colr8{background: #9e7b5d !important; }\n\n.colr9{background: #2f39a3 !important; }\n\n\n/*==================== 27-02-2023 ================ */\n\n\n\n.inner-title2 {float: left; width: 100%;}\n.inner-pad1 .quick-t h3{padding: 0px 0px 0px 14px;}\n\n/*==================== 13-03-2023 ================ */\n.logo {float: left;}\n.header-office_name {display: inline-block;}\n\n.megamenu1 .navbar{\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.megamenu1 .navbar-light .navbar-brand {\n    color: #1b08c5;\n}\n.megamenu1 .navbar-light .navbar-nav .nav-link {\n    color: #fff; font-weight: 300;\n}\n.megamenu1 .navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {\n    color: #1ebdc2;\n}\n.megamenu1 .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {\n    color: #ffde00 !important;\n}\n.megamenu1 .navbar-light .navbar-nav .nav-link{\n    padding-top:0px;\n    padding-bottom: 0px;\n    transition: 0.3s;\n    padding:7px 15px 7px 15px;\n    font-size: 14px; \n    color: #fff !important;\n}\n.megamenu1 .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover{\n    transition: 0.3s;\n}\n.megamenu1 .dropdown-item:focus, .dropdown-item:hover {\n   color: #fff !important;\n   text-decoration: none;\n   background-color: #302ba0 !important;\n}\n.megamenu1 .sm-menu{\n   border-radius: 0px;\n   border: 0px;\n   top: 35px;\n   background: #fff;\n   color: #0a0185;\n   box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n}\n.megamenu1 .sm-menu a{padding:7px 10px; color: #000; border-bottom: 1px solid #f6f6fe;}\n\n.megamenu1 .sm-menu h6{padding:0px 10px; color: #0a0185; font-size: 13px;}\n.megamenu1 .sm-menu .navcol {color: #0a0185; font-size: 13px; font-weight: 500;}\n\n.megamenu1 .dropdown-item {\n   color: #302ba0; font-size: 12px;\n}\n.megamenu1 .dropdown-item.active, .dropdown-item:active {\n   color: #fff;\n   text-decoration: none;\n   background-color: #2196F3;\n}\n.megamenu1 .navbar-toggler{\n   outline: none !important;\n}\n.megamenu1 .navbar-tog{\n   color: #1ebdc2;\n}\n.megamenu1 .megamenu-li {\n   position: static;\n}\n\n.megamenu1 .megamenu {\n   position: absolute;\n   width: 100%;\n   left: 0;\n   right: 0;\n   padding: 10px;\n}\n.megamenu1 .megamenu1 .megamenu h6{\n   margin-left: 21px;\n}\n.megamenu1 .megamenu i{\n   width: 20px;\n}\n.megamenu1 .navbar .nav-link{padding: 0px;}\n\n/*==================== social-media ========================= */\n\n.social-media {\n    position: fixed;\n    float: left;\n    top: 44%;\n    background: none;\n    height: auto;\n    width: 50px;\n    z-index: 111;\n    left: 0;\n}\n\n\n.social-media .facebook a {\n    padding: 10px 5px;\n    display: inline-block;\n    background: #35528e;\n    color: #fff;\n    text-align: center; transition-duration:0.5s;\n}\n.social-media .facebook a:hover{padding: 10px 15px; color: #fff; background: #35528e; transition-duration: 0.5s;}\n.social-media .facebook img{width: 30px; height:25px;}\n\n.social-media .twitter a {\n    padding: 10px 5px;\n    display: inline-block;\n    background: #1da1f2;\n    color: #fff;\n    text-align: center; transition-duration:0.5s;\n}\n.social-media .twitter a:hover{padding: 10px 15px; color: #fff; background: #1da1f2; transition-duration:0.5s;}\n.social-media .twitter img{width: 30px; height:25px;}\n\n.social-media .support a {\n    padding: 10px 5px;\n    display: inline-block;\n    background: #302ba0;\n    color: #fff;\n    text-align: center; transition-duration:0.5s;\n} \n.social-media .support a:hover{padding: 10px 15px; color:#fff; background: #302ba0; transition-duration:0.5s;}\n.social-media .support img{width: 30px; height:25px;}\n\n\n.social-media .whatsapp a {\n    padding: 10px 5px;\n    display: inline-block;\n    background: #25D366;\n    color: #fff;\n    text-align: center; transition-duration:0.5s;\n}\n\n.social-media .whatsapp a:hover{padding: 10px 15px; color: #fff; background: #25D366; transition-duration:0.5s;}\n.social-media .whatsapp img{width: 30px; height:25px;}\n\n\n.quick1 .sidebar .nav .quick-scrl{overflow-x:hidden; overflow-y: scroll; height: 100px;} \n.site-menu nav ul li .btn:focus {box-shadow:none;}\n.quick2 .sidebar .btn:focus {box-shadow:none;}\n\n/*==================== 22-03-2023 ========================= */\n.login-1 .dropdown button .bi-chevron-down::before{color: #fff !important;}\n.NavBar_container .NavBar_container--navbar .nav-menu .nav-item-list .card-header \n.nav-item-list .bi-chevron-down::before {color: #fff !important;}\n\n.glightbox-clean .gclose {\n    width: 35px;\n    height: 35px;\n    top: 15px;\n    right: 10px;\n    position: absolute;\n}\n\n/*==================== 06-04-23 ========================= */\n.more-but button{padding:5px 18px; font-size: 14px; color: #fff; background-color: #302ba0;}\n.more-but button .bi-chevron-down::before{color: #fff !important;}\n\n.about-img3 strong .btn{font-size: 13px; padding:3px 10px; background-color: #302ba0; color: #fff; margin: 0px 0px 0px 10px;}\n.about-img3 strong .btn .bi-chevron-down::before {color: #fff !important; font-size: 12px; padding: 0px 0px 0px 3px;}\n\n/*==================== 18-04-23 ========================= */\n\n.table-bor-2a td{color: #fff; vertical-align: middle !important; text-align: right;}\n.tab-bord1 {float: right;}\n.tab-bord1 td {border: solid 1px #fff !important; text-align: center; padding: 3px 8px !important;}\n.col-td1{width: 50%;}\n.list-items2a ul{ text-align: justify;\n    font-size: 13px;\n    padding: 0px 0px 0px 0px;\n    list-style: lower-roman inside;\n    line-height: 25px; }\n.rts-p{font-size: 12px; line-height: 30px;}\n.tex-col-1b {color: #FF0000;}\n.table-scl-3a {height: 250px; overflow-y: scroll; display: inline-block;}\n.eng-tab-width1 {width: 50%;}\n.center1 {text-align: center;}\n\n.thumb .fancybox img {width: 100%; overflow-y: hidden; height: 150px; margin: 0px 0px 30px 0px;}\n.gal-hight {margin: 70px 0px 0px 0px;}\n\n.rtinner ul li a {list-style: none; line-height:30px; font-size: 15px; }\n.rtinner ul {display: inline; list-style: inside;}\n\n.btn-1{font-size: 10px !important;}\n.nav-item a .bi-chevron-right::before{font-size:10px; text-align: right;}\n\n\n\n\n\n\n\n/*==================== Only For Responsive========================= */\n\n\n@media screen and (max-width:1920px) {\n    .language .dropdown-toggle{padding:4px 20px;}   \n    .hero2 img{width:100%;}\n}\n@media screen and (min-width:1357px) {\n .NavBar_container {  margin-top: 193px !important; }\n}\n\n@media screen and (max-width: 1200px) { \n    \n    .megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}\n\n    .Banner {margin-top:-65px; height:241px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:183px; width:100% !important;}\n    .banner-container{height:248px;}\n    .help a img {right: 25px; width: 177px; height: 174px;}\n\n}\n\n@media screen and (max-width: 1104px) {\n    .text_english {font-size: 12px !important;}}\n\n@media screen and (max-width: 1100px) {\n    .text_english {font-size: 12px !important;}\n    .megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}\n\n    .Banner {margin-top:-65px; height:210px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:152px; width:100% !important;}\n    .banner-container{height:214px;}\n    .help a img {right: 25px; width: 153px; height: 145px;}\n}\n\n@media screen and (max-width: 1024px) { \n.text_english {font-size: 13px !important;}\n.login-1 { margin: 0px -12px 0px 0px;}\n.megamenu1 .navbar-light .navbar-nav .nav-link{font-size: 10px;}\n\n.Banner {margin-top:-65px; height:210px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:152px; width:100% !important;}\n    .banner-container{height:214px;}\n    .help a img {right: 13px; width: 153px; height: 145px;}\n\n}\n\n@media screen and (max-width: 992px) { \n    \n    .megamenu1 .navbar-light .navbar-nav .nav-link{    font-size: 10px;}\n    .text_english {font-size: 13px !important;}\n    .login-1 { margin: 0px -12px 0px 0px;}\n\n    /* ======= Mega menu =========*/\n   .header2 { z-index: 111; position: relative; padding: 0px; }\n   .megamenu1 {padding: 0px; }\n   .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n   .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n   .megamenu1 .navbar-collapse { box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n   .megamenu1 .navbar{padding: 0px;}\n   /* ======= Mega menu =========*/\n   .Banner {margin-top:-65px; height:210px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:152px; width:100% !important;}\n    .banner-container{height:214px;}\n    .help a img {right: 13px; width: 115px; height: 114px;}\n\n}\n\n\n/*==================== 27-02-2023 ================ */\n@media (max-width: 967px) {\n.nav.nav-tabs{border-bottom:0;border-right:1px solid transparent;display:block; \n    margin-right:20px; width:100%!important}\n.horizontal-tabs .nav-tabs{width:100%;padding:0}\n}\n/*==================== 27-02-2023 ================ */\n\n\n@media screen and (max-width:890px) {\n    .text_bengali {font-size: 18px;}\n    .text_english {font-size: 14px; }\n    .login-1 {margin: 0px -13px 0px 0px;}\n   /* .container, .container-md, .container-sm { max-width: 840px; } */\n   /* ======= Mega menu =========*/\n   .header2 { z-index: 111; position: relative; padding: 0px; }\n   .megamenu1 {padding: 0px; }\n   .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n   .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n   .megamenu1 .navbar-collapse {padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n   .megamenu1 .navbar{padding: 0px;}\n   /* ======= Mega menu =========*/\n   .Banner {margin-top:-65px; height:190px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:133px; width:100% !important;}\n    .banner-container{height:190px;}\n    .help a img {right: 13px; width: 115px; height: 114px;}\n\n}\n\n@media screen and (max-width:870px) {\n    .text_bengali {font-size: 12px !important;}\n    .text_english {font-size: 12px !important;}\n }\n\n@media screen and (max-width:850px) {\n    .text_bengali {font-size: 12px !important;}\n    .text_english {font-size: 12px !important;}\n }\n\n@media screen and (max-width: 820px) {\n.font-site {width: 72px;} \n.login-1{margin: 0px 0px 0px 0px !important;}\n.text_english {font-size: 10px !important;}\n\n /* ======= Mega menu =========*/\n .header2 { z-index: 11111; position: relative; padding: 0px; }\n .megamenu1 {padding: 0px; }\n .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n .megamenu1 .navbar{padding: 0px;}\n /* ======= Mega menu =========*/\n\n.Banner {margin-top:-65px; height:180px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:123px; width:100% !important;}\n    .banner-container{height:190px;}\n    .help a img {right: 13px; width: 115px; height: 114px;}\n    \n}\n\n@media screen and (max-width: 815px) {\n\n    .font-site {width: 72px;} \n    /* ======= Mega menu =========*/\n    .header2 { z-index: 111; position: relative; padding: 0px; }\n    .megamenu1 {padding: 0px; }\n    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n    .megamenu1 .navbar-collapse {padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n    .megamenu1 .navbar{padding: 0px;}\n    /* ======= Mega menu =========*/\n    .text_english {font-size: 10px !important;}\n    .text_bengali{font-size: 13px !important;}\n\n\n}\n\n@media screen and (max-width: 768px) {\n    .inner-pad1 {padding: 0px 0px 0px 0px;    }\n    .container.aos-init.aos-animate .col-lg-3{padding: 0 !important;}\n    .pdf-link1 h6{line-height: 30px;text-align: justify;}\n    \n    .inner-title2 h3 {padding: 25px 0px 0px 0px;}\n    .text_english { font-size: 10px !important; padding: 10px 10px!important;}\n    .language.login-1 { margin-right: 50px; }\n    .language_dropdown { margin: -11px 0px 0px 0px;}\n    .mayar img { width: 65px; }\n    .col-lg-8.col-md-8.col-sm-12.message-board{flex: 100%; max-width: 100%;}\n    /*.container, .container-sm { max-width: 90% !important;}*/\n    .faq {margin-top: 20px;padding: 0;}\n    .site-menu-div{ display: none;} \n    .NavBar_container{ position: sticky;  z-index: 999; bottom: 0px;right: 0px;margin-top: 0;    }\n    .text_bengali {font-size: 15px; padding: 20px 10px 10px !important; }\n    .header { padding: 0px;z-index:20 !important;}\n    .modal-open{overflow:hidden !important; }   \n    .nav-menu { display: flex; flex-direction: column; justify-content: unset; width: 100%; border-top: 1pxsolid #fff; \n\tposition: absolute;  padding: 0px; text-align: left; left: -110%; opacity: 1; height: 100%; transition: all 0.5s ease; } \n    .nav-menu.active{ background: #302ba0; left: 0px; opacity: 1; transition: all 0.5s ease; z-index: 1;\n    position: fixed; top: 0; padding-top: 17px; bottom: 0; width: 84%; }\n    .font-site-mbl,.font-site{ display: block; }\n    .nav-item-list .active { color: #ffdd40;  border: none;}\n    .nav-links { padding:0px 31px !important;  width: 100%;  display: table; text-align: left !important; } \n    .nav-icon { display: block; position: fixed; top: -27px; right: -18px; transform: translate(-100%, 60%); font-size: 1.8rem;\n      cursor: pointer; color: #ffdd40; }\n   /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex{flex: 50%; max-width: 50%;} */\n    .mayar {margin: 5px -8px 0px 0px;}\n  \n    \n    .lg span {  font-size: 15px;  top: 18px;  }\n    .header .logo img { width: 40px; }\n    .mayar img { width:50px; }\n    .header1 {line-height: 0px; }\n    .search { margin:9px 0px 0px 0px; }\n    .language {margin: -10px 0px 0px 0px; }\n    .font-site {  width:auto; margin: 0px; }\n    .message1 { font-size: 9px; }\n    .message1 img { width: 59px;}   \n    .carousel-caption{ text-align: left !important; }\n    .head-part1 {  margin: 12px 0px 0px 0px;  float: right;}\n    \n    /* ======= Mega menu =========*/\n    .header2 { z-index: 111; position: relative; padding: 0px; }\n    .megamenu1 {padding: 0px; }\n    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n    .megamenu1 .navbar{padding: 0px;}\n    /* ======= Mega menu =========*/\n\n    .white-bgtxt { width: 45%;}\n    .col-6.white-bgtxt ul li { font-size: 10px; padding: 3px 0px;}\n    .col-6.white-bgtxt h6 { font-size: 16px;}\n    .site-menu nav ul li a i::before { font-size: 10px; }\n    .site-menu nav ul li a { font-size: 9px !important;}\n    .carousel-indicators {  bottom: 20px !important; }\n    .swiper-slide { width: 200px !important;  margin-right: 40px !important; }\n    .certificate1 ul li a {font-size: 11px; }\n    .navbar-fixed{top: 66px; z-index: 11;}\n    .navbar-fixed2{top:66px; padding: 4px 10px; height: auto; z-index: 11;}\n    .help a img { width:117px; bottom:0px; right:13px; height:119px;}\n\n    .Banner {margin-top:-76px; height:180px;}\n    .Banner .carousel-item { width:100% !important; height:134px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:123px; width:100% !important;}\n    .banner-container{height:190px;}\n    .login-1 {margin: 0px 56px 0px 0px; }\n\t/*.search-div{display: none;}*/\n    .site-menu nav ul li .btn {font-size: 11px !important;}\n\n    .lang-set{width: auto !important;}\n    .login-1{margin: -7px 0px 0px 0px !important;}\n    .site-menu nav ul li .btn .bi-chevron-down::before{padding: 0px 0px 0px 8px;}\n    .site-menu .nav_dropdown .nav-link{font-size: 9PX !important;}\n    .site-menu .nav_dropdown .btn-link fontSizeClass :focus {text-decoration: none; box-shadow: none;}\n\n    .dig-form{margin: 16px 0px 0px 0;}\n    \n}\n\n@media screen and (max-width: 767px) {.hid {display: none;}}\n\n@media screen and (max-width: 760px) {\n    .hid {display: none;}\n /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex{flex: 45%; max-width: 45%;} */\n  .NavBar_container{ position: sticky; z-index: 999; bottom: 0px; right: 0px; margin-top: 0;}\n  .header { padding: 0px; z-index:20 !important;}\n  .modal-open{overflow:hidden !important;}    \n  .nav-menu { display: flex; flex-direction: column; justify-content: unset; width: 100%; border-top: 1px solid #fff;\n   position: absolute; padding: 0px; text-align: left; left: -110%; opacity: 1; height: 100%; transition: all 0.5s ease;} \n  .nav-menu.active{\n   background: rgba(0,0,0,0.9); left: 0px; opacity: 1; transition: all 0.5s ease; z-index: 1; position: fixed; top: 0; padding-top: 17px;\n    bottom: 0; width: 85%; }\n  .font-site-mbl, .font-site{ display: block;}\n  .nav-item-list .active { color: #ffdd40; border: none;}\n  .nav-links { padding:0px 31px !important; width: 100%; display: table; text-align: left !important;} \n  .nav-icon { display: block; position: fixed; top: -18px; right: -18px; transform: translate(-100%, 60%);\n   font-size: 1.8rem; cursor: pointer; color: #ffdd40;}\n   \n  }\n\n  @media screen and (max-width: 740px) { .hid {display: none;}}\n\n  @media screen and (max-width: 700px) {  \n    \n    .hid {display: none;}\n    .mayar { margin: 5px 0px 0px 0px;}\n   /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 65% ;max-width: 65%;} */\n    .nav-icon{right:14px;}\n    .text_english {font-size:9px; }\n    .text_bengali {font-size:7px !important;}\n    .title2 h4{padding: 8px 0px 5px 30px;}\n    .whats-new{ padding: 0px 0px 0px 0px;}\n\n    .policy-img2{ height: 58px;}\n    .policy-img2 span{font-size: 8px;}\n    .policy-img2 h4 {line-height: 5px;}\n\n    .navbar-fixed{display: none;}\n\n    /* ======= Mega menu =========*/\n    .header2 { z-index: 111; position: relative; padding: 0px; }\n    .megamenu1 {padding: 0px; }\n    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n    .megamenu1 .navbar{padding: 0px;}\n    /* ======= Mega menu =========*/\n \n    /* .about .about-img img {width: 100%; height: auto;}\n    .about .about-img {margin:0px 0 0 0px; width: 100%;} */\n    .NavBar_container{display: block;   }\n    .help a img { width: 112px; top: -124px; height: 118px;}\n\n    .Banner {margin-top: -76px; height:173px;}\n    .Banner .carousel-item { width:100% !important; height:115px; top: 58px; margin-right: inherit !important; }\n    .Banner .carousel-item img{height:115px; width:100% !important;}\n    .banner-container{height:188px;}\n\n    .carousel-caption {bottom: 60px !important; top:45% !important;\n     padding-bottom: 0px !important; left: 8% !important;}\n     .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}\n\n     .navbar-fixed2{display: none;}\n     .login-1 {margin: -7px 3px 0px 0px !important; }\n\n     .head-part1 { margin: 12px 0px 0px 0px;}\n     .section.inner-pad1{margin-top: 20px;}\n  }\n  \n\n@media screen and (max-width: 600px) {\n    \n    .mayar { margin: 5px 0px 0px 0px;}  \n    /* .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 65% ;max-width: 65%;} */\n    .hid {display: none;}\n    .head-part1 { margin: 12px 7px 0px 0px;}\n    .nav-icon { right: 0px;}\n\n    .text_english {font-size:9px; }\n    .text_bengali {font-size:7px !important;}\n    .title2 h4{padding: 8px 0px 5px 30px;}\n    .whats-new{ padding: 0px 0px 0px 0px;}\n\n    .policy-img2{ height: 58px;}\n    .policy-img2 span{font-size: 8px;}\n    .policy-img2 h4 {line-height: 5px;}\n\n    .navbar-fixed{display: none;}\n \n    /* .about .about-img img {width: 100%; height: auto;}\n    .about .about-img {margin:0px 0 0 0px; width: 100%;} */\n    .NavBar_container{display: block;   }\n    .help a img { width: 80px; top: -89px; height: 84px; }\n    .nav-menu.active{ width: 79%;}\n\n    .carousel-caption {bottom: 60px !important; top:45% !important;\n     padding-bottom: 0px !important; left: 8% !important;}\n     .search-div{display: none;}\n     .navbar-fixed2{display: none;}\n     .login-1 {margin: -7px 120px 0px 0px !important;}\n\n    /* ======= Mega menu =========*/\n    .header2 { z-index: 111; position: relative; padding: 0px; }\n    .megamenu1 {padding: 0px; }\n    .megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n    .megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n    .megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n    .megamenu1 .navbar{padding: 0px;}\n    /* ======= Mega menu =========*/\n\n     .Banner {margin-top:-39px !important; height:196px !important;}\n     .Banner .carousel-item { width:100% !important; height:130px !important; top:98px; margin-right: inherit !important; }\n     .Banner .carousel-item img{height:99px !important; width:100% !important;}\n     .banner-container{height:210px !important;}\n\n     .hero2{ height: 185px !important;}\n    .hero .carousel-item { width:100% !important; height:110px !important; top:29px; \n        margin-right: inherit !important; }\n    .hero2 .carousel-item img{height:80px !important; width:100% !important;}\n\n     .site-menu nav ul li a{ font-size: 13px !important;}\n     .mayor-table{margin: 0px 0px 20px 0px;}\n     .funct1{margin: 0px 0px 20px 0px;}\n    body{padding-top:0px;}\n\n    .login-1 { margin: -7px 0px 0px 0px !important;}\n    .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}\n\n}\n\n@media (max-width:580px) {\n    .login-1 { margin: -7px 120px 0px 0px;  }\n\n    .hero2{ height: 185px !important;}\n    .hero .carousel-item { width:100% !important; height:110px !important; top:29px; \n        margin-right: inherit !important; }\n    .hero2 .carousel-item img{height:80px !important; width:100% !important;}\n    \n    .site-menu nav ul li a{ font-size: 13px !important;}\n    .title2 h4{font-size: 12px; padding:10px 0px !important;}\n    .mayor-table{margin: 0px 0px 20px 0px;}\n    .funct1{margin: 0px 0px 20px 0px;}\n    .width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}\n\n    .login-1  { margin: -7px 0px 0px 0px !important;}\n\n    .inner-title2 h3 {font-size: 15px; font-weight: 600;}\n    .mayor-table2 .table .table-bordered td {font-size: 12px;}\n\n    .map2 a{width: 100% !important;}\n    .whats-app h1{font-size: 11px;}\n    .whats-app {margin: 25px 0px 20px 0px;}\n}\n\n@media screen and (max-width:480px) {\n    .header1 {padding: 5px 0px 2px 0px;}\n\n    .head-part1 .lang-set { margin: -62px 0px 0px 0px;}\n    .swap-div{display:flex; flex-direction: column-reverse; }\n    .section-title.mes-title h4{font-size: 20px !important;}\n    .inner-title2 h3,\n    .inner-title h3 { padding: 10px 0px 10px 0px; font-size: 17px; }\n    .font-site{display: none;  }\n    .nav-icon {  right:0px;} \n\n/*=====Banner=======*/\n    .Banner {margin-top:-29px !important; height:117px !important;}\n    .Banner .carousel-item { width:100% !important; height:60px !important; top: 57px; \n    margin-right: inherit !important; }\n    .Banner .carousel-item img{height:60px !important; width:100% !important;}\n    .banner-container{height:124px !important; margin-top: 0px;}\n/*====Banner========*/   \n.social-media {display: none;}\n    .hero .carousel-item { width:100% !important; height:110px !important; top: 58px; \n        margin-right: inherit !important; }\n    .hero2 .carousel-item img{height:80px !important; width:100% !important;}  \n    .title2 h4{font-size: 12px; padding:10px 0px !important;}\n    .mayor-table{margin: 0px 0px 20px 0px;}\n    .col-lg-4.col-md-4.col-sm-6.lg.aos-init.aos-animate.d-flex {flex: 70% 1;max-width: 70% !important;}\n    .col-lg-5.col-md-5.col-sm-6{flex: 30% 1;max-width: 30%;}\n    .text_english {font-size: 13px; padding: 10px !important; }\n    .about{padding-bottom: 10px;}\n    .hero2 { height: unset !important; }\n    .whats-new { width: 93%; margin-left: auto; margin-right: auto;}\n    .col-lg-5.col-md-5.col-sm-6.about{flex: 100% 1;max-width: 100%;}\n    .faq{ padding: 0px 0px;}  \n    .certificate1{ padding: 7px 13px; }\n    body{ padding-top: 70px;}  \n   .navbar-fixed2,.navbar-fixed{ display: none;}\n   .NavBar_container{ display: block; }\n   .help a img { top: 230px; right: 8px; }\n   .language-mbl,.font-site-mbl{ display: block; margin-left: 31px; }\n   .site-menu nav ul li .dropdown .btn { font-size: 11px !important; }\n \n   .show_responsive,\n   .responsive_menu{display: block;}\n   ul.dropdown-menu.multi-level.min-height-400.show {height: 300px; overflow: scroll; z-index: 1 !important; }\n.responsive_menu .card-body ul li a{font-weight: 500 !important; font-size: 13px !important;\n    color: #302ba0 !important; border-bottom: 1px solid #E5E9EF !important; list-style: disc;\n    display: inherit; list-style-position: inside;}\n.show_responsive .dropdown-submenu>a:after{content:none !important;}\n.mobile_menu_dropdown{overflow: visible;} \nbutton.btn.btn-link fontSizeClass .collapsed, .btn-link fontSizeClass :hover { padding: 10px; }\n#accordion .card-body {padding: 0px 10px;}\n#accordion .card-body ul{ padding: 0px 12px; font-size: 13px;}\n#accordion .card-body ul li{    line-height: 22px;font-size: 13px;font-weight: 400;}\n.dig-form {width: 94%;margin: 10px;}\n.dig-login1 { width: 100%; margin: 0px; padding: 10px;}\n.form-group.continu{display: flex;}\n.dig-login1 .log-form .continu a {padding: 7px 16px;}\n.inner-title3 h3 {padding: 0px; font-size: 13px;}\n.about-head1 h5 { padding: 4px 10px; font-size: 11px; line-height: 18px; margin: 6px 0px 0px 0px;    }\n.funct1 { margin: 20px 0;}\n.footer .footer-content{padding: 20px 0px;}\n.menu-slider .menu-slide-track {animation: scroll 8s linear infinite;}\n.header-office_name{ display: flex; flex-direction: column; justify-content: center;}   \n.mbl-login{ display: block;}\n.login-1 {display: block !important; margin: -50px 0px 0px 140px !important; position: absolute;}\n.carousel-indicators{bottom: 3px !important;}\n.carousel-caption{ display: block !important;}\n.carousel-caption.d-none.d-md-block h5 { font-size: 19px; }\n.header-office_name p{margin: 0px ; }\n.text_english{ font-size: 8px !important; }\n.text_bengali{ font-size: 14px !important;  }\n\n.mayar{right:57%; top: 0%;}\n.logo span { color: #fff;}\n.header .logo img { max-height: initial; width: 40px;}\n.help a img { width: 60px;height: 60px;top: -63px;right: 10px;}\n.search {margin: 20px 0px 0px 0px; width: 100%;}\n.search .input-group { width: 100%;}\n.fixed-top {position: inherit;}\n.language {margin: 0px 20px 0px 0px;}\n.font-site {margin: 8px 45px 0px 0px;}\n.mobile-nav-toggle { background: rgba(var(--color-secondary-rgb), 0.9); color: #fff; \n    font-size: 33px; top: 14px; right: 7px;}\n\n/* ======= Mega menu =========*/\n.header2 { z-index: 111; position: relative; padding: 0px; }\n.megamenu1 {padding: 0px; }\n.megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n.megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n.megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);}\n.megamenu1 .navbar{padding: 0px;}\n\n/* ======= Mega menu =========*/\n\n.head-part1 { margin: 5px 0px 0px 0px;}\n.about-img3{ padding: 9px 0px !important;}\n.alert { display: none !important;}\n.swiper {margin: 0px 0px 0px 10px;}\n.service-item .img img { height: 80px;}\n.hero { margin-top:-30px; min-height: unset;}\n.section-main-heading2 { bottom: 0px;}\n.site-menu nav ul li a { font-size: 11px !important;}\n.faq .accordion-button { font-size: 10px;}\n.faq .content h3 { font-size: 22px; padding: 10px 0px;}\n.service-item { margin: 0px 0px 0px 0px;}\n.about .about-img {margin:20px 0px 0px 0px;}\n.mayar img { width:41px;}\n.section-main-heading p span {font-size: 16px;}\n.section-main-heading { margin: 0px 0px 20px 0px;}\n.services .details .icon {margin: 0px 0px 0px 8px;}\n.none-320 { display: none;}\n.display-320 { display: block;}\n.width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}\n\nsection { padding: 0px;}\n.mayor-table table { margin: 0px 15px 0px 15px;}\n.m-ta-2 table { margin: 0px 0px 0px 0px;}\n.mayor-table { overflow-x: scroll;}\n.mayor-table-column{padding: 6px !important;}\n.inner-title3{ margin-top: 20px;}\n.mayor{margin-top: 20px;}\n.mayor-table2a .row{ justify-content: center;}\n.menu-slider { margin: 0;}\n.list-aggregate { padding: 0;}\n.search{ display: none;}\n.carousel-control-next-icon, .carousel-control-prev-icon{ display: none !important;}\n.login-1 .dropdown-toggle,\n.language .dropdown-toggle {padding: 2px 0px;font-size: 12px;width: 50px !important;}\n.search-div{display: none;}\n\n\n.language_dropdown { margin: 9px 6px 0px 0px; font-size: 11px !important; font-weight: normal !important;\n     padding: 0px !important;}\n.mayar img { width: 30px;margin-top: -2px;}\n.nav-icon{ top: -16px;right: -18px;}\n.form-select option{ padding: 8px 10px !important;}\n.responsivemenudiv .dropdown-item:focus{background: none;}\n.responsivemenudiv .nav-link:hover{background: none;}\n\n.inner-title3 { margin-top: 0px; padding: 0px 20px 10px 24px;}\n\n.map2 a{width: 100% !important;}\n.whats-app h1{font-size: 11px;}\n.whats-app {margin: 25px 0px 20px 0px;}\n\n}\n\n\n\n@media screen and (max-width: 320px){\n\nbody{margin: 0px; padding: 0px;}\n\n.header1 {padding: 5px 0px 2px 0px;}\n\n/* ======= Mega menu =========*/\n.header2 { z-index: 1111111; position: relative; padding: 0px; }\n.megamenu1 {padding: 0px; }\n.megamenu1 .navbar-light .navbar-toggler i{color: #fff; font-size: 30px;}\n.megamenu1 .navbar-light .navbar-toggler{padding:0px; border-color: rgba(0,0,0,.0);}\n.megamenu1 .navbar-collapse { padding: 0px 0px 20px 0px; box-shadow: 0px 0 16px rgb(0 0 0 / 10%);\n    height:320px;  overflow-y: scroll; overflow-x: hidden; display: inline-block;\n}\n\n.megamenu1 .navbar{padding: 0px;}\n.megamenu1 .navbar {z-index: 111111;}\n\n/* ======= Mega menu =========*/\n\n.social-media{top: 52%; display: none;}\n.text_bengali{ font-size: 14px !important;}\n.text_english{ font-size: 8px !important;}\n.dig-login1 { margin: 10px 0 10px;}\n.about-head1 h4 { font-size: 12px; line-height: 20px; text-align: justify !important;  }\n.map2 a {width: 100%;}\n.about-img2 p {line-height: 20px;}\n.inner-log-form .col-lg-6.col-md-12.form-group {margin: 20px 10px !important;  }\n.col-lg-12.about-head2{padding: 0;}\n.about-img2 p,\n.col-lg-12.about-head2 p {text-align: justify;}\ntr.table-warning.table-bor-2 th,\ntable.table-bordered tbody tr td { font-size: 11px; }\ntable.table-bordered tbody tr td .nav-item{list-style-type:none ;}\n.depart.Tender_batra {height: 300px; width:100%;overflow: scroll; }\n.form-group.continu .btn-primary { font-size: 11px;padding: 0px 10px; }\n.dig-login1 .log-form .form-group select { width: 100%; }\n.form-group.continu{margin: 0px !important;}\n.dig-login1 .log-form h3 { font-size: 14px;}\n.dig-form .subheader { display: none !important; }\n.section-main-heading2 { bottom: 12px; }\n.col-lg-12 .about-head1, .dig-login1.dig-form, .about-head1, .col-lg-12.about-head2{margin-bottom: 20px;}\n.inner-title h3,\n.inner-title2 h3 {font-size: 15px; font-weight: 600;}\n\n\n.search-div{display: none;}\n.scrool-message{width: 100%; }\n.section-main-heading p.main-heading-title { margin: 0;padding: 0px 0 0px;}\n.responsive_menu .aos-init .aos-animate .aos-init.aos-animate {  border: 0;  margin-top: 0;}\n.text_english {font-size: 8px !important; }\n.mayar { right: 57%; top: 0%;}\n.width-30{max-width: 100% !important; width: 100% !important; padding: 0px; font-size: 12px;}\n\n.Banner {margin-top:39px !important; height:108px !important;}\n.Banner .carousel-item { width:100% !important; height:52px !important; top: 58px; \n margin-right: inherit !important; }\n .Banner .carousel-item img{height:52px !important; width:100% !important;}\n.banner-container{height:118px !important; margin-top: 0px;}\n\n.hero .carousel-item { width:100% !important; height:110px !important; top: 58px; \n    margin-right: inherit !important; }\n.hero2 .carousel-item img{height:80px !important; width:100% !important;}\n\n.title2 h4{font-size: 12px; padding:10px 0px !important;}\n.mayor-table{margin: 0px 0px 20px 0px;}\n\n.funct1{margin: 0px 0px;}\n\n.mayar img { width: 30px;margin-top: -2px;}\n.nav-icon{ top: -16px;right: -18px;}\n.form-select option{ padding: 8px 10px !important;}\n.responsivemenudiv .dropdown-item:focus{background: none;}\n.responsivemenudiv .nav-link:hover{background: none;}\n.help a img { width:45px;  position: absolute; right:6px; top:-47px; bottom:1px; height:48px;}\n\n.language_dropdown { margin: 9px 6px 0px 0px; font-size: 11px !important; font-weight: normal !important;\n     padding: 0px !important;}\n.head-part1 .lang-set{ margin: -62px -20px 0px 0px !important;}\n.hero.hero2{margin-top: 40px;}\n\n.map2 a{width: 100% !important;}\n.whats-app h1{font-size: 11px;}\n.whats-app {margin: 85px 0px 20px 0px;}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
